import {
  Logger,
  init_logger
} from "./chunk-CGQJYOWJ.mjs";
import {
  ShaderStore,
  init_shaderStore
} from "./chunk-74QERPGX.mjs";
import {
  EngineStore,
  GetClass,
  Observable,
  PerformanceConfigurator,
  init_engineStore,
  init_observable,
  init_performanceConfigurator,
  init_typeStore
} from "./chunk-PMCXIDBB.mjs";
import {
  __async,
  __esm,
  __spreadValues
} from "./chunk-AU4RG7EN.mjs";

// node_modules/@babylonjs/core/Misc/domManagement.js
function IsWindowObjectExist() {
  return typeof window !== "undefined";
}
function IsNavigatorAvailable() {
  return typeof navigator !== "undefined";
}
function IsDocumentAvailable() {
  return typeof document !== "undefined";
}
function GetDOMTextContent(element) {
  let result = "";
  let child = element.firstChild;
  while (child) {
    if (child.nodeType === 3) {
      result += child.textContent;
    }
    child = child.nextSibling;
  }
  return result;
}
var DomManagement;
var init_domManagement = __esm({
  "node_modules/@babylonjs/core/Misc/domManagement.js"() {
    "use strict";
    DomManagement = {
      /**
       * Checks if the window object exists
       * @returns true if the window object exists
       */
      IsWindowObjectExist,
      /**
       * Checks if the navigator object exists
       * @returns true if the navigator object exists
       */
      IsNavigatorAvailable,
      /**
       * Check if the document object exists
       * @returns true if the document object exists
       */
      IsDocumentAvailable,
      /**
       * Extracts text content from a DOM element hierarchy
       * @param element defines the root element
       * @returns a string
       */
      GetDOMTextContent
    };
  }
});

// node_modules/@babylonjs/core/Engines/WebGL/webGLPipelineContext.js
var WebGLPipelineContext;
var init_webGLPipelineContext = __esm({
  "node_modules/@babylonjs/core/Engines/WebGL/webGLPipelineContext.js"() {
    "use strict";
    WebGLPipelineContext = class {
      constructor() {
        this._valueCache = {};
        this.vertexCompilationError = null;
        this.fragmentCompilationError = null;
        this.programLinkError = null;
        this.programValidationError = null;
        this._isDisposed = false;
      }
      get isAsync() {
        return this.isParallelCompiled;
      }
      get isReady() {
        if (this.program) {
          if (this.isParallelCompiled) {
            return this.engine._isRenderingStateCompiled(this);
          }
          return true;
        }
        return false;
      }
      _handlesSpectorRebuildCallback(onCompiled) {
        if (onCompiled && this.program) {
          onCompiled(this.program);
        }
      }
      setEngine(engine) {
        this.engine = engine;
      }
      _fillEffectInformation(effect, uniformBuffersNames, uniformsNames, uniforms, samplerList, samplers, attributesNames, attributes) {
        const engine = this.engine;
        if (engine.supportsUniformBuffers) {
          for (const name2 in uniformBuffersNames) {
            effect.bindUniformBlock(name2, uniformBuffersNames[name2]);
          }
        }
        const effectAvailableUniforms = this.engine.getUniforms(this, uniformsNames);
        effectAvailableUniforms.forEach((uniform, index2) => {
          uniforms[uniformsNames[index2]] = uniform;
        });
        this._uniforms = uniforms;
        let index;
        for (index = 0; index < samplerList.length; index++) {
          const sampler = effect.getUniform(samplerList[index]);
          if (sampler == null) {
            samplerList.splice(index, 1);
            index--;
          }
        }
        samplerList.forEach((name2, index2) => {
          samplers[name2] = index2;
        });
        for (const attr of engine.getAttributes(this, attributesNames)) {
          attributes.push(attr);
        }
      }
      /**
       * Release all associated resources.
       **/
      dispose() {
        this._uniforms = {};
        this._isDisposed = true;
      }
      /**
       * @internal
       */
      _cacheMatrix(uniformName, matrix) {
        const cache = this._valueCache[uniformName];
        const flag = matrix.updateFlag;
        if (cache !== void 0 && cache === flag) {
          return false;
        }
        this._valueCache[uniformName] = flag;
        return true;
      }
      /**
       * @internal
       */
      _cacheFloat2(uniformName, x, y) {
        let cache = this._valueCache[uniformName];
        if (!cache || cache.length !== 2) {
          cache = [x, y];
          this._valueCache[uniformName] = cache;
          return true;
        }
        let changed = false;
        if (cache[0] !== x) {
          cache[0] = x;
          changed = true;
        }
        if (cache[1] !== y) {
          cache[1] = y;
          changed = true;
        }
        return changed;
      }
      /**
       * @internal
       */
      _cacheFloat3(uniformName, x, y, z) {
        let cache = this._valueCache[uniformName];
        if (!cache || cache.length !== 3) {
          cache = [x, y, z];
          this._valueCache[uniformName] = cache;
          return true;
        }
        let changed = false;
        if (cache[0] !== x) {
          cache[0] = x;
          changed = true;
        }
        if (cache[1] !== y) {
          cache[1] = y;
          changed = true;
        }
        if (cache[2] !== z) {
          cache[2] = z;
          changed = true;
        }
        return changed;
      }
      /**
       * @internal
       */
      _cacheFloat4(uniformName, x, y, z, w) {
        let cache = this._valueCache[uniformName];
        if (!cache || cache.length !== 4) {
          cache = [x, y, z, w];
          this._valueCache[uniformName] = cache;
          return true;
        }
        let changed = false;
        if (cache[0] !== x) {
          cache[0] = x;
          changed = true;
        }
        if (cache[1] !== y) {
          cache[1] = y;
          changed = true;
        }
        if (cache[2] !== z) {
          cache[2] = z;
          changed = true;
        }
        if (cache[3] !== w) {
          cache[3] = w;
          changed = true;
        }
        return changed;
      }
      /**
       * Sets an integer value on a uniform variable.
       * @param uniformName Name of the variable.
       * @param value Value to be set.
       */
      setInt(uniformName, value) {
        const cache = this._valueCache[uniformName];
        if (cache !== void 0 && cache === value) {
          return;
        }
        if (this.engine.setInt(this._uniforms[uniformName], value)) {
          this._valueCache[uniformName] = value;
        }
      }
      /**
       * Sets a int2 on a uniform variable.
       * @param uniformName Name of the variable.
       * @param x First int in int2.
       * @param y Second int in int2.
       */
      setInt2(uniformName, x, y) {
        if (this._cacheFloat2(uniformName, x, y)) {
          if (!this.engine.setInt2(this._uniforms[uniformName], x, y)) {
            this._valueCache[uniformName] = null;
          }
        }
      }
      /**
       * Sets a int3 on a uniform variable.
       * @param uniformName Name of the variable.
       * @param x First int in int3.
       * @param y Second int in int3.
       * @param z Third int in int3.
       */
      setInt3(uniformName, x, y, z) {
        if (this._cacheFloat3(uniformName, x, y, z)) {
          if (!this.engine.setInt3(this._uniforms[uniformName], x, y, z)) {
            this._valueCache[uniformName] = null;
          }
        }
      }
      /**
       * Sets a int4 on a uniform variable.
       * @param uniformName Name of the variable.
       * @param x First int in int4.
       * @param y Second int in int4.
       * @param z Third int in int4.
       * @param w Fourth int in int4.
       */
      setInt4(uniformName, x, y, z, w) {
        if (this._cacheFloat4(uniformName, x, y, z, w)) {
          if (!this.engine.setInt4(this._uniforms[uniformName], x, y, z, w)) {
            this._valueCache[uniformName] = null;
          }
        }
      }
      /**
       * Sets an int array on a uniform variable.
       * @param uniformName Name of the variable.
       * @param array array to be set.
       */
      setIntArray(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setIntArray(this._uniforms[uniformName], array);
      }
      /**
       * Sets an int array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
       * @param uniformName Name of the variable.
       * @param array array to be set.
       */
      setIntArray2(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setIntArray2(this._uniforms[uniformName], array);
      }
      /**
       * Sets an int array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
       * @param uniformName Name of the variable.
       * @param array array to be set.
       */
      setIntArray3(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setIntArray3(this._uniforms[uniformName], array);
      }
      /**
       * Sets an int array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
       * @param uniformName Name of the variable.
       * @param array array to be set.
       */
      setIntArray4(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setIntArray4(this._uniforms[uniformName], array);
      }
      /**
       * Sets an unsigned integer value on a uniform variable.
       * @param uniformName Name of the variable.
       * @param value Value to be set.
       */
      setUInt(uniformName, value) {
        const cache = this._valueCache[uniformName];
        if (cache !== void 0 && cache === value) {
          return;
        }
        if (this.engine.setUInt(this._uniforms[uniformName], value)) {
          this._valueCache[uniformName] = value;
        }
      }
      /**
       * Sets an unsigned int2 value on a uniform variable.
       * @param uniformName Name of the variable.
       * @param x First unsigned int in uint2.
       * @param y Second unsigned int in uint2.
       */
      setUInt2(uniformName, x, y) {
        if (this._cacheFloat2(uniformName, x, y)) {
          if (!this.engine.setUInt2(this._uniforms[uniformName], x, y)) {
            this._valueCache[uniformName] = null;
          }
        }
      }
      /**
       * Sets an unsigned int3 value on a uniform variable.
       * @param uniformName Name of the variable.
       * @param x First unsigned int in uint3.
       * @param y Second unsigned int in uint3.
       * @param z Third unsigned int in uint3.
       */
      setUInt3(uniformName, x, y, z) {
        if (this._cacheFloat3(uniformName, x, y, z)) {
          if (!this.engine.setUInt3(this._uniforms[uniformName], x, y, z)) {
            this._valueCache[uniformName] = null;
          }
        }
      }
      /**
       * Sets an unsigned int4 value on a uniform variable.
       * @param uniformName Name of the variable.
       * @param x First unsigned int in uint4.
       * @param y Second unsigned int in uint4.
       * @param z Third unsigned int in uint4.
       * @param w Fourth unsigned int in uint4.
       */
      setUInt4(uniformName, x, y, z, w) {
        if (this._cacheFloat4(uniformName, x, y, z, w)) {
          if (!this.engine.setUInt4(this._uniforms[uniformName], x, y, z, w)) {
            this._valueCache[uniformName] = null;
          }
        }
      }
      /**
       * Sets an unsigned int array on a uniform variable.
       * @param uniformName Name of the variable.
       * @param array array to be set.
       */
      setUIntArray(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setUIntArray(this._uniforms[uniformName], array);
      }
      /**
       * Sets an unsigned int array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
       * @param uniformName Name of the variable.
       * @param array array to be set.
       */
      setUIntArray2(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setUIntArray2(this._uniforms[uniformName], array);
      }
      /**
       * Sets an unsigned int array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
       * @param uniformName Name of the variable.
       * @param array array to be set.
       */
      setUIntArray3(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setUIntArray3(this._uniforms[uniformName], array);
      }
      /**
       * Sets an unsigned int array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
       * @param uniformName Name of the variable.
       * @param array array to be set.
       */
      setUIntArray4(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setUIntArray4(this._uniforms[uniformName], array);
      }
      /**
       * Sets an array on a uniform variable.
       * @param uniformName Name of the variable.
       * @param array array to be set.
       */
      setArray(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setArray(this._uniforms[uniformName], array);
      }
      /**
       * Sets an array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
       * @param uniformName Name of the variable.
       * @param array array to be set.
       */
      setArray2(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setArray2(this._uniforms[uniformName], array);
      }
      /**
       * Sets an array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
       * @param uniformName Name of the variable.
       * @param array array to be set.
       */
      setArray3(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setArray3(this._uniforms[uniformName], array);
      }
      /**
       * Sets an array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
       * @param uniformName Name of the variable.
       * @param array array to be set.
       */
      setArray4(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setArray4(this._uniforms[uniformName], array);
      }
      /**
       * Sets matrices on a uniform variable.
       * @param uniformName Name of the variable.
       * @param matrices matrices to be set.
       */
      setMatrices(uniformName, matrices) {
        if (!matrices) {
          return;
        }
        this._valueCache[uniformName] = null;
        this.engine.setMatrices(this._uniforms[uniformName], matrices);
      }
      /**
       * Sets matrix on a uniform variable.
       * @param uniformName Name of the variable.
       * @param matrix matrix to be set.
       */
      setMatrix(uniformName, matrix) {
        if (this._cacheMatrix(uniformName, matrix)) {
          if (!this.engine.setMatrices(this._uniforms[uniformName], matrix.asArray())) {
            this._valueCache[uniformName] = null;
          }
        }
      }
      /**
       * Sets a 3x3 matrix on a uniform variable. (Specified as [1,2,3,4,5,6,7,8,9] will result in [1,2,3][4,5,6][7,8,9] matrix)
       * @param uniformName Name of the variable.
       * @param matrix matrix to be set.
       */
      setMatrix3x3(uniformName, matrix) {
        this._valueCache[uniformName] = null;
        this.engine.setMatrix3x3(this._uniforms[uniformName], matrix);
      }
      /**
       * Sets a 2x2 matrix on a uniform variable. (Specified as [1,2,3,4] will result in [1,2][3,4] matrix)
       * @param uniformName Name of the variable.
       * @param matrix matrix to be set.
       */
      setMatrix2x2(uniformName, matrix) {
        this._valueCache[uniformName] = null;
        this.engine.setMatrix2x2(this._uniforms[uniformName], matrix);
      }
      /**
       * Sets a float on a uniform variable.
       * @param uniformName Name of the variable.
       * @param value value to be set.
       */
      setFloat(uniformName, value) {
        const cache = this._valueCache[uniformName];
        if (cache !== void 0 && cache === value) {
          return;
        }
        if (this.engine.setFloat(this._uniforms[uniformName], value)) {
          this._valueCache[uniformName] = value;
        }
      }
      /**
       * Sets a Vector2 on a uniform variable.
       * @param uniformName Name of the variable.
       * @param vector2 vector2 to be set.
       */
      setVector2(uniformName, vector2) {
        if (this._cacheFloat2(uniformName, vector2.x, vector2.y)) {
          if (!this.engine.setFloat2(this._uniforms[uniformName], vector2.x, vector2.y)) {
            this._valueCache[uniformName] = null;
          }
        }
      }
      /**
       * Sets a float2 on a uniform variable.
       * @param uniformName Name of the variable.
       * @param x First float in float2.
       * @param y Second float in float2.
       */
      setFloat2(uniformName, x, y) {
        if (this._cacheFloat2(uniformName, x, y)) {
          if (!this.engine.setFloat2(this._uniforms[uniformName], x, y)) {
            this._valueCache[uniformName] = null;
          }
        }
      }
      /**
       * Sets a Vector3 on a uniform variable.
       * @param uniformName Name of the variable.
       * @param vector3 Value to be set.
       */
      setVector3(uniformName, vector3) {
        if (this._cacheFloat3(uniformName, vector3.x, vector3.y, vector3.z)) {
          if (!this.engine.setFloat3(this._uniforms[uniformName], vector3.x, vector3.y, vector3.z)) {
            this._valueCache[uniformName] = null;
          }
        }
      }
      /**
       * Sets a float3 on a uniform variable.
       * @param uniformName Name of the variable.
       * @param x First float in float3.
       * @param y Second float in float3.
       * @param z Third float in float3.
       */
      setFloat3(uniformName, x, y, z) {
        if (this._cacheFloat3(uniformName, x, y, z)) {
          if (!this.engine.setFloat3(this._uniforms[uniformName], x, y, z)) {
            this._valueCache[uniformName] = null;
          }
        }
      }
      /**
       * Sets a Vector4 on a uniform variable.
       * @param uniformName Name of the variable.
       * @param vector4 Value to be set.
       */
      setVector4(uniformName, vector4) {
        if (this._cacheFloat4(uniformName, vector4.x, vector4.y, vector4.z, vector4.w)) {
          if (!this.engine.setFloat4(this._uniforms[uniformName], vector4.x, vector4.y, vector4.z, vector4.w)) {
            this._valueCache[uniformName] = null;
          }
        }
      }
      /**
       * Sets a Quaternion on a uniform variable.
       * @param uniformName Name of the variable.
       * @param quaternion Value to be set.
       */
      setQuaternion(uniformName, quaternion) {
        if (this._cacheFloat4(uniformName, quaternion.x, quaternion.y, quaternion.z, quaternion.w)) {
          if (!this.engine.setFloat4(this._uniforms[uniformName], quaternion.x, quaternion.y, quaternion.z, quaternion.w)) {
            this._valueCache[uniformName] = null;
          }
        }
      }
      /**
       * Sets a float4 on a uniform variable.
       * @param uniformName Name of the variable.
       * @param x First float in float4.
       * @param y Second float in float4.
       * @param z Third float in float4.
       * @param w Fourth float in float4.
       */
      setFloat4(uniformName, x, y, z, w) {
        if (this._cacheFloat4(uniformName, x, y, z, w)) {
          if (!this.engine.setFloat4(this._uniforms[uniformName], x, y, z, w)) {
            this._valueCache[uniformName] = null;
          }
        }
      }
      /**
       * Sets a Color3 on a uniform variable.
       * @param uniformName Name of the variable.
       * @param color3 Value to be set.
       */
      setColor3(uniformName, color3) {
        if (this._cacheFloat3(uniformName, color3.r, color3.g, color3.b)) {
          if (!this.engine.setFloat3(this._uniforms[uniformName], color3.r, color3.g, color3.b)) {
            this._valueCache[uniformName] = null;
          }
        }
      }
      /**
       * Sets a Color4 on a uniform variable.
       * @param uniformName Name of the variable.
       * @param color3 Value to be set.
       * @param alpha Alpha value to be set.
       */
      setColor4(uniformName, color3, alpha) {
        if (this._cacheFloat4(uniformName, color3.r, color3.g, color3.b, alpha)) {
          if (!this.engine.setFloat4(this._uniforms[uniformName], color3.r, color3.g, color3.b, alpha)) {
            this._valueCache[uniformName] = null;
          }
        }
      }
      /**
       * Sets a Color4 on a uniform variable
       * @param uniformName defines the name of the variable
       * @param color4 defines the value to be set
       */
      setDirectColor4(uniformName, color4) {
        if (this._cacheFloat4(uniformName, color4.r, color4.g, color4.b, color4.a)) {
          if (!this.engine.setFloat4(this._uniforms[uniformName], color4.r, color4.g, color4.b, color4.a)) {
            this._valueCache[uniformName] = null;
          }
        }
      }
      _getVertexShaderCode() {
        return this.vertexShader ? this.engine._getShaderSource(this.vertexShader) : null;
      }
      _getFragmentShaderCode() {
        return this.fragmentShader ? this.engine._getShaderSource(this.fragmentShader) : null;
      }
    };
  }
});

// node_modules/@babylonjs/core/Misc/devTools.js
function _WarnImport(name2, warnOnce = false) {
  if (warnOnce && warnedMap[name2]) {
    return;
  }
  warnedMap[name2] = true;
  return `${name2} needs to be imported before as it contains a side-effect required by your code.`;
}
var warnedMap;
var init_devTools = __esm({
  "node_modules/@babylonjs/core/Misc/devTools.js"() {
    "use strict";
    warnedMap = {};
  }
});

// node_modules/@babylonjs/core/Engines/abstractEngine.functions.js
function _ConcatenateShader(source, defines, shaderVersion = "") {
  return shaderVersion + (defines ? defines + "\n" : "") + source;
}
function _loadFile(url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError, injectedLoadFile) {
  const loadFile = injectedLoadFile || EngineFunctionContext.loadFile;
  if (loadFile) {
    const request = loadFile(url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError);
    return request;
  }
  throw _WarnImport("FileTools");
}
function _getGlobalDefines(defines, isNDCHalfZRange, useReverseDepthBuffer, useExactSrgbConversions) {
  if (defines) {
    if (isNDCHalfZRange) {
      defines["IS_NDC_HALF_ZRANGE"] = "";
    } else {
      delete defines["IS_NDC_HALF_ZRANGE"];
    }
    if (useReverseDepthBuffer) {
      defines["USE_REVERSE_DEPTHBUFFER"] = "";
    } else {
      delete defines["USE_REVERSE_DEPTHBUFFER"];
    }
    if (useExactSrgbConversions) {
      defines["USE_EXACT_SRGB_CONVERSIONS"] = "";
    } else {
      delete defines["USE_EXACT_SRGB_CONVERSIONS"];
    }
    return;
  } else {
    let s = "";
    if (isNDCHalfZRange) {
      s += "#define IS_NDC_HALF_ZRANGE";
    }
    if (useReverseDepthBuffer) {
      if (s) {
        s += "\n";
      }
      s += "#define USE_REVERSE_DEPTHBUFFER";
    }
    if (useExactSrgbConversions) {
      if (s) {
        s += "\n";
      }
      s += "#define USE_EXACT_SRGB_CONVERSIONS";
    }
    return s;
  }
}
var EngineFunctionContext;
var init_abstractEngine_functions = __esm({
  "node_modules/@babylonjs/core/Engines/abstractEngine.functions.js"() {
    "use strict";
    init_devTools();
    init_domManagement();
    EngineFunctionContext = {};
  }
});

// node_modules/@babylonjs/core/Engines/thinEngine.functions.js
function getStateObject(context) {
  let state = _stateObject.get(context);
  if (!state) {
    if (!context) {
      return singleStateObject;
    }
    state = {
      // use feature detection. instanceof returns false. This only exists on WebGL2 context
      _webGLVersion: context.TEXTURE_BINDING_3D ? 2 : 1,
      _context: context,
      cachedPipelines: {}
    };
    _stateObject.set(context, state);
  }
  return state;
}
function deleteStateObject(context) {
  _stateObject.delete(context);
}
function createRawShaderProgram(pipelineContext, vertexCode, fragmentCode, context, transformFeedbackVaryings, _createShaderProgramInjection) {
  var _a;
  const stateObject = getStateObject(context);
  if (!_createShaderProgramInjection) {
    _createShaderProgramInjection = (_a = stateObject._createShaderProgramInjection) != null ? _a : _createShaderProgram;
  }
  const vertexShader = _compileRawShader(vertexCode, "vertex", context, stateObject._contextWasLost);
  const fragmentShader = _compileRawShader(fragmentCode, "fragment", context, stateObject._contextWasLost);
  return _createShaderProgramInjection(pipelineContext, vertexShader, fragmentShader, context, transformFeedbackVaryings, stateObject.validateShaderPrograms);
}
function createShaderProgram(pipelineContext, vertexCode, fragmentCode, defines, context, transformFeedbackVaryings = null, _createShaderProgramInjection) {
  var _a;
  const stateObject = getStateObject(context);
  if (!_createShaderProgramInjection) {
    _createShaderProgramInjection = (_a = stateObject._createShaderProgramInjection) != null ? _a : _createShaderProgram;
  }
  const shaderVersion = stateObject._webGLVersion > 1 ? "#version 300 es\n#define WEBGL2 \n" : "";
  const vertexShader = _compileShader(vertexCode, "vertex", defines, shaderVersion, context, stateObject._contextWasLost);
  const fragmentShader = _compileShader(fragmentCode, "fragment", defines, shaderVersion, context, stateObject._contextWasLost);
  return _createShaderProgramInjection(pipelineContext, vertexShader, fragmentShader, context, transformFeedbackVaryings, stateObject.validateShaderPrograms);
}
function createPipelineContext(context, _shaderProcessingContext) {
  const pipelineContext = new WebGLPipelineContext();
  const stateObject = getStateObject(context);
  if (stateObject.parallelShaderCompile) {
    pipelineContext.isParallelCompiled = true;
  }
  pipelineContext.context = stateObject._context;
  return pipelineContext;
}
function _createShaderProgram(pipelineContext, vertexShader, fragmentShader, context, _transformFeedbackVaryings = null, validateShaderPrograms) {
  const shaderProgram = context.createProgram();
  pipelineContext.program = shaderProgram;
  if (!shaderProgram) {
    throw new Error("Unable to create program");
  }
  context.attachShader(shaderProgram, vertexShader);
  context.attachShader(shaderProgram, fragmentShader);
  context.linkProgram(shaderProgram);
  pipelineContext.context = context;
  pipelineContext.vertexShader = vertexShader;
  pipelineContext.fragmentShader = fragmentShader;
  if (!pipelineContext.isParallelCompiled) {
    _finalizePipelineContext(pipelineContext, context, validateShaderPrograms);
  }
  return shaderProgram;
}
function _finalizePipelineContext(pipelineContext, gl, validateShaderPrograms) {
  const context = pipelineContext.context;
  const vertexShader = pipelineContext.vertexShader;
  const fragmentShader = pipelineContext.fragmentShader;
  const program = pipelineContext.program;
  const linked = context.getProgramParameter(program, context.LINK_STATUS);
  if (!linked) {
    if (!gl.getShaderParameter(vertexShader, gl.COMPILE_STATUS)) {
      const log = gl.getShaderInfoLog(vertexShader);
      if (log) {
        pipelineContext.vertexCompilationError = log;
        throw new Error("VERTEX SHADER " + log);
      }
    }
    if (!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS)) {
      const log = gl.getShaderInfoLog(fragmentShader);
      if (log) {
        pipelineContext.fragmentCompilationError = log;
        throw new Error("FRAGMENT SHADER " + log);
      }
    }
    const error = context.getProgramInfoLog(program);
    if (error) {
      pipelineContext.programLinkError = error;
      throw new Error(error);
    }
  }
  if (
    /*this.*/
    validateShaderPrograms
  ) {
    context.validateProgram(program);
    const validated = context.getProgramParameter(program, context.VALIDATE_STATUS);
    if (!validated) {
      const error = context.getProgramInfoLog(program);
      if (error) {
        pipelineContext.programValidationError = error;
        throw new Error(error);
      }
    }
  }
  context.deleteShader(vertexShader);
  context.deleteShader(fragmentShader);
  pipelineContext.vertexShader = void 0;
  pipelineContext.fragmentShader = void 0;
  if (pipelineContext.onCompiled) {
    pipelineContext.onCompiled();
    pipelineContext.onCompiled = void 0;
  }
}
function _preparePipelineContext(pipelineContext, vertexSourceCode, fragmentSourceCode, createAsRaw, _rawVertexSourceCode, _rawFragmentSourceCode, rebuildRebind, defines, transformFeedbackVaryings, _key = "", onReady, createRawShaderProgramInjection, createShaderProgramInjection) {
  var _a, _b;
  const stateObject = getStateObject(pipelineContext.context);
  if (!createRawShaderProgramInjection) {
    createRawShaderProgramInjection = (_a = stateObject.createRawShaderProgramInjection) != null ? _a : createRawShaderProgram;
  }
  if (!createShaderProgramInjection) {
    createShaderProgramInjection = (_b = stateObject.createShaderProgramInjection) != null ? _b : createShaderProgram;
  }
  const webGLRenderingState = pipelineContext;
  if (createAsRaw) {
    webGLRenderingState.program = createRawShaderProgramInjection(webGLRenderingState, vertexSourceCode, fragmentSourceCode, webGLRenderingState.context, transformFeedbackVaryings);
  } else {
    webGLRenderingState.program = createShaderProgramInjection(webGLRenderingState, vertexSourceCode, fragmentSourceCode, defines, webGLRenderingState.context, transformFeedbackVaryings);
  }
  webGLRenderingState.program.__SPECTOR_rebuildProgram = rebuildRebind;
  onReady();
}
function _compileShader(source, type, defines, shaderVersion, gl, _contextWasLost) {
  return _compileRawShader(_ConcatenateShader(source, defines, shaderVersion), type, gl, _contextWasLost);
}
function _compileRawShader(source, type, gl, _contextWasLost) {
  const shader = gl.createShader(type === "vertex" ? gl.VERTEX_SHADER : gl.FRAGMENT_SHADER);
  if (!shader) {
    let error = gl.NO_ERROR;
    let tempError = gl.NO_ERROR;
    while ((tempError = gl.getError()) !== gl.NO_ERROR) {
      error = tempError;
    }
    throw new Error(`Something went wrong while creating a gl ${type} shader object. gl error=${error}, gl isContextLost=${gl.isContextLost()}, _contextWasLost=${_contextWasLost}`);
  }
  gl.shaderSource(shader, source);
  gl.compileShader(shader);
  return shader;
}
function _setProgram(program, gl) {
  gl.useProgram(program);
}
function _executeWhenRenderingStateIsCompiled(pipelineContext, action) {
  const webGLPipelineContext = pipelineContext;
  if (!webGLPipelineContext.isParallelCompiled) {
    action(pipelineContext);
    return;
  }
  const oldHandler = webGLPipelineContext.onCompiled;
  webGLPipelineContext.onCompiled = () => {
    oldHandler == null ? void 0 : oldHandler();
    action(pipelineContext);
  };
}
var _stateObject, singleStateObject;
var init_thinEngine_functions = __esm({
  "node_modules/@babylonjs/core/Engines/thinEngine.functions.js"() {
    "use strict";
    init_webGLPipelineContext();
    init_abstractEngine_functions();
    _stateObject = /* @__PURE__ */ new WeakMap();
    singleStateObject = {
      _webGLVersion: 2,
      cachedPipelines: {}
    };
  }
});

// node_modules/@babylonjs/core/Engines/Processors/shaderCodeNode.js
var defaultAttributeKeywordName, defaultVaryingKeywordName, ShaderCodeNode;
var init_shaderCodeNode = __esm({
  "node_modules/@babylonjs/core/Engines/Processors/shaderCodeNode.js"() {
    "use strict";
    defaultAttributeKeywordName = "attribute";
    defaultVaryingKeywordName = "varying";
    ShaderCodeNode = class {
      constructor() {
        this.children = [];
      }
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      isValid(preprocessors) {
        return true;
      }
      process(preprocessors, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        let result = "";
        if (this.line) {
          let value = this.line;
          const processor = options.processor;
          if (processor) {
            if (processor.lineProcessor) {
              value = processor.lineProcessor(value, options.isFragment, options.processingContext);
            }
            const attributeKeyword = (_b = (_a = options.processor) == null ? void 0 : _a.attributeKeywordName) != null ? _b : defaultAttributeKeywordName;
            const varyingKeyword = options.isFragment && ((_c = options.processor) == null ? void 0 : _c.varyingFragmentKeywordName) ? (_d = options.processor) == null ? void 0 : _d.varyingFragmentKeywordName : !options.isFragment && ((_e = options.processor) == null ? void 0 : _e.varyingVertexKeywordName) ? (_f = options.processor) == null ? void 0 : _f.varyingVertexKeywordName : defaultVaryingKeywordName;
            if (!options.isFragment && processor.attributeProcessor && this.line.startsWith(attributeKeyword)) {
              value = processor.attributeProcessor(this.line, preprocessors, options.processingContext);
            } else if (processor.varyingProcessor && (((_g = processor.varyingCheck) == null ? void 0 : _g.call(processor, this.line, options.isFragment)) || !processor.varyingCheck && this.line.startsWith(varyingKeyword))) {
              value = processor.varyingProcessor(this.line, options.isFragment, preprocessors, options.processingContext);
            } else if (processor.uniformProcessor && processor.uniformRegexp && processor.uniformRegexp.test(this.line)) {
              if (!options.lookForClosingBracketForUniformBuffer) {
                value = processor.uniformProcessor(this.line, options.isFragment, preprocessors, options.processingContext);
              }
            } else if (processor.uniformBufferProcessor && processor.uniformBufferRegexp && processor.uniformBufferRegexp.test(this.line)) {
              if (!options.lookForClosingBracketForUniformBuffer) {
                value = processor.uniformBufferProcessor(this.line, options.isFragment, options.processingContext);
                options.lookForClosingBracketForUniformBuffer = true;
              }
            } else if (processor.textureProcessor && processor.textureRegexp && processor.textureRegexp.test(this.line)) {
              value = processor.textureProcessor(this.line, options.isFragment, preprocessors, options.processingContext);
            } else if ((processor.uniformProcessor || processor.uniformBufferProcessor) && this.line.startsWith("uniform") && !options.lookForClosingBracketForUniformBuffer) {
              const regex = /uniform\s+(?:(?:highp)?|(?:lowp)?)\s*(\S+)\s+(\S+)\s*;/;
              if (regex.test(this.line)) {
                if (processor.uniformProcessor) {
                  value = processor.uniformProcessor(this.line, options.isFragment, preprocessors, options.processingContext);
                }
              } else {
                if (processor.uniformBufferProcessor) {
                  value = processor.uniformBufferProcessor(this.line, options.isFragment, options.processingContext);
                  options.lookForClosingBracketForUniformBuffer = true;
                }
              }
            }
            if (options.lookForClosingBracketForUniformBuffer && this.line.indexOf("}") !== -1) {
              options.lookForClosingBracketForUniformBuffer = false;
              if (processor.endOfUniformBufferProcessor) {
                value = processor.endOfUniformBufferProcessor(this.line, options.isFragment, options.processingContext);
              }
            }
          }
          result += value + "\n";
        }
        this.children.forEach((child) => {
          result += child.process(preprocessors, options);
        });
        if (this.additionalDefineKey) {
          preprocessors[this.additionalDefineKey] = this.additionalDefineValue || "true";
        }
        return result;
      }
    };
  }
});

// node_modules/@babylonjs/core/Engines/Processors/shaderCodeCursor.js
var ShaderCodeCursor;
var init_shaderCodeCursor = __esm({
  "node_modules/@babylonjs/core/Engines/Processors/shaderCodeCursor.js"() {
    "use strict";
    ShaderCodeCursor = class {
      constructor() {
        this._lines = [];
      }
      get currentLine() {
        return this._lines[this.lineIndex];
      }
      get canRead() {
        return this.lineIndex < this._lines.length - 1;
      }
      set lines(value) {
        this._lines.length = 0;
        for (const line of value) {
          if (!line || line === "\r") {
            continue;
          }
          if (line[0] === "#") {
            this._lines.push(line);
            continue;
          }
          const trimmedLine = line.trim();
          if (!trimmedLine) {
            continue;
          }
          if (trimmedLine.startsWith("//")) {
            this._lines.push(line);
            continue;
          }
          const semicolonIndex = trimmedLine.indexOf(";");
          if (semicolonIndex === -1) {
            this._lines.push(trimmedLine);
          } else if (semicolonIndex === trimmedLine.length - 1) {
            if (trimmedLine.length > 1) {
              this._lines.push(trimmedLine);
            }
          } else {
            const split = line.split(";");
            for (let index = 0; index < split.length; index++) {
              let subLine = split[index];
              if (!subLine) {
                continue;
              }
              subLine = subLine.trim();
              if (!subLine) {
                continue;
              }
              this._lines.push(subLine + (index !== split.length - 1 ? ";" : ""));
            }
          }
        }
      }
    };
  }
});

// node_modules/@babylonjs/core/Engines/Processors/shaderCodeConditionNode.js
var ShaderCodeConditionNode;
var init_shaderCodeConditionNode = __esm({
  "node_modules/@babylonjs/core/Engines/Processors/shaderCodeConditionNode.js"() {
    "use strict";
    init_shaderCodeNode();
    ShaderCodeConditionNode = class extends ShaderCodeNode {
      process(preprocessors, options) {
        for (let index = 0; index < this.children.length; index++) {
          const node = this.children[index];
          if (node.isValid(preprocessors)) {
            return node.process(preprocessors, options);
          }
        }
        return "";
      }
    };
  }
});

// node_modules/@babylonjs/core/Engines/Processors/shaderCodeTestNode.js
var ShaderCodeTestNode;
var init_shaderCodeTestNode = __esm({
  "node_modules/@babylonjs/core/Engines/Processors/shaderCodeTestNode.js"() {
    "use strict";
    init_shaderCodeNode();
    ShaderCodeTestNode = class extends ShaderCodeNode {
      isValid(preprocessors) {
        return this.testExpression.isTrue(preprocessors);
      }
    };
  }
});

// node_modules/@babylonjs/core/Engines/Processors/Expressions/shaderDefineExpression.js
var ShaderDefineExpression;
var init_shaderDefineExpression = __esm({
  "node_modules/@babylonjs/core/Engines/Processors/Expressions/shaderDefineExpression.js"() {
    "use strict";
    ShaderDefineExpression = class _ShaderDefineExpression {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      isTrue(preprocessors) {
        return true;
      }
      static postfixToInfix(postfix) {
        const stack = [];
        for (const c of postfix) {
          if (_ShaderDefineExpression._OperatorPriority[c] === void 0) {
            stack.push(c);
          } else {
            const v1 = stack[stack.length - 1], v2 = stack[stack.length - 2];
            stack.length -= 2;
            stack.push(`(${v2}${c}${v1})`);
          }
        }
        return stack[stack.length - 1];
      }
      /**
       * Converts an infix expression to a postfix expression.
       *
       * This method is used to transform infix expressions, which are more human-readable,
       * into postfix expressions, also known as Reverse Polish Notation (RPN), that can be
       * evaluated more efficiently by a computer. The conversion is based on the operator
       * priority defined in _OperatorPriority.
       *
       * The function employs a stack-based algorithm for the conversion and caches the result
       * to improve performance. The cache keeps track of each converted expression's access time
       * to manage the cache size and optimize memory usage. When the cache size exceeds a specified
       * limit, the least recently accessed items in the cache are deleted.
       *
       * The cache mechanism is particularly helpful for shader compilation, where the same infix
       * expressions might be encountered repeatedly, hence the caching can speed up the process.
       *
       * @param infix - The infix expression to be converted.
       * @returns The postfix expression as an array of strings.
       */
      static infixToPostfix(infix) {
        const cacheItem = _ShaderDefineExpression._InfixToPostfixCache.get(infix);
        if (cacheItem) {
          cacheItem.accessTime = Date.now();
          return cacheItem.result;
        }
        if (!infix.includes("&&") && !infix.includes("||") && !infix.includes(")") && !infix.includes("(")) {
          return [infix];
        }
        const result = [];
        let stackIdx = -1;
        const pushOperand = () => {
          operand = operand.trim();
          if (operand !== "") {
            result.push(operand);
            operand = "";
          }
        };
        const push = (s) => {
          if (stackIdx < _ShaderDefineExpression._Stack.length - 1) {
            _ShaderDefineExpression._Stack[++stackIdx] = s;
          }
        };
        const peek = () => _ShaderDefineExpression._Stack[stackIdx];
        const pop = () => stackIdx === -1 ? "!!INVALID EXPRESSION!!" : _ShaderDefineExpression._Stack[stackIdx--];
        let idx = 0, operand = "";
        while (idx < infix.length) {
          const c = infix.charAt(idx), token = idx < infix.length - 1 ? infix.substring(idx, 2 + idx) : "";
          if (c === "(") {
            operand = "";
            push(c);
          } else if (c === ")") {
            pushOperand();
            while (stackIdx !== -1 && peek() !== "(") {
              result.push(pop());
            }
            pop();
          } else if (_ShaderDefineExpression._OperatorPriority[token] > 1) {
            pushOperand();
            while (stackIdx !== -1 && _ShaderDefineExpression._OperatorPriority[peek()] >= _ShaderDefineExpression._OperatorPriority[token]) {
              result.push(pop());
            }
            push(token);
            idx++;
          } else {
            operand += c;
          }
          idx++;
        }
        pushOperand();
        while (stackIdx !== -1) {
          if (peek() === "(") {
            pop();
          } else {
            result.push(pop());
          }
        }
        if (_ShaderDefineExpression._InfixToPostfixCache.size >= _ShaderDefineExpression.InfixToPostfixCacheLimitSize) {
          _ShaderDefineExpression.ClearCache();
        }
        _ShaderDefineExpression._InfixToPostfixCache.set(infix, { result, accessTime: Date.now() });
        return result;
      }
      static ClearCache() {
        const sortedCache = Array.from(_ShaderDefineExpression._InfixToPostfixCache.entries()).sort((a, b) => a[1].accessTime - b[1].accessTime);
        for (let i = 0; i < _ShaderDefineExpression.InfixToPostfixCacheCleanupSize; i++) {
          _ShaderDefineExpression._InfixToPostfixCache.delete(sortedCache[i][0]);
        }
      }
    };
    ShaderDefineExpression.InfixToPostfixCacheLimitSize = 5e4;
    ShaderDefineExpression.InfixToPostfixCacheCleanupSize = 25e3;
    ShaderDefineExpression._InfixToPostfixCache = /* @__PURE__ */ new Map();
    ShaderDefineExpression._OperatorPriority = {
      ")": 0,
      "(": 1,
      "||": 2,
      "&&": 3
    };
    ShaderDefineExpression._Stack = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""];
  }
});

// node_modules/@babylonjs/core/Engines/Processors/Expressions/Operators/shaderDefineIsDefinedOperator.js
var ShaderDefineIsDefinedOperator;
var init_shaderDefineIsDefinedOperator = __esm({
  "node_modules/@babylonjs/core/Engines/Processors/Expressions/Operators/shaderDefineIsDefinedOperator.js"() {
    "use strict";
    init_shaderDefineExpression();
    ShaderDefineIsDefinedOperator = class extends ShaderDefineExpression {
      constructor(define, not = false) {
        super();
        this.define = define;
        this.not = not;
      }
      isTrue(preprocessors) {
        let condition = preprocessors[this.define] !== void 0;
        if (this.not) {
          condition = !condition;
        }
        return condition;
      }
    };
  }
});

// node_modules/@babylonjs/core/Engines/Processors/Expressions/Operators/shaderDefineOrOperator.js
var ShaderDefineOrOperator;
var init_shaderDefineOrOperator = __esm({
  "node_modules/@babylonjs/core/Engines/Processors/Expressions/Operators/shaderDefineOrOperator.js"() {
    "use strict";
    init_shaderDefineExpression();
    ShaderDefineOrOperator = class extends ShaderDefineExpression {
      isTrue(preprocessors) {
        return this.leftOperand.isTrue(preprocessors) || this.rightOperand.isTrue(preprocessors);
      }
    };
  }
});

// node_modules/@babylonjs/core/Engines/Processors/Expressions/Operators/shaderDefineAndOperator.js
var ShaderDefineAndOperator;
var init_shaderDefineAndOperator = __esm({
  "node_modules/@babylonjs/core/Engines/Processors/Expressions/Operators/shaderDefineAndOperator.js"() {
    "use strict";
    init_shaderDefineExpression();
    ShaderDefineAndOperator = class extends ShaderDefineExpression {
      isTrue(preprocessors) {
        return this.leftOperand.isTrue(preprocessors) && this.rightOperand.isTrue(preprocessors);
      }
    };
  }
});

// node_modules/@babylonjs/core/Engines/Processors/Expressions/Operators/shaderDefineArithmeticOperator.js
var ShaderDefineArithmeticOperator;
var init_shaderDefineArithmeticOperator = __esm({
  "node_modules/@babylonjs/core/Engines/Processors/Expressions/Operators/shaderDefineArithmeticOperator.js"() {
    "use strict";
    init_shaderDefineExpression();
    ShaderDefineArithmeticOperator = class extends ShaderDefineExpression {
      constructor(define, operand, testValue) {
        super();
        this.define = define;
        this.operand = operand;
        this.testValue = testValue;
      }
      isTrue(preprocessors) {
        let value = preprocessors[this.define];
        if (value === void 0) {
          value = this.define;
        }
        let condition = false;
        const left = parseInt(value);
        const right = parseInt(this.testValue);
        switch (this.operand) {
          case ">":
            condition = left > right;
            break;
          case "<":
            condition = left < right;
            break;
          case "<=":
            condition = left <= right;
            break;
          case ">=":
            condition = left >= right;
            break;
          case "==":
            condition = left === right;
            break;
          case "!=":
            condition = left !== right;
            break;
        }
        return condition;
      }
    };
  }
});

// node_modules/@babylonjs/core/Engines/Processors/shaderProcessor.js
function Initialize(options) {
  if (options.processor && options.processor.initializeShaders) {
    options.processor.initializeShaders(options.processingContext);
  }
}
function Process(sourceCode, options, callback, engine) {
  var _a;
  if ((_a = options.processor) == null ? void 0 : _a.preProcessShaderCode) {
    sourceCode = options.processor.preProcessShaderCode(sourceCode, options.isFragment);
  }
  _ProcessIncludes(sourceCode, options, (codeWithIncludes) => {
    if (options.processCodeAfterIncludes) {
      codeWithIncludes = options.processCodeAfterIncludes(options.isFragment ? "fragment" : "vertex", codeWithIncludes, options.defines);
    }
    const migratedCode = _ProcessShaderConversion(codeWithIncludes, options, engine);
    callback(migratedCode, codeWithIncludes);
  });
}
function PreProcess(sourceCode, options, callback, engine) {
  var _a;
  if ((_a = options.processor) == null ? void 0 : _a.preProcessShaderCode) {
    sourceCode = options.processor.preProcessShaderCode(sourceCode, options.isFragment);
  }
  _ProcessIncludes(sourceCode, options, (codeWithIncludes) => {
    if (options.processCodeAfterIncludes) {
      codeWithIncludes = options.processCodeAfterIncludes(options.isFragment ? "fragment" : "vertex", codeWithIncludes, options.defines);
    }
    const migratedCode = _ApplyPreProcessing(codeWithIncludes, options, engine);
    callback(migratedCode, codeWithIncludes);
  });
}
function Finalize(vertexCode, fragmentCode, options) {
  if (!options.processor || !options.processor.finalizeShaders) {
    return { vertexCode, fragmentCode };
  }
  return options.processor.finalizeShaders(vertexCode, fragmentCode, options.processingContext);
}
function _ProcessPrecision(source, options) {
  var _a;
  if ((_a = options.processor) == null ? void 0 : _a.noPrecision) {
    return source;
  }
  const shouldUseHighPrecisionShader = options.shouldUseHighPrecisionShader;
  if (source.indexOf("precision highp float") === -1) {
    if (!shouldUseHighPrecisionShader) {
      source = "precision mediump float;\n" + source;
    } else {
      source = "precision highp float;\n" + source;
    }
  } else {
    if (!shouldUseHighPrecisionShader) {
      source = source.replace("precision highp float", "precision mediump float");
    }
  }
  return source;
}
function _ExtractOperation(expression) {
  const regex = /defined\((.+)\)/;
  const match = regex.exec(expression);
  if (match && match.length) {
    return new ShaderDefineIsDefinedOperator(match[1].trim(), expression[0] === "!");
  }
  const operators = ["==", "!=", ">=", "<=", "<", ">"];
  let operator = "";
  let indexOperator = 0;
  for (operator of operators) {
    indexOperator = expression.indexOf(operator);
    if (indexOperator > -1) {
      break;
    }
  }
  if (indexOperator === -1) {
    return new ShaderDefineIsDefinedOperator(expression);
  }
  const define = expression.substring(0, indexOperator).trim();
  const value = expression.substring(indexOperator + operator.length).trim();
  return new ShaderDefineArithmeticOperator(define, operator, value);
}
function _BuildSubExpression(expression) {
  expression = expression.replace(regexSE, "defined[$1]");
  const postfix = ShaderDefineExpression.infixToPostfix(expression);
  const stack = [];
  for (const c of postfix) {
    if (c !== "||" && c !== "&&") {
      stack.push(c);
    } else if (stack.length >= 2) {
      let v1 = stack[stack.length - 1], v2 = stack[stack.length - 2];
      stack.length -= 2;
      const operator = c == "&&" ? new ShaderDefineAndOperator() : new ShaderDefineOrOperator();
      if (typeof v1 === "string") {
        v1 = v1.replace(regexSERevert, "defined($1)");
      }
      if (typeof v2 === "string") {
        v2 = v2.replace(regexSERevert, "defined($1)");
      }
      operator.leftOperand = typeof v2 === "string" ? _ExtractOperation(v2) : v2;
      operator.rightOperand = typeof v1 === "string" ? _ExtractOperation(v1) : v1;
      stack.push(operator);
    }
  }
  let result = stack[stack.length - 1];
  if (typeof result === "string") {
    result = result.replace(regexSERevert, "defined($1)");
  }
  return typeof result === "string" ? _ExtractOperation(result) : result;
}
function _BuildExpression(line, start) {
  const node = new ShaderCodeTestNode();
  const command = line.substring(0, start);
  let expression = line.substring(start);
  expression = expression.substring(0, (expression.indexOf("//") + 1 || expression.length + 1) - 1).trim();
  if (command === "#ifdef") {
    node.testExpression = new ShaderDefineIsDefinedOperator(expression);
  } else if (command === "#ifndef") {
    node.testExpression = new ShaderDefineIsDefinedOperator(expression, true);
  } else {
    node.testExpression = _BuildSubExpression(expression);
  }
  return node;
}
function _MoveCursorWithinIf(cursor, rootNode, ifNode) {
  let line = cursor.currentLine;
  while (_MoveCursor(cursor, ifNode)) {
    line = cursor.currentLine;
    const first5 = line.substring(0, 5).toLowerCase();
    if (first5 === "#else") {
      const elseNode = new ShaderCodeNode();
      rootNode.children.push(elseNode);
      _MoveCursor(cursor, elseNode);
      return;
    } else if (first5 === "#elif") {
      const elifNode = _BuildExpression(line, 5);
      rootNode.children.push(elifNode);
      ifNode = elifNode;
    }
  }
}
function _MoveCursor(cursor, rootNode) {
  while (cursor.canRead) {
    cursor.lineIndex++;
    const line = cursor.currentLine;
    if (line.indexOf("#") >= 0) {
      const matches = _MoveCursorRegex.exec(line);
      if (matches && matches.length) {
        const keyword = matches[0];
        switch (keyword) {
          case "#ifdef": {
            const newRootNode = new ShaderCodeConditionNode();
            rootNode.children.push(newRootNode);
            const ifNode = _BuildExpression(line, 6);
            newRootNode.children.push(ifNode);
            _MoveCursorWithinIf(cursor, newRootNode, ifNode);
            break;
          }
          case "#else":
          case "#elif":
            return true;
          case "#endif":
            return false;
          case "#ifndef": {
            const newRootNode = new ShaderCodeConditionNode();
            rootNode.children.push(newRootNode);
            const ifNode = _BuildExpression(line, 7);
            newRootNode.children.push(ifNode);
            _MoveCursorWithinIf(cursor, newRootNode, ifNode);
            break;
          }
          case "#if": {
            const newRootNode = new ShaderCodeConditionNode();
            const ifNode = _BuildExpression(line, 3);
            rootNode.children.push(newRootNode);
            newRootNode.children.push(ifNode);
            _MoveCursorWithinIf(cursor, newRootNode, ifNode);
            break;
          }
        }
        continue;
      }
    }
    const newNode = new ShaderCodeNode();
    newNode.line = line;
    rootNode.children.push(newNode);
    if (line[0] === "#" && line[1] === "d") {
      const split = line.replace(";", "").split(" ");
      newNode.additionalDefineKey = split[1];
      if (split.length === 3) {
        newNode.additionalDefineValue = split[2];
      }
    }
  }
  return false;
}
function _EvaluatePreProcessors(sourceCode, preprocessors, options) {
  const rootNode = new ShaderCodeNode();
  const cursor = new ShaderCodeCursor();
  cursor.lineIndex = -1;
  cursor.lines = sourceCode.split("\n");
  _MoveCursor(cursor, rootNode);
  return rootNode.process(preprocessors, options);
}
function _PreparePreProcessors(options, engine) {
  var _a;
  const defines = options.defines;
  const preprocessors = {};
  for (const define of defines) {
    const keyValue = define.replace("#define", "").replace(";", "").trim();
    const split = keyValue.split(" ");
    preprocessors[split[0]] = split.length > 1 ? split[1] : "";
  }
  if (((_a = options.processor) == null ? void 0 : _a.shaderLanguage) === 0) {
    preprocessors["GL_ES"] = "true";
  }
  preprocessors["__VERSION__"] = options.version;
  preprocessors[options.platformName] = "true";
  _getGlobalDefines(preprocessors, engine == null ? void 0 : engine.isNDCHalfZRange, engine == null ? void 0 : engine.useReverseDepthBuffer, engine == null ? void 0 : engine.useExactSrgbConversions);
  return preprocessors;
}
function _ProcessShaderConversion(sourceCode, options, engine) {
  let preparedSourceCode = _ProcessPrecision(sourceCode, options);
  if (!options.processor) {
    return preparedSourceCode;
  }
  if (options.processor.shaderLanguage === 0 && preparedSourceCode.indexOf("#version 3") !== -1) {
    preparedSourceCode = preparedSourceCode.replace("#version 300 es", "");
    if (!options.processor.parseGLES3) {
      return preparedSourceCode;
    }
  }
  const defines = options.defines;
  const preprocessors = _PreparePreProcessors(options, engine);
  if (options.processor.preProcessor) {
    preparedSourceCode = options.processor.preProcessor(preparedSourceCode, defines, preprocessors, options.isFragment, options.processingContext);
  }
  preparedSourceCode = _EvaluatePreProcessors(preparedSourceCode, preprocessors, options);
  if (options.processor.postProcessor) {
    preparedSourceCode = options.processor.postProcessor(preparedSourceCode, defines, options.isFragment, options.processingContext, engine ? {
      drawBuffersExtensionDisabled: engine.getCaps().drawBuffersExtension ? false : true
    } : {});
  }
  if (engine == null ? void 0 : engine._features.needShaderCodeInlining) {
    preparedSourceCode = engine.inlineShaderCode(preparedSourceCode);
  }
  return preparedSourceCode;
}
function _ApplyPreProcessing(sourceCode, options, engine) {
  var _a, _b;
  let preparedSourceCode = sourceCode;
  const defines = options.defines;
  const preprocessors = _PreparePreProcessors(options, engine);
  if ((_a = options.processor) == null ? void 0 : _a.preProcessor) {
    preparedSourceCode = options.processor.preProcessor(preparedSourceCode, defines, preprocessors, options.isFragment, options.processingContext);
  }
  preparedSourceCode = _EvaluatePreProcessors(preparedSourceCode, preprocessors, options);
  if ((_b = options.processor) == null ? void 0 : _b.postProcessor) {
    preparedSourceCode = options.processor.postProcessor(preparedSourceCode, defines, options.isFragment, options.processingContext, engine ? {
      drawBuffersExtensionDisabled: engine.getCaps().drawBuffersExtension ? false : true
    } : {});
  }
  if (engine._features.needShaderCodeInlining) {
    preparedSourceCode = engine.inlineShaderCode(preparedSourceCode);
  }
  return preparedSourceCode;
}
function _ProcessIncludes(sourceCode, options, callback) {
  reusableMatches.length = 0;
  let match;
  while ((match = regexShaderInclude.exec(sourceCode)) !== null) {
    reusableMatches.push(match);
  }
  let returnValue = String(sourceCode);
  let parts = [sourceCode];
  let keepProcessing = false;
  for (const match2 of reusableMatches) {
    let includeFile = match2[1];
    if (includeFile.indexOf("__decl__") !== -1) {
      includeFile = includeFile.replace(regexShaderDecl, "");
      if (options.supportsUniformBuffers) {
        includeFile = includeFile.replace("Vertex", "Ubo").replace("Fragment", "Ubo");
      }
      includeFile = includeFile + "Declaration";
    }
    if (options.includesShadersStore[includeFile]) {
      let includeContent = options.includesShadersStore[includeFile];
      if (match2[2]) {
        const splits = match2[3].split(",");
        for (let index = 0; index < splits.length; index += 2) {
          const source = new RegExp(splits[index], "g");
          const dest = splits[index + 1];
          includeContent = includeContent.replace(source, dest);
        }
      }
      if (match2[4]) {
        const indexString = match2[5];
        if (indexString.indexOf("..") !== -1) {
          const indexSplits = indexString.split("..");
          const minIndex = parseInt(indexSplits[0]);
          let maxIndex = parseInt(indexSplits[1]);
          let sourceIncludeContent = includeContent.slice(0);
          includeContent = "";
          if (isNaN(maxIndex)) {
            maxIndex = options.indexParameters[indexSplits[1]];
          }
          for (let i = minIndex; i < maxIndex; i++) {
            if (!options.supportsUniformBuffers) {
              sourceIncludeContent = sourceIncludeContent.replace(regexLightX, (str, p1) => {
                return p1 + "{X}";
              });
            }
            includeContent += sourceIncludeContent.replace(regexX, i.toString()) + "\n";
          }
        } else {
          if (!options.supportsUniformBuffers) {
            includeContent = includeContent.replace(regexLightX, (str, p1) => {
              return p1 + "{X}";
            });
          }
          includeContent = includeContent.replace(regexX, indexString);
        }
      }
      const newParts = [];
      for (const part of parts) {
        const splitPart = part.split(match2[0]);
        for (let i = 0; i < splitPart.length - 1; i++) {
          newParts.push(splitPart[i]);
          newParts.push(includeContent);
        }
        newParts.push(splitPart[splitPart.length - 1]);
      }
      parts = newParts;
      keepProcessing = keepProcessing || includeContent.indexOf("#include<") >= 0 || includeContent.indexOf("#include <") >= 0;
    } else {
      const includeShaderUrl = options.shadersRepository + "ShadersInclude/" + includeFile + ".fx";
      _functionContainer.loadFile(includeShaderUrl, (fileContent) => {
        options.includesShadersStore[includeFile] = fileContent;
        _ProcessIncludes(parts.join(""), options, callback);
      });
      return;
    }
  }
  reusableMatches.length = 0;
  returnValue = parts.join("");
  if (keepProcessing) {
    _ProcessIncludes(returnValue.toString(), options, callback);
  } else {
    callback(returnValue);
  }
}
var regexSE, regexSERevert, regexShaderInclude, regexShaderDecl, regexLightX, regexX, reusableMatches, _MoveCursorRegex, _functionContainer;
var init_shaderProcessor = __esm({
  "node_modules/@babylonjs/core/Engines/Processors/shaderProcessor.js"() {
    "use strict";
    init_shaderCodeNode();
    init_shaderCodeCursor();
    init_shaderCodeConditionNode();
    init_shaderCodeTestNode();
    init_shaderDefineIsDefinedOperator();
    init_shaderDefineOrOperator();
    init_shaderDefineAndOperator();
    init_shaderDefineExpression();
    init_shaderDefineArithmeticOperator();
    init_devTools();
    init_abstractEngine_functions();
    regexSE = /defined\s*?\((.+?)\)/g;
    regexSERevert = /defined\s*?\[(.+?)\]/g;
    regexShaderInclude = /#include\s?<(.+)>(\((.*)\))*(\[(.*)\])*/g;
    regexShaderDecl = /__decl__/;
    regexLightX = /light\{X\}.(\w*)/g;
    regexX = /\{X\}/g;
    reusableMatches = [];
    _MoveCursorRegex = /(#ifdef)|(#else)|(#elif)|(#endif)|(#ifndef)|(#if)/;
    _functionContainer = {
      /**
       * Loads a file from a url
       * @param url url to load
       * @param onSuccess callback called when the file successfully loads
       * @param onProgress callback called while file is loading (if the server supports this mode)
       * @param offlineProvider defines the offline provider for caching
       * @param useArrayBuffer defines a boolean indicating that date must be returned as ArrayBuffer
       * @param onError callback called when the file fails to load
       * @returns a file request object
       * @internal
       */
      loadFile: (url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError) => {
        throw _WarnImport("FileTools");
      }
    };
  }
});

// node_modules/@babylonjs/core/Materials/effect.functions.js
function getCachedPipeline(name2, context) {
  const stateObject = getStateObject(context);
  return stateObject.cachedPipelines[name2];
}
function resetCachedPipeline(pipeline) {
  const name2 = pipeline._name;
  const context = pipeline.context;
  if (name2 && context) {
    const stateObject = getStateObject(context);
    const cachedPipeline = stateObject.cachedPipelines[name2];
    cachedPipeline == null ? void 0 : cachedPipeline.dispose();
    delete stateObject.cachedPipelines[name2];
  }
}
function _processShaderCode(processorOptions, baseName, processFinalCode, onFinalCodeReady, shaderLanguage, engine, effectContext) {
  let vertexSource;
  let fragmentSource;
  const hostDocument = IsWindowObjectExist() ? engine == null ? void 0 : engine.getHostDocument() : null;
  if (typeof baseName === "string") {
    vertexSource = baseName;
  } else if (baseName.vertexSource) {
    vertexSource = "source:" + baseName.vertexSource;
  } else if (baseName.vertexElement) {
    vertexSource = (hostDocument == null ? void 0 : hostDocument.getElementById(baseName.vertexElement)) || baseName.vertexElement;
  } else {
    vertexSource = baseName.vertex || baseName;
  }
  if (typeof baseName === "string") {
    fragmentSource = baseName;
  } else if (baseName.fragmentSource) {
    fragmentSource = "source:" + baseName.fragmentSource;
  } else if (baseName.fragmentElement) {
    fragmentSource = (hostDocument == null ? void 0 : hostDocument.getElementById(baseName.fragmentElement)) || baseName.fragmentElement;
  } else {
    fragmentSource = baseName.fragment || baseName;
  }
  const shaderCodes = [void 0, void 0];
  const shadersLoaded = () => {
    if (shaderCodes[0] && shaderCodes[1]) {
      processorOptions.isFragment = true;
      const [migratedVertexCode, fragmentCode] = shaderCodes;
      Process(fragmentCode, processorOptions, (migratedFragmentCode, codeBeforeMigration) => {
        if (effectContext) {
          effectContext._fragmentSourceCodeBeforeMigration = codeBeforeMigration;
        }
        if (processFinalCode) {
          migratedFragmentCode = processFinalCode("fragment", migratedFragmentCode);
        }
        const finalShaders = Finalize(migratedVertexCode, migratedFragmentCode, processorOptions);
        processorOptions = null;
        const finalCode = _useFinalCode(finalShaders.vertexCode, finalShaders.fragmentCode, baseName, shaderLanguage);
        onFinalCodeReady == null ? void 0 : onFinalCodeReady(finalCode.vertexSourceCode, finalCode.fragmentSourceCode);
      }, engine);
    }
  };
  _loadShader(vertexSource, "Vertex", "", (vertexCode) => {
    Initialize(processorOptions);
    Process(vertexCode, processorOptions, (migratedVertexCode, codeBeforeMigration) => {
      if (effectContext) {
        effectContext._rawVertexSourceCode = vertexCode;
        effectContext._vertexSourceCodeBeforeMigration = codeBeforeMigration;
      }
      if (processFinalCode) {
        migratedVertexCode = processFinalCode("vertex", migratedVertexCode);
      }
      shaderCodes[0] = migratedVertexCode;
      shadersLoaded();
    }, engine);
  }, shaderLanguage);
  _loadShader(fragmentSource, "Fragment", "Pixel", (fragmentCode) => {
    if (effectContext) {
      effectContext._rawFragmentSourceCode = fragmentCode;
    }
    shaderCodes[1] = fragmentCode;
    shadersLoaded();
  }, shaderLanguage);
}
function _loadShader(shader, key, optionalKey, callback, shaderLanguage, _loadFileInjection) {
  if (typeof HTMLElement !== "undefined") {
    if (shader instanceof HTMLElement) {
      const shaderCode = GetDOMTextContent(shader);
      callback(shaderCode);
      return;
    }
  }
  if (shader.substring(0, 7) === "source:") {
    callback(shader.substring(7));
    return;
  }
  if (shader.substring(0, 7) === "base64:") {
    const shaderBinary = window.atob(shader.substring(7));
    callback(shaderBinary);
    return;
  }
  const shaderStore = ShaderStore.GetShadersStore(shaderLanguage);
  if (shaderStore[shader + key + "Shader"]) {
    callback(shaderStore[shader + key + "Shader"]);
    return;
  }
  if (optionalKey && shaderStore[shader + optionalKey + "Shader"]) {
    callback(shaderStore[shader + optionalKey + "Shader"]);
    return;
  }
  let shaderUrl;
  if (shader[0] === "." || shader[0] === "/" || shader.indexOf("http") > -1) {
    shaderUrl = shader;
  } else {
    shaderUrl = ShaderStore.GetShadersRepository(shaderLanguage) + shader;
  }
  _loadFileInjection = _loadFileInjection || _loadFile;
  if (!_loadFileInjection) {
    throw new Error("loadFileInjection is not defined");
  }
  _loadFileInjection(shaderUrl + "." + key.toLowerCase() + ".fx", callback);
}
function _useFinalCode(migratedVertexCode, migratedFragmentCode, baseName, shaderLanguage) {
  if (baseName) {
    const vertex = baseName.vertexElement || baseName.vertex || baseName.spectorName || baseName;
    const fragment = baseName.fragmentElement || baseName.fragment || baseName.spectorName || baseName;
    return {
      vertexSourceCode: (shaderLanguage === 1 ? "//" : "") + "#define SHADER_NAME vertex:" + vertex + "\n" + migratedVertexCode,
      fragmentSourceCode: (shaderLanguage === 1 ? "//" : "") + "#define SHADER_NAME fragment:" + fragment + "\n" + migratedFragmentCode
    };
  } else {
    return {
      vertexSourceCode: migratedVertexCode,
      fragmentSourceCode: migratedFragmentCode
    };
  }
}
var createAndPreparePipelineContext;
var init_effect_functions = __esm({
  "node_modules/@babylonjs/core/Materials/effect.functions.js"() {
    "use strict";
    init_domManagement();
    init_thinEngine_functions();
    init_shaderStore();
    init_logger();
    init_shaderProcessor();
    init_abstractEngine_functions();
    createAndPreparePipelineContext = (options, createPipelineContext2, _preparePipelineContext2, _executeWhenRenderingStateIsCompiled2) => {
      try {
        const pipelineContext = options.existingPipelineContext || createPipelineContext2(options.shaderProcessingContext);
        pipelineContext._name = options.name;
        if (options.name && options.context) {
          const stateObject = getStateObject(options.context);
          stateObject.cachedPipelines[options.name] = pipelineContext;
        }
        _preparePipelineContext2(pipelineContext, options.vertex, options.fragment, !!options.createAsRaw, "", "", options.rebuildRebind, options.defines, options.transformFeedbackVaryings, "", () => {
          _executeWhenRenderingStateIsCompiled2(pipelineContext, () => {
            var _a;
            (_a = options.onRenderingStateCompiled) == null ? void 0 : _a.call(options, pipelineContext);
          });
        });
        return pipelineContext;
      } catch (e) {
        Logger.Error("Error compiling effect");
        throw e;
      }
    };
  }
});

// node_modules/@babylonjs/core/Materials/effect.js
var Effect;
var init_effect = __esm({
  "node_modules/@babylonjs/core/Materials/effect.js"() {
    "use strict";
    init_observable();
    init_logger();
    init_shaderStore();
    init_effect_functions();
    Effect = class _Effect {
      /**
       * Gets or sets the relative url used to load shaders if using the engine in non-minified mode
       */
      static get ShadersRepository() {
        return ShaderStore.ShadersRepository;
      }
      static set ShadersRepository(repo) {
        ShaderStore.ShadersRepository = repo;
      }
      /**
       * Observable that will be called when effect is bound.
       */
      get onBindObservable() {
        if (!this._onBindObservable) {
          this._onBindObservable = new Observable();
        }
        return this._onBindObservable;
      }
      /**
       * Gets the shader language type used to write vertex and fragment source code.
       */
      get shaderLanguage() {
        return this._shaderLanguage;
      }
      /**
       * Instantiates an effect.
       * An effect can be used to create/manage/execute vertex and fragment shaders.
       * @param baseName Name of the effect.
       * @param attributesNamesOrOptions List of attribute names that will be passed to the shader or set of all options to create the effect.
       * @param uniformsNamesOrEngine List of uniform variable names that will be passed to the shader or the engine that will be used to render effect.
       * @param samplers List of sampler variables that will be passed to the shader.
       * @param engine Engine to be used to render the effect
       * @param defines Define statements to be added to the shader.
       * @param fallbacks Possible fallbacks for this effect to improve performance when needed.
       * @param onCompiled Callback that will be called when the shader is compiled.
       * @param onError Callback that will be called if an error occurs during shader compilation.
       * @param indexParameters Parameters to be used with Babylons include syntax to iterate over an array (eg. \{lights: 10\})
       * @param key Effect Key identifying uniquely compiled shader variants
       * @param shaderLanguage the language the shader is written in (default: GLSL)
       * @param extraInitializationsAsync additional async code to run before preparing the effect
       */
      constructor(baseName, attributesNamesOrOptions, uniformsNamesOrEngine, samplers = null, engine, defines = null, fallbacks = null, onCompiled = null, onError = null, indexParameters, key = "", shaderLanguage = 0, extraInitializationsAsync) {
        var _a, _b, _c, _d;
        this.defines = "";
        this.onCompiled = null;
        this.onError = null;
        this.onBind = null;
        this.uniqueId = 0;
        this.onCompileObservable = new Observable();
        this.onErrorObservable = new Observable();
        this._onBindObservable = null;
        this._isDisposed = false;
        this._refCount = 1;
        this._bonesComputationForcedToCPU = false;
        this._uniformBuffersNames = {};
        this._multiTarget = false;
        this._samplers = {};
        this._isReady = false;
        this._compilationError = "";
        this._allFallbacksProcessed = false;
        this._uniforms = {};
        this._key = "";
        this._fallbacks = null;
        this._vertexSourceCodeOverride = "";
        this._fragmentSourceCodeOverride = "";
        this._transformFeedbackVaryings = null;
        this._pipelineContext = null;
        this._vertexSourceCode = "";
        this._fragmentSourceCode = "";
        this._vertexSourceCodeBeforeMigration = "";
        this._fragmentSourceCodeBeforeMigration = "";
        this._rawVertexSourceCode = "";
        this._rawFragmentSourceCode = "";
        this._processCodeAfterIncludes = void 0;
        this._processFinalCode = null;
        this.name = baseName;
        this._key = key;
        const pipelineName = this._key.replace(/\r/g, "").replace(/\n/g, "|");
        let cachedPipeline = void 0;
        if (attributesNamesOrOptions.attributes) {
          const options = attributesNamesOrOptions;
          this._engine = uniformsNamesOrEngine;
          this._attributesNames = options.attributes;
          this._uniformsNames = options.uniformsNames.concat(options.samplers);
          this._samplerList = options.samplers.slice();
          this.defines = options.defines;
          this.onError = options.onError;
          this.onCompiled = options.onCompiled;
          this._fallbacks = options.fallbacks;
          this._indexParameters = options.indexParameters;
          this._transformFeedbackVaryings = options.transformFeedbackVaryings || null;
          this._multiTarget = !!options.multiTarget;
          this._shaderLanguage = (_a = options.shaderLanguage) != null ? _a : 0;
          if (options.uniformBuffersNames) {
            this._uniformBuffersNamesList = options.uniformBuffersNames.slice();
            for (let i = 0; i < options.uniformBuffersNames.length; i++) {
              this._uniformBuffersNames[options.uniformBuffersNames[i]] = i;
            }
          }
          this._processFinalCode = (_b = options.processFinalCode) != null ? _b : null;
          this._processCodeAfterIncludes = (_c = options.processCodeAfterIncludes) != null ? _c : void 0;
          cachedPipeline = options.existingPipelineContext;
        } else {
          this._engine = engine;
          this.defines = defines == null ? "" : defines;
          this._uniformsNames = uniformsNamesOrEngine.concat(samplers);
          this._samplerList = samplers ? samplers.slice() : [];
          this._attributesNames = attributesNamesOrOptions;
          this._uniformBuffersNamesList = [];
          this._shaderLanguage = shaderLanguage;
          this.onError = onError;
          this.onCompiled = onCompiled;
          this._indexParameters = indexParameters;
          this._fallbacks = fallbacks;
        }
        if (this._engine.shaderPlatformName === "WEBGL2") {
          cachedPipeline = (_d = getCachedPipeline(pipelineName, this._engine._gl)) != null ? _d : cachedPipeline;
        }
        this._attributeLocationByName = {};
        this.uniqueId = _Effect._UniqueIdSeed++;
        if (!cachedPipeline) {
          this._processShaderCodeAsync(null, false, null, extraInitializationsAsync);
        } else {
          this._pipelineContext = cachedPipeline;
          this._pipelineContext.setEngine(this._engine);
          this._onRenderingStateCompiled(this._pipelineContext);
          if (this._pipelineContext.program) {
            this._pipelineContext.program.__SPECTOR_rebuildProgram = this._rebuildProgram.bind(this);
          }
        }
      }
      /** @internal */
      _processShaderCodeAsync(shaderProcessor = null, keepExistingPipelineContext = false, shaderProcessingContext = null, extraInitializationsAsync) {
        return __async(this, null, function* () {
          if (extraInitializationsAsync) {
            yield extraInitializationsAsync();
          }
          this._processingContext = shaderProcessingContext || this._engine._getShaderProcessingContext(this._shaderLanguage, false);
          const processorOptions = {
            defines: this.defines.split("\n"),
            indexParameters: this._indexParameters,
            isFragment: false,
            shouldUseHighPrecisionShader: this._engine._shouldUseHighPrecisionShader,
            processor: shaderProcessor != null ? shaderProcessor : this._engine._getShaderProcessor(this._shaderLanguage),
            supportsUniformBuffers: this._engine.supportsUniformBuffers,
            shadersRepository: ShaderStore.GetShadersRepository(this._shaderLanguage),
            includesShadersStore: ShaderStore.GetIncludesShadersStore(this._shaderLanguage),
            version: (this._engine.version * 100).toString(),
            platformName: this._engine.shaderPlatformName,
            processingContext: this._processingContext,
            isNDCHalfZRange: this._engine.isNDCHalfZRange,
            useReverseDepthBuffer: this._engine.useReverseDepthBuffer,
            processCodeAfterIncludes: this._processCodeAfterIncludes
          };
          _processShaderCode(processorOptions, this.name, this._processFinalCode, (migratedVertexCode, migratedFragmentCode) => {
            this._vertexSourceCode = migratedVertexCode;
            this._fragmentSourceCode = migratedFragmentCode;
            this._prepareEffect(keepExistingPipelineContext);
          }, this._shaderLanguage, this._engine, this);
        });
      }
      /**
       * Unique key for this effect
       */
      get key() {
        return this._key;
      }
      /**
       * If the effect has been compiled and prepared.
       * @returns if the effect is compiled and prepared.
       */
      isReady() {
        try {
          return this._isReadyInternal();
        } catch (e) {
          return false;
        }
      }
      _isReadyInternal() {
        if (this._isReady) {
          return true;
        }
        if (this._pipelineContext) {
          return this._pipelineContext.isReady;
        }
        return false;
      }
      /**
       * The engine the effect was initialized with.
       * @returns the engine.
       */
      getEngine() {
        return this._engine;
      }
      /**
       * The pipeline context for this effect
       * @returns the associated pipeline context
       */
      getPipelineContext() {
        return this._pipelineContext;
      }
      /**
       * The set of names of attribute variables for the shader.
       * @returns An array of attribute names.
       */
      getAttributesNames() {
        return this._attributesNames;
      }
      /**
       * Returns the attribute at the given index.
       * @param index The index of the attribute.
       * @returns The location of the attribute.
       */
      getAttributeLocation(index) {
        return this._attributes[index];
      }
      /**
       * Returns the attribute based on the name of the variable.
       * @param name of the attribute to look up.
       * @returns the attribute location.
       */
      getAttributeLocationByName(name2) {
        return this._attributeLocationByName[name2];
      }
      /**
       * The number of attributes.
       * @returns the number of attributes.
       */
      getAttributesCount() {
        return this._attributes.length;
      }
      /**
       * Gets the index of a uniform variable.
       * @param uniformName of the uniform to look up.
       * @returns the index.
       */
      getUniformIndex(uniformName) {
        return this._uniformsNames.indexOf(uniformName);
      }
      /**
       * Returns the attribute based on the name of the variable.
       * @param uniformName of the uniform to look up.
       * @returns the location of the uniform.
       */
      getUniform(uniformName) {
        return this._uniforms[uniformName];
      }
      /**
       * Returns an array of sampler variable names
       * @returns The array of sampler variable names.
       */
      getSamplers() {
        return this._samplerList;
      }
      /**
       * Returns an array of uniform variable names
       * @returns The array of uniform variable names.
       */
      getUniformNames() {
        return this._uniformsNames;
      }
      /**
       * Returns an array of uniform buffer variable names
       * @returns The array of uniform buffer variable names.
       */
      getUniformBuffersNames() {
        return this._uniformBuffersNamesList;
      }
      /**
       * Returns the index parameters used to create the effect
       * @returns The index parameters object
       */
      getIndexParameters() {
        return this._indexParameters;
      }
      /**
       * The error from the last compilation.
       * @returns the error string.
       */
      getCompilationError() {
        return this._compilationError;
      }
      /**
       * Gets a boolean indicating that all fallbacks were used during compilation
       * @returns true if all fallbacks were used
       */
      allFallbacksProcessed() {
        return this._allFallbacksProcessed;
      }
      /**
       * Adds a callback to the onCompiled observable and call the callback immediately if already ready.
       * @param func The callback to be used.
       */
      executeWhenCompiled(func) {
        if (this.isReady()) {
          func(this);
          return;
        }
        this.onCompileObservable.add((effect) => {
          func(effect);
        });
        if (!this._pipelineContext || this._pipelineContext.isAsync) {
          setTimeout(() => {
            this._checkIsReady(null);
          }, 16);
        }
      }
      _checkIsReady(previousPipelineContext) {
        try {
          if (this._isReadyInternal()) {
            return;
          }
        } catch (e) {
          this._processCompilationErrors(e, previousPipelineContext);
          return;
        }
        if (this._isDisposed) {
          return;
        }
        setTimeout(() => {
          this._checkIsReady(previousPipelineContext);
        }, 16);
      }
      /**
       * Gets the vertex shader source code of this effect
       * This is the final source code that will be compiled, after all the processing has been done (pre-processing applied, code injection/replacement, etc)
       */
      get vertexSourceCode() {
        var _a, _b;
        return this._vertexSourceCodeOverride && this._fragmentSourceCodeOverride ? this._vertexSourceCodeOverride : (_b = (_a = this._pipelineContext) == null ? void 0 : _a._getVertexShaderCode()) != null ? _b : this._vertexSourceCode;
      }
      /**
       * Gets the fragment shader source code of this effect
       * This is the final source code that will be compiled, after all the processing has been done (pre-processing applied, code injection/replacement, etc)
       */
      get fragmentSourceCode() {
        var _a, _b;
        return this._vertexSourceCodeOverride && this._fragmentSourceCodeOverride ? this._fragmentSourceCodeOverride : (_b = (_a = this._pipelineContext) == null ? void 0 : _a._getFragmentShaderCode()) != null ? _b : this._fragmentSourceCode;
      }
      /**
       * Gets the vertex shader source code before migration.
       * This is the source code after the include directives have been replaced by their contents but before the code is migrated, i.e. before ShaderProcess._ProcessShaderConversion is executed.
       * This method is, among other things, responsible for parsing #if/#define directives as well as converting GLES2 syntax to GLES3 (in the case of WebGL).
       */
      get vertexSourceCodeBeforeMigration() {
        return this._vertexSourceCodeBeforeMigration;
      }
      /**
       * Gets the fragment shader source code before migration.
       * This is the source code after the include directives have been replaced by their contents but before the code is migrated, i.e. before ShaderProcess._ProcessShaderConversion is executed.
       * This method is, among other things, responsible for parsing #if/#define directives as well as converting GLES2 syntax to GLES3 (in the case of WebGL).
       */
      get fragmentSourceCodeBeforeMigration() {
        return this._fragmentSourceCodeBeforeMigration;
      }
      /**
       * Gets the vertex shader source code before it has been modified by any processing
       */
      get rawVertexSourceCode() {
        return this._rawVertexSourceCode;
      }
      /**
       * Gets the fragment shader source code before it has been modified by any processing
       */
      get rawFragmentSourceCode() {
        return this._rawFragmentSourceCode;
      }
      getPipelineGenerationOptions() {
        return {
          platformName: this._engine.shaderPlatformName,
          shaderLanguage: this._shaderLanguage,
          shaderNameOrContent: this.name,
          key: this._key,
          defines: this.defines.split("\n"),
          addGlobalDefines: false,
          extendedProcessingOptions: {
            indexParameters: this._indexParameters,
            isNDCHalfZRange: this._engine.isNDCHalfZRange,
            useReverseDepthBuffer: this._engine.useReverseDepthBuffer,
            supportsUniformBuffers: this._engine.supportsUniformBuffers
          },
          extendedCreatePipelineOptions: {
            transformFeedbackVaryings: this._transformFeedbackVaryings,
            createAsRaw: !!(this._vertexSourceCodeOverride && this._fragmentSourceCodeOverride)
          }
        };
      }
      /**
       * Recompiles the webGL program
       * @param vertexSourceCode The source code for the vertex shader.
       * @param fragmentSourceCode The source code for the fragment shader.
       * @param onCompiled Callback called when completed.
       * @param onError Callback called on error.
       * @internal
       */
      _rebuildProgram(vertexSourceCode, fragmentSourceCode, onCompiled, onError) {
        this._isReady = false;
        this._vertexSourceCodeOverride = vertexSourceCode;
        this._fragmentSourceCodeOverride = fragmentSourceCode;
        this.onError = (effect, error) => {
          if (onError) {
            onError(error);
          }
        };
        this.onCompiled = () => {
          var _a, _b;
          const scenes = this.getEngine().scenes;
          if (scenes) {
            for (let i = 0; i < scenes.length; i++) {
              scenes[i].markAllMaterialsAsDirty(63);
            }
          }
          (_b = (_a = this._pipelineContext)._handlesSpectorRebuildCallback) == null ? void 0 : _b.call(_a, onCompiled);
        };
        this._fallbacks = null;
        this._prepareEffect();
      }
      _onRenderingStateCompiled(pipelineContext) {
        this._pipelineContext = pipelineContext;
        this._pipelineContext.setEngine(this._engine);
        this._attributes = [];
        this._pipelineContext._fillEffectInformation(this, this._uniformBuffersNames, this._uniformsNames, this._uniforms, this._samplerList, this._samplers, this._attributesNames, this._attributes);
        if (this._attributesNames) {
          for (let i = 0; i < this._attributesNames.length; i++) {
            const name2 = this._attributesNames[i];
            this._attributeLocationByName[name2] = this._attributes[i];
          }
        }
        this._engine.bindSamplers(this);
        this._compilationError = "";
        this._isReady = true;
        if (this.onCompiled) {
          this.onCompiled(this);
        }
        this.onCompileObservable.notifyObservers(this);
        this.onCompileObservable.clear();
        if (this._fallbacks) {
          this._fallbacks.unBindMesh();
        }
      }
      /**
       * Prepares the effect
       * @internal
       */
      _prepareEffect(keepExistingPipelineContext = false) {
        const previousPipelineContext = this._pipelineContext;
        this._isReady = false;
        try {
          const overrides = !!(this._vertexSourceCodeOverride && this._fragmentSourceCodeOverride);
          const defines = overrides ? null : this.defines;
          const vertex = overrides ? this._vertexSourceCodeOverride : this._vertexSourceCode;
          const fragment = overrides ? this._fragmentSourceCodeOverride : this._fragmentSourceCode;
          const engine = this._engine;
          this._pipelineContext = createAndPreparePipelineContext({
            existingPipelineContext: keepExistingPipelineContext ? previousPipelineContext : null,
            vertex,
            fragment,
            context: engine.shaderPlatformName === "WEBGL2" ? engine._gl : void 0,
            rebuildRebind: (vertexSourceCode, fragmentSourceCode, onCompiled, onError) => this._rebuildProgram(vertexSourceCode, fragmentSourceCode, onCompiled, onError),
            defines,
            transformFeedbackVaryings: this._transformFeedbackVaryings,
            name: this._key.replace(/\r/g, "").replace(/\n/g, "|"),
            createAsRaw: overrides,
            parallelShaderCompile: engine._caps.parallelShaderCompile,
            shaderProcessingContext: this._processingContext,
            onRenderingStateCompiled: (pipelineContext) => {
              if (previousPipelineContext && !keepExistingPipelineContext) {
                this._engine._deletePipelineContext(previousPipelineContext);
              }
              if (pipelineContext) {
                this._onRenderingStateCompiled(pipelineContext);
              }
            }
          }, this._engine.createPipelineContext.bind(this._engine), this._engine._preparePipelineContext.bind(this._engine), this._engine._executeWhenRenderingStateIsCompiled.bind(this._engine));
          if (this._pipelineContext.isAsync) {
            this._checkIsReady(previousPipelineContext);
          }
        } catch (e) {
          this._processCompilationErrors(e, previousPipelineContext);
        }
      }
      _getShaderCodeAndErrorLine(code, error, isFragment) {
        const regexp = isFragment ? /FRAGMENT SHADER ERROR: 0:(\d+?):/ : /VERTEX SHADER ERROR: 0:(\d+?):/;
        let errorLine = null;
        if (error && code) {
          const res = error.match(regexp);
          if (res && res.length === 2) {
            const lineNumber = parseInt(res[1]);
            const lines = code.split("\n", -1);
            if (lines.length >= lineNumber) {
              errorLine = `Offending line [${lineNumber}] in ${isFragment ? "fragment" : "vertex"} code: ${lines[lineNumber - 1]}`;
            }
          }
        }
        return [code, errorLine];
      }
      _processCompilationErrors(e, previousPipelineContext = null) {
        var _a, _b, _c;
        this._compilationError = e.message;
        const attributesNames = this._attributesNames;
        const fallbacks = this._fallbacks;
        Logger.Error("Unable to compile effect:");
        Logger.Error("Uniforms: " + this._uniformsNames.map(function(uniform) {
          return " " + uniform;
        }));
        Logger.Error("Attributes: " + attributesNames.map(function(attribute) {
          return " " + attribute;
        }));
        Logger.Error("Defines:\n" + this.defines);
        if (_Effect.LogShaderCodeOnCompilationError) {
          let lineErrorVertex = null, lineErrorFragment = null, code = null;
          if ((_a = this._pipelineContext) == null ? void 0 : _a._getVertexShaderCode()) {
            [code, lineErrorVertex] = this._getShaderCodeAndErrorLine(this._pipelineContext._getVertexShaderCode(), this._compilationError, false);
            if (code) {
              Logger.Error("Vertex code:");
              Logger.Error(code);
            }
          }
          if ((_b = this._pipelineContext) == null ? void 0 : _b._getFragmentShaderCode()) {
            [code, lineErrorFragment] = this._getShaderCodeAndErrorLine((_c = this._pipelineContext) == null ? void 0 : _c._getFragmentShaderCode(), this._compilationError, true);
            if (code) {
              Logger.Error("Fragment code:");
              Logger.Error(code);
            }
          }
          if (lineErrorVertex) {
            Logger.Error(lineErrorVertex);
          }
          if (lineErrorFragment) {
            Logger.Error(lineErrorFragment);
          }
        }
        Logger.Error("Error: " + this._compilationError);
        const notifyErrors = () => {
          if (this.onError) {
            this.onError(this, this._compilationError);
          }
          this.onErrorObservable.notifyObservers(this);
        };
        if (previousPipelineContext) {
          this._pipelineContext = previousPipelineContext;
          this._isReady = true;
          notifyErrors();
        }
        if (fallbacks) {
          this._pipelineContext = null;
          if (fallbacks.hasMoreFallbacks) {
            this._allFallbacksProcessed = false;
            Logger.Error("Trying next fallback.");
            this.defines = fallbacks.reduce(this.defines, this);
            this._prepareEffect();
          } else {
            this._allFallbacksProcessed = true;
            notifyErrors();
            this.onErrorObservable.clear();
            if (this._fallbacks) {
              this._fallbacks.unBindMesh();
            }
          }
        } else {
          this._allFallbacksProcessed = true;
          if (!previousPipelineContext) {
            notifyErrors();
          }
        }
      }
      /**
       * Checks if the effect is supported. (Must be called after compilation)
       */
      get isSupported() {
        return this._compilationError === "";
      }
      /**
       * Binds a texture to the engine to be used as output of the shader.
       * @param channel Name of the output variable.
       * @param texture Texture to bind.
       * @internal
       */
      _bindTexture(channel, texture) {
        this._engine._bindTexture(this._samplers[channel], texture, channel);
      }
      /**
       * Sets a texture on the engine to be used in the shader.
       * @param channel Name of the sampler variable.
       * @param texture Texture to set.
       */
      setTexture(channel, texture) {
        this._engine.setTexture(this._samplers[channel], this._uniforms[channel], texture, channel);
      }
      /**
       * Sets an array of textures on the engine to be used in the shader.
       * @param channel Name of the variable.
       * @param textures Textures to set.
       */
      setTextureArray(channel, textures) {
        const exName = channel + "Ex";
        if (this._samplerList.indexOf(exName + "0") === -1) {
          const initialPos = this._samplerList.indexOf(channel);
          for (let index = 1; index < textures.length; index++) {
            const currentExName = exName + (index - 1).toString();
            this._samplerList.splice(initialPos + index, 0, currentExName);
          }
          let channelIndex = 0;
          for (const key of this._samplerList) {
            this._samplers[key] = channelIndex;
            channelIndex += 1;
          }
        }
        this._engine.setTextureArray(this._samplers[channel], this._uniforms[channel], textures, channel);
      }
      /**
       * Binds a buffer to a uniform.
       * @param buffer Buffer to bind.
       * @param name Name of the uniform variable to bind to.
       */
      bindUniformBuffer(buffer, name2) {
        const bufferName = this._uniformBuffersNames[name2];
        if (bufferName === void 0 || _Effect._BaseCache[bufferName] === buffer && this._engine._features.useUBOBindingCache) {
          return;
        }
        _Effect._BaseCache[bufferName] = buffer;
        this._engine.bindUniformBufferBase(buffer, bufferName, name2);
      }
      /**
       * Binds block to a uniform.
       * @param blockName Name of the block to bind.
       * @param index Index to bind.
       */
      bindUniformBlock(blockName, index) {
        this._engine.bindUniformBlock(this._pipelineContext, blockName, index);
      }
      /**
       * Sets an integer value on a uniform variable.
       * @param uniformName Name of the variable.
       * @param value Value to be set.
       * @returns this effect.
       */
      setInt(uniformName, value) {
        this._pipelineContext.setInt(uniformName, value);
        return this;
      }
      /**
       * Sets an int2 value on a uniform variable.
       * @param uniformName Name of the variable.
       * @param x First int in int2.
       * @param y Second int in int2.
       * @returns this effect.
       */
      setInt2(uniformName, x, y) {
        this._pipelineContext.setInt2(uniformName, x, y);
        return this;
      }
      /**
       * Sets an int3 value on a uniform variable.
       * @param uniformName Name of the variable.
       * @param x First int in int3.
       * @param y Second int in int3.
       * @param z Third int in int3.
       * @returns this effect.
       */
      setInt3(uniformName, x, y, z) {
        this._pipelineContext.setInt3(uniformName, x, y, z);
        return this;
      }
      /**
       * Sets an int4 value on a uniform variable.
       * @param uniformName Name of the variable.
       * @param x First int in int4.
       * @param y Second int in int4.
       * @param z Third int in int4.
       * @param w Fourth int in int4.
       * @returns this effect.
       */
      setInt4(uniformName, x, y, z, w) {
        this._pipelineContext.setInt4(uniformName, x, y, z, w);
        return this;
      }
      /**
       * Sets an int array on a uniform variable.
       * @param uniformName Name of the variable.
       * @param array array to be set.
       * @returns this effect.
       */
      setIntArray(uniformName, array) {
        this._pipelineContext.setIntArray(uniformName, array);
        return this;
      }
      /**
       * Sets an int array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
       * @param uniformName Name of the variable.
       * @param array array to be set.
       * @returns this effect.
       */
      setIntArray2(uniformName, array) {
        this._pipelineContext.setIntArray2(uniformName, array);
        return this;
      }
      /**
       * Sets an int array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
       * @param uniformName Name of the variable.
       * @param array array to be set.
       * @returns this effect.
       */
      setIntArray3(uniformName, array) {
        this._pipelineContext.setIntArray3(uniformName, array);
        return this;
      }
      /**
       * Sets an int array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
       * @param uniformName Name of the variable.
       * @param array array to be set.
       * @returns this effect.
       */
      setIntArray4(uniformName, array) {
        this._pipelineContext.setIntArray4(uniformName, array);
        return this;
      }
      /**
       * Sets an unsigned integer value on a uniform variable.
       * @param uniformName Name of the variable.
       * @param value Value to be set.
       * @returns this effect.
       */
      setUInt(uniformName, value) {
        this._pipelineContext.setUInt(uniformName, value);
        return this;
      }
      /**
       * Sets an unsigned int2 value on a uniform variable.
       * @param uniformName Name of the variable.
       * @param x First unsigned int in uint2.
       * @param y Second unsigned int in uint2.
       * @returns this effect.
       */
      setUInt2(uniformName, x, y) {
        this._pipelineContext.setUInt2(uniformName, x, y);
        return this;
      }
      /**
       * Sets an unsigned int3 value on a uniform variable.
       * @param uniformName Name of the variable.
       * @param x First unsigned int in uint3.
       * @param y Second unsigned int in uint3.
       * @param z Third unsigned int in uint3.
       * @returns this effect.
       */
      setUInt3(uniformName, x, y, z) {
        this._pipelineContext.setUInt3(uniformName, x, y, z);
        return this;
      }
      /**
       * Sets an unsigned int4 value on a uniform variable.
       * @param uniformName Name of the variable.
       * @param x First unsigned int in uint4.
       * @param y Second unsigned int in uint4.
       * @param z Third unsigned int in uint4.
       * @param w Fourth unsigned int in uint4.
       * @returns this effect.
       */
      setUInt4(uniformName, x, y, z, w) {
        this._pipelineContext.setUInt4(uniformName, x, y, z, w);
        return this;
      }
      /**
       * Sets an unsigned int array on a uniform variable.
       * @param uniformName Name of the variable.
       * @param array array to be set.
       * @returns this effect.
       */
      setUIntArray(uniformName, array) {
        this._pipelineContext.setUIntArray(uniformName, array);
        return this;
      }
      /**
       * Sets an unsigned int array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
       * @param uniformName Name of the variable.
       * @param array array to be set.
       * @returns this effect.
       */
      setUIntArray2(uniformName, array) {
        this._pipelineContext.setUIntArray2(uniformName, array);
        return this;
      }
      /**
       * Sets an unsigned int array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
       * @param uniformName Name of the variable.
       * @param array array to be set.
       * @returns this effect.
       */
      setUIntArray3(uniformName, array) {
        this._pipelineContext.setUIntArray3(uniformName, array);
        return this;
      }
      /**
       * Sets an unsigned int array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
       * @param uniformName Name of the variable.
       * @param array array to be set.
       * @returns this effect.
       */
      setUIntArray4(uniformName, array) {
        this._pipelineContext.setUIntArray4(uniformName, array);
        return this;
      }
      /**
       * Sets an float array on a uniform variable.
       * @param uniformName Name of the variable.
       * @param array array to be set.
       * @returns this effect.
       */
      setFloatArray(uniformName, array) {
        this._pipelineContext.setArray(uniformName, array);
        return this;
      }
      /**
       * Sets an float array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
       * @param uniformName Name of the variable.
       * @param array array to be set.
       * @returns this effect.
       */
      setFloatArray2(uniformName, array) {
        this._pipelineContext.setArray2(uniformName, array);
        return this;
      }
      /**
       * Sets an float array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
       * @param uniformName Name of the variable.
       * @param array array to be set.
       * @returns this effect.
       */
      setFloatArray3(uniformName, array) {
        this._pipelineContext.setArray3(uniformName, array);
        return this;
      }
      /**
       * Sets an float array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
       * @param uniformName Name of the variable.
       * @param array array to be set.
       * @returns this effect.
       */
      setFloatArray4(uniformName, array) {
        this._pipelineContext.setArray4(uniformName, array);
        return this;
      }
      /**
       * Sets an array on a uniform variable.
       * @param uniformName Name of the variable.
       * @param array array to be set.
       * @returns this effect.
       */
      setArray(uniformName, array) {
        this._pipelineContext.setArray(uniformName, array);
        return this;
      }
      /**
       * Sets an array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
       * @param uniformName Name of the variable.
       * @param array array to be set.
       * @returns this effect.
       */
      setArray2(uniformName, array) {
        this._pipelineContext.setArray2(uniformName, array);
        return this;
      }
      /**
       * Sets an array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
       * @param uniformName Name of the variable.
       * @param array array to be set.
       * @returns this effect.
       */
      setArray3(uniformName, array) {
        this._pipelineContext.setArray3(uniformName, array);
        return this;
      }
      /**
       * Sets an array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
       * @param uniformName Name of the variable.
       * @param array array to be set.
       * @returns this effect.
       */
      setArray4(uniformName, array) {
        this._pipelineContext.setArray4(uniformName, array);
        return this;
      }
      /**
       * Sets matrices on a uniform variable.
       * @param uniformName Name of the variable.
       * @param matrices matrices to be set.
       * @returns this effect.
       */
      setMatrices(uniformName, matrices) {
        this._pipelineContext.setMatrices(uniformName, matrices);
        return this;
      }
      /**
       * Sets matrix on a uniform variable.
       * @param uniformName Name of the variable.
       * @param matrix matrix to be set.
       * @returns this effect.
       */
      setMatrix(uniformName, matrix) {
        this._pipelineContext.setMatrix(uniformName, matrix);
        return this;
      }
      /**
       * Sets a 3x3 matrix on a uniform variable. (Specified as [1,2,3,4,5,6,7,8,9] will result in [1,2,3][4,5,6][7,8,9] matrix)
       * @param uniformName Name of the variable.
       * @param matrix matrix to be set.
       * @returns this effect.
       */
      setMatrix3x3(uniformName, matrix) {
        this._pipelineContext.setMatrix3x3(uniformName, matrix);
        return this;
      }
      /**
       * Sets a 2x2 matrix on a uniform variable. (Specified as [1,2,3,4] will result in [1,2][3,4] matrix)
       * @param uniformName Name of the variable.
       * @param matrix matrix to be set.
       * @returns this effect.
       */
      setMatrix2x2(uniformName, matrix) {
        this._pipelineContext.setMatrix2x2(uniformName, matrix);
        return this;
      }
      /**
       * Sets a float on a uniform variable.
       * @param uniformName Name of the variable.
       * @param value value to be set.
       * @returns this effect.
       */
      setFloat(uniformName, value) {
        this._pipelineContext.setFloat(uniformName, value);
        return this;
      }
      /**
       * Sets a boolean on a uniform variable.
       * @param uniformName Name of the variable.
       * @param bool value to be set.
       * @returns this effect.
       */
      setBool(uniformName, bool) {
        this._pipelineContext.setInt(uniformName, bool ? 1 : 0);
        return this;
      }
      /**
       * Sets a Vector2 on a uniform variable.
       * @param uniformName Name of the variable.
       * @param vector2 vector2 to be set.
       * @returns this effect.
       */
      setVector2(uniformName, vector2) {
        this._pipelineContext.setVector2(uniformName, vector2);
        return this;
      }
      /**
       * Sets a float2 on a uniform variable.
       * @param uniformName Name of the variable.
       * @param x First float in float2.
       * @param y Second float in float2.
       * @returns this effect.
       */
      setFloat2(uniformName, x, y) {
        this._pipelineContext.setFloat2(uniformName, x, y);
        return this;
      }
      /**
       * Sets a Vector3 on a uniform variable.
       * @param uniformName Name of the variable.
       * @param vector3 Value to be set.
       * @returns this effect.
       */
      setVector3(uniformName, vector3) {
        this._pipelineContext.setVector3(uniformName, vector3);
        return this;
      }
      /**
       * Sets a float3 on a uniform variable.
       * @param uniformName Name of the variable.
       * @param x First float in float3.
       * @param y Second float in float3.
       * @param z Third float in float3.
       * @returns this effect.
       */
      setFloat3(uniformName, x, y, z) {
        this._pipelineContext.setFloat3(uniformName, x, y, z);
        return this;
      }
      /**
       * Sets a Vector4 on a uniform variable.
       * @param uniformName Name of the variable.
       * @param vector4 Value to be set.
       * @returns this effect.
       */
      setVector4(uniformName, vector4) {
        this._pipelineContext.setVector4(uniformName, vector4);
        return this;
      }
      /**
       * Sets a Quaternion on a uniform variable.
       * @param uniformName Name of the variable.
       * @param quaternion Value to be set.
       * @returns this effect.
       */
      setQuaternion(uniformName, quaternion) {
        this._pipelineContext.setQuaternion(uniformName, quaternion);
        return this;
      }
      /**
       * Sets a float4 on a uniform variable.
       * @param uniformName Name of the variable.
       * @param x First float in float4.
       * @param y Second float in float4.
       * @param z Third float in float4.
       * @param w Fourth float in float4.
       * @returns this effect.
       */
      setFloat4(uniformName, x, y, z, w) {
        this._pipelineContext.setFloat4(uniformName, x, y, z, w);
        return this;
      }
      /**
       * Sets a Color3 on a uniform variable.
       * @param uniformName Name of the variable.
       * @param color3 Value to be set.
       * @returns this effect.
       */
      setColor3(uniformName, color3) {
        this._pipelineContext.setColor3(uniformName, color3);
        return this;
      }
      /**
       * Sets a Color4 on a uniform variable.
       * @param uniformName Name of the variable.
       * @param color3 Value to be set.
       * @param alpha Alpha value to be set.
       * @returns this effect.
       */
      setColor4(uniformName, color3, alpha) {
        this._pipelineContext.setColor4(uniformName, color3, alpha);
        return this;
      }
      /**
       * Sets a Color4 on a uniform variable
       * @param uniformName defines the name of the variable
       * @param color4 defines the value to be set
       * @returns this effect.
       */
      setDirectColor4(uniformName, color4) {
        this._pipelineContext.setDirectColor4(uniformName, color4);
        return this;
      }
      /**
       * Release all associated resources.
       **/
      dispose() {
        this._refCount--;
        if (this._refCount > 0) {
          return;
        }
        if (this._pipelineContext) {
          resetCachedPipeline(this._pipelineContext);
        }
        this._engine._releaseEffect(this);
        this._isDisposed = true;
      }
      /**
       * This function will add a new shader to the shader store
       * @param name the name of the shader
       * @param pixelShader optional pixel shader content
       * @param vertexShader optional vertex shader content
       * @param shaderLanguage the language the shader is written in (default: GLSL)
       */
      static RegisterShader(name2, pixelShader, vertexShader, shaderLanguage = 0) {
        if (pixelShader) {
          ShaderStore.GetShadersStore(shaderLanguage)[`${name2}PixelShader`] = pixelShader;
        }
        if (vertexShader) {
          ShaderStore.GetShadersStore(shaderLanguage)[`${name2}VertexShader`] = vertexShader;
        }
      }
      /**
       * Resets the cache of effects.
       */
      static ResetCache() {
        _Effect._BaseCache = {};
      }
    };
    Effect.LogShaderCodeOnCompilationError = true;
    Effect._UniqueIdSeed = 0;
    Effect._BaseCache = {};
    Effect.ShadersStore = ShaderStore.ShadersStore;
    Effect.IncludesShadersStore = ShaderStore.IncludesShadersStore;
  }
});

// node_modules/@babylonjs/core/Misc/deepCopier.js
function GetAllPropertyNames(obj) {
  const props = [];
  do {
    Object.getOwnPropertyNames(obj).forEach(function(prop) {
      if (props.indexOf(prop) === -1) {
        props.push(prop);
      }
    });
  } while (obj = Object.getPrototypeOf(obj));
  return props;
}
var CloneValue, DeepCopier;
var init_deepCopier = __esm({
  "node_modules/@babylonjs/core/Misc/deepCopier.js"() {
    "use strict";
    init_logger();
    CloneValue = (source, destinationObject, shallowCopyValues) => {
      if (!source) {
        return null;
      }
      if (source.getClassName && source.getClassName() === "Mesh") {
        return null;
      }
      if (source.getClassName && (source.getClassName() === "SubMesh" || source.getClassName() === "PhysicsBody")) {
        return source.clone(destinationObject);
      } else if (source.clone) {
        return source.clone();
      } else if (Array.isArray(source)) {
        return source.slice();
      } else if (shallowCopyValues && typeof source === "object") {
        return __spreadValues({}, source);
      }
      return null;
    };
    DeepCopier = class {
      /**
       * Tries to copy an object by duplicating every property
       * @param source defines the source object
       * @param destination defines the target object
       * @param doNotCopyList defines a list of properties to avoid
       * @param mustCopyList defines a list of properties to copy (even if they start with _)
       * @param shallowCopyValues defines wether properties referencing objects (none cloneable) must be shallow copied (false by default)
       * @remarks shallowCopyValues will not instantite the copied values which makes it only usable for "JSON objects"
       */
      static DeepCopy(source, destination, doNotCopyList, mustCopyList, shallowCopyValues = false) {
        const properties = GetAllPropertyNames(source);
        for (const prop of properties) {
          if (prop[0] === "_" && (!mustCopyList || mustCopyList.indexOf(prop) === -1)) {
            continue;
          }
          if (prop.endsWith("Observable")) {
            continue;
          }
          if (doNotCopyList && doNotCopyList.indexOf(prop) !== -1) {
            continue;
          }
          const sourceValue = source[prop];
          const typeOfSourceValue = typeof sourceValue;
          if (typeOfSourceValue === "function") {
            continue;
          }
          try {
            if (typeOfSourceValue === "object") {
              if (sourceValue instanceof Uint8Array) {
                destination[prop] = Uint8Array.from(sourceValue);
              } else if (sourceValue instanceof Array) {
                destination[prop] = [];
                if (sourceValue.length > 0) {
                  if (typeof sourceValue[0] == "object") {
                    for (let index = 0; index < sourceValue.length; index++) {
                      const clonedValue = CloneValue(sourceValue[index], destination, shallowCopyValues);
                      if (destination[prop].indexOf(clonedValue) === -1) {
                        destination[prop].push(clonedValue);
                      }
                    }
                  } else {
                    destination[prop] = sourceValue.slice(0);
                  }
                }
              } else {
                destination[prop] = CloneValue(sourceValue, destination, shallowCopyValues);
              }
            } else {
              destination[prop] = sourceValue;
            }
          } catch (e) {
            Logger.Warn(e.message);
          }
        }
      }
    };
  }
});

// node_modules/@babylonjs/core/Misc/precisionDate.js
var PrecisionDate;
var init_precisionDate = __esm({
  "node_modules/@babylonjs/core/Misc/precisionDate.js"() {
    "use strict";
    init_domManagement();
    PrecisionDate = class {
      /**
       * Gets either window.performance.now() if supported or Date.now() else
       */
      static get Now() {
        if (IsWindowObjectExist() && window.performance && window.performance.now) {
          return window.performance.now();
        }
        return Date.now();
      }
    };
  }
});

// node_modules/@babylonjs/core/Misc/webRequest.js
function createXMLHttpRequest() {
  if (typeof _native !== "undefined" && _native.XMLHttpRequest) {
    return new _native.XMLHttpRequest();
  } else {
    return new XMLHttpRequest();
  }
}
var WebRequest;
var init_webRequest = __esm({
  "node_modules/@babylonjs/core/Misc/webRequest.js"() {
    "use strict";
    WebRequest = class _WebRequest {
      constructor() {
        this._xhr = createXMLHttpRequest();
        this._requestURL = "";
      }
      /**
       * This function can be called to check if there are request modifiers for network requests
       * @returns true if there are any custom requests available
       */
      static get IsCustomRequestAvailable() {
        return Object.keys(_WebRequest.CustomRequestHeaders).length > 0 || _WebRequest.CustomRequestModifiers.length > 0;
      }
      _injectCustomRequestHeaders() {
        if (this._shouldSkipRequestModifications(this._requestURL)) {
          return;
        }
        for (const key in _WebRequest.CustomRequestHeaders) {
          const val = _WebRequest.CustomRequestHeaders[key];
          if (val) {
            this._xhr.setRequestHeader(key, val);
          }
        }
      }
      _shouldSkipRequestModifications(url) {
        return _WebRequest.SkipRequestModificationForBabylonCDN && (url.includes("preview.babylonjs.com") || url.includes("cdn.babylonjs.com"));
      }
      /**
       * Gets or sets a function to be called when loading progress changes
       */
      get onprogress() {
        return this._xhr.onprogress;
      }
      set onprogress(value) {
        this._xhr.onprogress = value;
      }
      /**
       * Returns client's state
       */
      get readyState() {
        return this._xhr.readyState;
      }
      /**
       * Returns client's status
       */
      get status() {
        return this._xhr.status;
      }
      /**
       * Returns client's status as a text
       */
      get statusText() {
        return this._xhr.statusText;
      }
      /**
       * Returns client's response
       */
      get response() {
        return this._xhr.response;
      }
      /**
       * Returns client's response url
       */
      get responseURL() {
        return this._xhr.responseURL;
      }
      /**
       * Returns client's response as text
       */
      get responseText() {
        return this._xhr.responseText;
      }
      /**
       * Gets or sets the expected response type
       */
      get responseType() {
        return this._xhr.responseType;
      }
      set responseType(value) {
        this._xhr.responseType = value;
      }
      /**
       * Gets or sets the timeout value in milliseconds
       */
      get timeout() {
        return this._xhr.timeout;
      }
      set timeout(value) {
        this._xhr.timeout = value;
      }
      addEventListener(type, listener, options) {
        this._xhr.addEventListener(type, listener, options);
      }
      removeEventListener(type, listener, options) {
        this._xhr.removeEventListener(type, listener, options);
      }
      /**
       * Cancels any network activity
       */
      abort() {
        this._xhr.abort();
      }
      /**
       * Initiates the request. The optional argument provides the request body. The argument is ignored if request method is GET or HEAD
       * @param body defines an optional request body
       */
      send(body) {
        if (_WebRequest.CustomRequestHeaders) {
          this._injectCustomRequestHeaders();
        }
        this._xhr.send(body);
      }
      /**
       * Sets the request method, request URL
       * @param method defines the method to use (GET, POST, etc..)
       * @param url defines the url to connect with
       */
      open(method, url) {
        for (const update of _WebRequest.CustomRequestModifiers) {
          if (this._shouldSkipRequestModifications(url)) {
            return;
          }
          update(this._xhr, url);
        }
        url = url.replace("file:http:", "http:");
        url = url.replace("file:https:", "https:");
        this._requestURL = url;
        this._xhr.open(method, url, true);
      }
      /**
       * Sets the value of a request header.
       * @param name The name of the header whose value is to be set
       * @param value The value to set as the body of the header
       */
      setRequestHeader(name2, value) {
        this._xhr.setRequestHeader(name2, value);
      }
      /**
       * Get the string containing the text of a particular header's value.
       * @param name The name of the header
       * @returns The string containing the text of the given header name
       */
      getResponseHeader(name2) {
        return this._xhr.getResponseHeader(name2);
      }
    };
    WebRequest.CustomRequestHeaders = {};
    WebRequest.CustomRequestModifiers = new Array();
    WebRequest.SkipRequestModificationForBabylonCDN = true;
  }
});

// node_modules/@babylonjs/core/Misc/filesInputStore.js
var FilesInputStore;
var init_filesInputStore = __esm({
  "node_modules/@babylonjs/core/Misc/filesInputStore.js"() {
    "use strict";
    FilesInputStore = class {
    };
    FilesInputStore.FilesToLoad = {};
  }
});

// node_modules/@babylonjs/core/Misc/retryStrategy.js
var RetryStrategy;
var init_retryStrategy = __esm({
  "node_modules/@babylonjs/core/Misc/retryStrategy.js"() {
    "use strict";
    RetryStrategy = class {
      /**
       * Function used to defines an exponential back off strategy
       * @param maxRetries defines the maximum number of retries (3 by default)
       * @param baseInterval defines the interval between retries
       * @returns the strategy function to use
       */
      static ExponentialBackoff(maxRetries = 3, baseInterval = 500) {
        return (url, request, retryIndex) => {
          if (request.status !== 0 || retryIndex >= maxRetries || url.indexOf("file:") !== -1) {
            return -1;
          }
          return Math.pow(2, retryIndex) * baseInterval;
        };
      }
    };
  }
});

// node_modules/@babylonjs/core/Misc/error.js
var BaseError, ErrorCodes, RuntimeError;
var init_error = __esm({
  "node_modules/@babylonjs/core/Misc/error.js"() {
    "use strict";
    BaseError = class extends Error {
    };
    BaseError._setPrototypeOf = Object.setPrototypeOf || ((o, proto) => {
      o.__proto__ = proto;
      return o;
    });
    ErrorCodes = {
      // Mesh errors 0-999
      /** Invalid or empty mesh vertex positions. */
      MeshInvalidPositionsError: 0,
      // Texture errors 1000-1999
      /** Unsupported texture found. */
      UnsupportedTextureError: 1e3,
      // GLTFLoader errors 2000-2999
      /** Unexpected magic number found in GLTF file header. */
      GLTFLoaderUnexpectedMagicError: 2e3,
      // SceneLoader errors 3000-3999
      /** SceneLoader generic error code. Ideally wraps the inner exception. */
      SceneLoaderError: 3e3,
      // File related errors 4000-4999
      /** Load file error */
      LoadFileError: 4e3,
      /** Request file error */
      RequestFileError: 4001,
      /** Read file error */
      ReadFileError: 4002
    };
    RuntimeError = class _RuntimeError extends BaseError {
      /**
       * Creates a new RuntimeError
       * @param message defines the message of the error
       * @param errorCode the error code
       * @param innerError the error that caused the outer error
       */
      constructor(message, errorCode, innerError) {
        super(message);
        this.errorCode = errorCode;
        this.innerError = innerError;
        this.name = "RuntimeError";
        BaseError._setPrototypeOf(this, _RuntimeError.prototype);
      }
    };
  }
});

// node_modules/@babylonjs/core/Misc/stringTools.js
var EndsWith, StartsWith, Decode, EncodeArrayBufferToBase64, DecodeBase64ToString, DecodeBase64ToBinary, PadNumber, StringTools;
var init_stringTools = __esm({
  "node_modules/@babylonjs/core/Misc/stringTools.js"() {
    "use strict";
    EndsWith = (str, suffix) => {
      return str.endsWith(suffix);
    };
    StartsWith = (str, suffix) => {
      if (!str) {
        return false;
      }
      return str.startsWith(suffix);
    };
    Decode = (buffer) => {
      if (typeof TextDecoder !== "undefined") {
        return new TextDecoder().decode(buffer);
      }
      let result = "";
      for (let i = 0; i < buffer.byteLength; i++) {
        result += String.fromCharCode(buffer[i]);
      }
      return result;
    };
    EncodeArrayBufferToBase64 = (buffer) => {
      const keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
      let output = "";
      let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
      let i = 0;
      const bytes = ArrayBuffer.isView(buffer) ? new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength) : new Uint8Array(buffer);
      while (i < bytes.length) {
        chr1 = bytes[i++];
        chr2 = i < bytes.length ? bytes[i++] : Number.NaN;
        chr3 = i < bytes.length ? bytes[i++] : Number.NaN;
        enc1 = chr1 >> 2;
        enc2 = (chr1 & 3) << 4 | chr2 >> 4;
        enc3 = (chr2 & 15) << 2 | chr3 >> 6;
        enc4 = chr3 & 63;
        if (isNaN(chr2)) {
          enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
          enc4 = 64;
        }
        output += keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
      }
      return output;
    };
    DecodeBase64ToString = (base64Data) => {
      return atob(base64Data);
    };
    DecodeBase64ToBinary = (base64Data) => {
      const decodedString = DecodeBase64ToString(base64Data);
      const bufferLength = decodedString.length;
      const bufferView = new Uint8Array(new ArrayBuffer(bufferLength));
      for (let i = 0; i < bufferLength; i++) {
        bufferView[i] = decodedString.charCodeAt(i);
      }
      return bufferView.buffer;
    };
    PadNumber = (num, length) => {
      let str = String(num);
      while (str.length < length) {
        str = "0" + str;
      }
      return str;
    };
    StringTools = {
      EndsWith,
      StartsWith,
      Decode,
      EncodeArrayBufferToBase64,
      DecodeBase64ToString,
      DecodeBase64ToBinary,
      PadNumber
    };
  }
});

// node_modules/@babylonjs/core/Misc/timingTools.js
var TimingTools;
var init_timingTools = __esm({
  "node_modules/@babylonjs/core/Misc/timingTools.js"() {
    "use strict";
    init_domManagement();
    TimingTools = class {
      /**
       * Polyfill for setImmediate
       * @param action defines the action to execute after the current execution block
       */
      static SetImmediate(action) {
        if (IsWindowObjectExist() && window.setImmediate) {
          window.setImmediate(action);
        } else {
          setTimeout(action, 1);
        }
      }
    };
  }
});

// node_modules/@babylonjs/core/States/depthCullingState.js
var DepthCullingState;
var init_depthCullingState = __esm({
  "node_modules/@babylonjs/core/States/depthCullingState.js"() {
    "use strict";
    DepthCullingState = class {
      /**
       * Initializes the state.
       * @param reset
       */
      constructor(reset = true) {
        this._isDepthTestDirty = false;
        this._isDepthMaskDirty = false;
        this._isDepthFuncDirty = false;
        this._isCullFaceDirty = false;
        this._isCullDirty = false;
        this._isZOffsetDirty = false;
        this._isFrontFaceDirty = false;
        if (reset) {
          this.reset();
        }
      }
      get isDirty() {
        return this._isDepthFuncDirty || this._isDepthTestDirty || this._isDepthMaskDirty || this._isCullFaceDirty || this._isCullDirty || this._isZOffsetDirty || this._isFrontFaceDirty;
      }
      get zOffset() {
        return this._zOffset;
      }
      set zOffset(value) {
        if (this._zOffset === value) {
          return;
        }
        this._zOffset = value;
        this._isZOffsetDirty = true;
      }
      get zOffsetUnits() {
        return this._zOffsetUnits;
      }
      set zOffsetUnits(value) {
        if (this._zOffsetUnits === value) {
          return;
        }
        this._zOffsetUnits = value;
        this._isZOffsetDirty = true;
      }
      get cullFace() {
        return this._cullFace;
      }
      set cullFace(value) {
        if (this._cullFace === value) {
          return;
        }
        this._cullFace = value;
        this._isCullFaceDirty = true;
      }
      get cull() {
        return this._cull;
      }
      set cull(value) {
        if (this._cull === value) {
          return;
        }
        this._cull = value;
        this._isCullDirty = true;
      }
      get depthFunc() {
        return this._depthFunc;
      }
      set depthFunc(value) {
        if (this._depthFunc === value) {
          return;
        }
        this._depthFunc = value;
        this._isDepthFuncDirty = true;
      }
      get depthMask() {
        return this._depthMask;
      }
      set depthMask(value) {
        if (this._depthMask === value) {
          return;
        }
        this._depthMask = value;
        this._isDepthMaskDirty = true;
      }
      get depthTest() {
        return this._depthTest;
      }
      set depthTest(value) {
        if (this._depthTest === value) {
          return;
        }
        this._depthTest = value;
        this._isDepthTestDirty = true;
      }
      get frontFace() {
        return this._frontFace;
      }
      set frontFace(value) {
        if (this._frontFace === value) {
          return;
        }
        this._frontFace = value;
        this._isFrontFaceDirty = true;
      }
      reset() {
        this._depthMask = true;
        this._depthTest = true;
        this._depthFunc = null;
        this._cullFace = null;
        this._cull = null;
        this._zOffset = 0;
        this._zOffsetUnits = 0;
        this._frontFace = null;
        this._isDepthTestDirty = true;
        this._isDepthMaskDirty = true;
        this._isDepthFuncDirty = false;
        this._isCullFaceDirty = false;
        this._isCullDirty = false;
        this._isZOffsetDirty = true;
        this._isFrontFaceDirty = false;
      }
      apply(gl) {
        if (!this.isDirty) {
          return;
        }
        if (this._isCullDirty) {
          if (this.cull) {
            gl.enable(gl.CULL_FACE);
          } else {
            gl.disable(gl.CULL_FACE);
          }
          this._isCullDirty = false;
        }
        if (this._isCullFaceDirty) {
          gl.cullFace(this.cullFace);
          this._isCullFaceDirty = false;
        }
        if (this._isDepthMaskDirty) {
          gl.depthMask(this.depthMask);
          this._isDepthMaskDirty = false;
        }
        if (this._isDepthTestDirty) {
          if (this.depthTest) {
            gl.enable(gl.DEPTH_TEST);
          } else {
            gl.disable(gl.DEPTH_TEST);
          }
          this._isDepthTestDirty = false;
        }
        if (this._isDepthFuncDirty) {
          gl.depthFunc(this.depthFunc);
          this._isDepthFuncDirty = false;
        }
        if (this._isZOffsetDirty) {
          if (this.zOffset || this.zOffsetUnits) {
            gl.enable(gl.POLYGON_OFFSET_FILL);
            gl.polygonOffset(this.zOffset, this.zOffsetUnits);
          } else {
            gl.disable(gl.POLYGON_OFFSET_FILL);
          }
          this._isZOffsetDirty = false;
        }
        if (this._isFrontFaceDirty) {
          gl.frontFace(this.frontFace);
          this._isFrontFaceDirty = false;
        }
      }
    };
  }
});

// node_modules/@babylonjs/core/States/stencilStateComposer.js
var StencilStateComposer;
var init_stencilStateComposer = __esm({
  "node_modules/@babylonjs/core/States/stencilStateComposer.js"() {
    "use strict";
    StencilStateComposer = class {
      get isDirty() {
        return this._isStencilTestDirty || this._isStencilMaskDirty || this._isStencilFuncDirty || this._isStencilOpDirty;
      }
      get func() {
        return this._func;
      }
      set func(value) {
        if (this._func === value) {
          return;
        }
        this._func = value;
        this._isStencilFuncDirty = true;
      }
      get funcRef() {
        return this._funcRef;
      }
      set funcRef(value) {
        if (this._funcRef === value) {
          return;
        }
        this._funcRef = value;
        this._isStencilFuncDirty = true;
      }
      get funcMask() {
        return this._funcMask;
      }
      set funcMask(value) {
        if (this._funcMask === value) {
          return;
        }
        this._funcMask = value;
        this._isStencilFuncDirty = true;
      }
      get opStencilFail() {
        return this._opStencilFail;
      }
      set opStencilFail(value) {
        if (this._opStencilFail === value) {
          return;
        }
        this._opStencilFail = value;
        this._isStencilOpDirty = true;
      }
      get opDepthFail() {
        return this._opDepthFail;
      }
      set opDepthFail(value) {
        if (this._opDepthFail === value) {
          return;
        }
        this._opDepthFail = value;
        this._isStencilOpDirty = true;
      }
      get opStencilDepthPass() {
        return this._opStencilDepthPass;
      }
      set opStencilDepthPass(value) {
        if (this._opStencilDepthPass === value) {
          return;
        }
        this._opStencilDepthPass = value;
        this._isStencilOpDirty = true;
      }
      get mask() {
        return this._mask;
      }
      set mask(value) {
        if (this._mask === value) {
          return;
        }
        this._mask = value;
        this._isStencilMaskDirty = true;
      }
      get enabled() {
        return this._enabled;
      }
      set enabled(value) {
        if (this._enabled === value) {
          return;
        }
        this._enabled = value;
        this._isStencilTestDirty = true;
      }
      constructor(reset = true) {
        this._isStencilTestDirty = false;
        this._isStencilMaskDirty = false;
        this._isStencilFuncDirty = false;
        this._isStencilOpDirty = false;
        this.useStencilGlobalOnly = false;
        if (reset) {
          this.reset();
        }
      }
      reset() {
        var _a;
        this.stencilMaterial = void 0;
        (_a = this.stencilGlobal) == null ? void 0 : _a.reset();
        this._isStencilTestDirty = true;
        this._isStencilMaskDirty = true;
        this._isStencilFuncDirty = true;
        this._isStencilOpDirty = true;
      }
      apply(gl) {
        var _a;
        if (!gl) {
          return;
        }
        const stencilMaterialEnabled = !this.useStencilGlobalOnly && !!((_a = this.stencilMaterial) == null ? void 0 : _a.enabled);
        this.enabled = stencilMaterialEnabled ? this.stencilMaterial.enabled : this.stencilGlobal.enabled;
        this.func = stencilMaterialEnabled ? this.stencilMaterial.func : this.stencilGlobal.func;
        this.funcRef = stencilMaterialEnabled ? this.stencilMaterial.funcRef : this.stencilGlobal.funcRef;
        this.funcMask = stencilMaterialEnabled ? this.stencilMaterial.funcMask : this.stencilGlobal.funcMask;
        this.opStencilFail = stencilMaterialEnabled ? this.stencilMaterial.opStencilFail : this.stencilGlobal.opStencilFail;
        this.opDepthFail = stencilMaterialEnabled ? this.stencilMaterial.opDepthFail : this.stencilGlobal.opDepthFail;
        this.opStencilDepthPass = stencilMaterialEnabled ? this.stencilMaterial.opStencilDepthPass : this.stencilGlobal.opStencilDepthPass;
        this.mask = stencilMaterialEnabled ? this.stencilMaterial.mask : this.stencilGlobal.mask;
        if (!this.isDirty) {
          return;
        }
        if (this._isStencilTestDirty) {
          if (this.enabled) {
            gl.enable(gl.STENCIL_TEST);
          } else {
            gl.disable(gl.STENCIL_TEST);
          }
          this._isStencilTestDirty = false;
        }
        if (this._isStencilMaskDirty) {
          gl.stencilMask(this.mask);
          this._isStencilMaskDirty = false;
        }
        if (this._isStencilFuncDirty) {
          gl.stencilFunc(this.func, this.funcRef, this.funcMask);
          this._isStencilFuncDirty = false;
        }
        if (this._isStencilOpDirty) {
          gl.stencilOp(this.opStencilFail, this.opDepthFail, this.opStencilDepthPass);
          this._isStencilOpDirty = false;
        }
      }
    };
  }
});

// node_modules/@babylonjs/core/States/stencilState.js
var StencilState;
var init_stencilState = __esm({
  "node_modules/@babylonjs/core/States/stencilState.js"() {
    "use strict";
    StencilState = class _StencilState {
      constructor() {
        this.reset();
      }
      reset() {
        this.enabled = false;
        this.mask = 255;
        this.func = _StencilState.ALWAYS;
        this.funcRef = 1;
        this.funcMask = 255;
        this.opStencilFail = _StencilState.KEEP;
        this.opDepthFail = _StencilState.KEEP;
        this.opStencilDepthPass = _StencilState.REPLACE;
      }
      get stencilFunc() {
        return this.func;
      }
      set stencilFunc(value) {
        this.func = value;
      }
      get stencilFuncRef() {
        return this.funcRef;
      }
      set stencilFuncRef(value) {
        this.funcRef = value;
      }
      get stencilFuncMask() {
        return this.funcMask;
      }
      set stencilFuncMask(value) {
        this.funcMask = value;
      }
      get stencilOpStencilFail() {
        return this.opStencilFail;
      }
      set stencilOpStencilFail(value) {
        this.opStencilFail = value;
      }
      get stencilOpDepthFail() {
        return this.opDepthFail;
      }
      set stencilOpDepthFail(value) {
        this.opDepthFail = value;
      }
      get stencilOpStencilDepthPass() {
        return this.opStencilDepthPass;
      }
      set stencilOpStencilDepthPass(value) {
        this.opStencilDepthPass = value;
      }
      get stencilMask() {
        return this.mask;
      }
      set stencilMask(value) {
        this.mask = value;
      }
      get stencilTest() {
        return this.enabled;
      }
      set stencilTest(value) {
        this.enabled = value;
      }
    };
    StencilState.ALWAYS = 519;
    StencilState.KEEP = 7680;
    StencilState.REPLACE = 7681;
  }
});

// node_modules/@babylonjs/core/States/alphaCullingState.js
var AlphaState;
var init_alphaCullingState = __esm({
  "node_modules/@babylonjs/core/States/alphaCullingState.js"() {
    "use strict";
    AlphaState = class {
      /**
       * Initializes the state.
       */
      constructor() {
        this._blendFunctionParameters = new Array(4);
        this._blendEquationParameters = new Array(2);
        this._blendConstants = new Array(4);
        this._isBlendConstantsDirty = false;
        this._alphaBlend = false;
        this._isAlphaBlendDirty = false;
        this._isBlendFunctionParametersDirty = false;
        this._isBlendEquationParametersDirty = false;
        this.reset();
      }
      get isDirty() {
        return this._isAlphaBlendDirty || this._isBlendFunctionParametersDirty || this._isBlendEquationParametersDirty;
      }
      get alphaBlend() {
        return this._alphaBlend;
      }
      set alphaBlend(value) {
        if (this._alphaBlend === value) {
          return;
        }
        this._alphaBlend = value;
        this._isAlphaBlendDirty = true;
      }
      setAlphaBlendConstants(r, g, b, a) {
        if (this._blendConstants[0] === r && this._blendConstants[1] === g && this._blendConstants[2] === b && this._blendConstants[3] === a) {
          return;
        }
        this._blendConstants[0] = r;
        this._blendConstants[1] = g;
        this._blendConstants[2] = b;
        this._blendConstants[3] = a;
        this._isBlendConstantsDirty = true;
      }
      setAlphaBlendFunctionParameters(value0, value1, value2, value3) {
        if (this._blendFunctionParameters[0] === value0 && this._blendFunctionParameters[1] === value1 && this._blendFunctionParameters[2] === value2 && this._blendFunctionParameters[3] === value3) {
          return;
        }
        this._blendFunctionParameters[0] = value0;
        this._blendFunctionParameters[1] = value1;
        this._blendFunctionParameters[2] = value2;
        this._blendFunctionParameters[3] = value3;
        this._isBlendFunctionParametersDirty = true;
      }
      setAlphaEquationParameters(rgb, alpha) {
        if (this._blendEquationParameters[0] === rgb && this._blendEquationParameters[1] === alpha) {
          return;
        }
        this._blendEquationParameters[0] = rgb;
        this._blendEquationParameters[1] = alpha;
        this._isBlendEquationParametersDirty = true;
      }
      reset() {
        this._alphaBlend = false;
        this._blendFunctionParameters[0] = null;
        this._blendFunctionParameters[1] = null;
        this._blendFunctionParameters[2] = null;
        this._blendFunctionParameters[3] = null;
        this._blendEquationParameters[0] = null;
        this._blendEquationParameters[1] = null;
        this._blendConstants[0] = null;
        this._blendConstants[1] = null;
        this._blendConstants[2] = null;
        this._blendConstants[3] = null;
        this._isAlphaBlendDirty = true;
        this._isBlendFunctionParametersDirty = false;
        this._isBlendEquationParametersDirty = false;
        this._isBlendConstantsDirty = false;
      }
      apply(gl) {
        if (!this.isDirty) {
          return;
        }
        if (this._isAlphaBlendDirty) {
          if (this._alphaBlend) {
            gl.enable(gl.BLEND);
          } else {
            gl.disable(gl.BLEND);
          }
          this._isAlphaBlendDirty = false;
        }
        if (this._isBlendFunctionParametersDirty) {
          gl.blendFuncSeparate(this._blendFunctionParameters[0], this._blendFunctionParameters[1], this._blendFunctionParameters[2], this._blendFunctionParameters[3]);
          this._isBlendFunctionParametersDirty = false;
        }
        if (this._isBlendEquationParametersDirty) {
          gl.blendEquationSeparate(this._blendEquationParameters[0], this._blendEquationParameters[1]);
          this._isBlendEquationParametersDirty = false;
        }
        if (this._isBlendConstantsDirty) {
          gl.blendColor(this._blendConstants[0], this._blendConstants[1], this._blendConstants[2], this._blendConstants[3]);
          this._isBlendConstantsDirty = false;
        }
      }
    };
  }
});

// node_modules/@babylonjs/core/Materials/Textures/textureSampler.js
var TextureSampler;
var init_textureSampler = __esm({
  "node_modules/@babylonjs/core/Materials/Textures/textureSampler.js"() {
    "use strict";
    TextureSampler = class {
      /**
       * | Value | Type               | Description |
       * | ----- | ------------------ | ----------- |
       * | 0     | CLAMP_ADDRESSMODE  |             |
       * | 1     | WRAP_ADDRESSMODE   |             |
       * | 2     | MIRROR_ADDRESSMODE |             |
       */
      get wrapU() {
        return this._cachedWrapU;
      }
      set wrapU(value) {
        this._cachedWrapU = value;
      }
      /**
       * | Value | Type               | Description |
       * | ----- | ------------------ | ----------- |
       * | 0     | CLAMP_ADDRESSMODE  |             |
       * | 1     | WRAP_ADDRESSMODE   |             |
       * | 2     | MIRROR_ADDRESSMODE |             |
       */
      get wrapV() {
        return this._cachedWrapV;
      }
      set wrapV(value) {
        this._cachedWrapV = value;
      }
      /**
       * | Value | Type               | Description |
       * | ----- | ------------------ | ----------- |
       * | 0     | CLAMP_ADDRESSMODE  |             |
       * | 1     | WRAP_ADDRESSMODE   |             |
       * | 2     | MIRROR_ADDRESSMODE |             |
       */
      get wrapR() {
        return this._cachedWrapR;
      }
      set wrapR(value) {
        this._cachedWrapR = value;
      }
      /**
       * With compliant hardware and browser (supporting anisotropic filtering)
       * this defines the level of anisotropic filtering in the texture.
       * The higher the better but the slower.
       */
      get anisotropicFilteringLevel() {
        return this._cachedAnisotropicFilteringLevel;
      }
      set anisotropicFilteringLevel(value) {
        this._cachedAnisotropicFilteringLevel = value;
      }
      /**
       * Gets or sets the comparison function (513, 514, etc). Set 0 to not use a comparison function
       */
      get comparisonFunction() {
        return this._comparisonFunction;
      }
      set comparisonFunction(value) {
        this._comparisonFunction = value;
      }
      /**
       * Indicates to use the mip maps (if available on the texture).
       * Thanks to this flag, you can instruct the sampler to not sample the mipmaps even if they exist (and if the sampling mode is set to a value that normally samples the mipmaps!)
       */
      get useMipMaps() {
        return this._useMipMaps;
      }
      set useMipMaps(value) {
        this._useMipMaps = value;
      }
      /**
       * Creates a Sampler instance
       */
      constructor() {
        this.samplingMode = -1;
        this._useMipMaps = true;
        this._cachedWrapU = null;
        this._cachedWrapV = null;
        this._cachedWrapR = null;
        this._cachedAnisotropicFilteringLevel = null;
        this._comparisonFunction = 0;
      }
      /**
       * Sets all the parameters of the sampler
       * @param wrapU u address mode (default: TEXTURE_WRAP_ADDRESSMODE)
       * @param wrapV v address mode (default: TEXTURE_WRAP_ADDRESSMODE)
       * @param wrapR r address mode (default: TEXTURE_WRAP_ADDRESSMODE)
       * @param anisotropicFilteringLevel anisotropic level (default: 1)
       * @param samplingMode sampling mode (default: 2)
       * @param comparisonFunction comparison function (default: 0 - no comparison function)
       * @returns the current sampler instance
       */
      setParameters(wrapU = 1, wrapV = 1, wrapR = 1, anisotropicFilteringLevel = 1, samplingMode = 2, comparisonFunction = 0) {
        this._cachedWrapU = wrapU;
        this._cachedWrapV = wrapV;
        this._cachedWrapR = wrapR;
        this._cachedAnisotropicFilteringLevel = anisotropicFilteringLevel;
        this.samplingMode = samplingMode;
        this._comparisonFunction = comparisonFunction;
        return this;
      }
      /**
       * Compares this sampler with another one
       * @param other sampler to compare with
       * @returns true if the samplers have the same parametres, else false
       */
      compareSampler(other) {
        return this._cachedWrapU === other._cachedWrapU && this._cachedWrapV === other._cachedWrapV && this._cachedWrapR === other._cachedWrapR && this._cachedAnisotropicFilteringLevel === other._cachedAnisotropicFilteringLevel && this.samplingMode === other.samplingMode && this._comparisonFunction === other._comparisonFunction && this._useMipMaps === other._useMipMaps;
      }
    };
  }
});

// node_modules/@babylonjs/core/Materials/Textures/internalTexture.js
var InternalTextureSource, InternalTexture;
var init_internalTexture = __esm({
  "node_modules/@babylonjs/core/Materials/Textures/internalTexture.js"() {
    "use strict";
    init_observable();
    init_textureSampler();
    (function(InternalTextureSource2) {
      InternalTextureSource2[InternalTextureSource2["Unknown"] = 0] = "Unknown";
      InternalTextureSource2[InternalTextureSource2["Url"] = 1] = "Url";
      InternalTextureSource2[InternalTextureSource2["Temp"] = 2] = "Temp";
      InternalTextureSource2[InternalTextureSource2["Raw"] = 3] = "Raw";
      InternalTextureSource2[InternalTextureSource2["Dynamic"] = 4] = "Dynamic";
      InternalTextureSource2[InternalTextureSource2["RenderTarget"] = 5] = "RenderTarget";
      InternalTextureSource2[InternalTextureSource2["MultiRenderTarget"] = 6] = "MultiRenderTarget";
      InternalTextureSource2[InternalTextureSource2["Cube"] = 7] = "Cube";
      InternalTextureSource2[InternalTextureSource2["CubeRaw"] = 8] = "CubeRaw";
      InternalTextureSource2[InternalTextureSource2["CubePrefiltered"] = 9] = "CubePrefiltered";
      InternalTextureSource2[InternalTextureSource2["Raw3D"] = 10] = "Raw3D";
      InternalTextureSource2[InternalTextureSource2["Raw2DArray"] = 11] = "Raw2DArray";
      InternalTextureSource2[InternalTextureSource2["DepthStencil"] = 12] = "DepthStencil";
      InternalTextureSource2[InternalTextureSource2["CubeRawRGBD"] = 13] = "CubeRawRGBD";
      InternalTextureSource2[InternalTextureSource2["Depth"] = 14] = "Depth";
    })(InternalTextureSource || (InternalTextureSource = {}));
    InternalTexture = class _InternalTexture extends TextureSampler {
      /**
       * Gets a boolean indicating if the texture uses mipmaps
       * TODO implements useMipMaps as a separate setting from generateMipMaps
       */
      get useMipMaps() {
        return this.generateMipMaps;
      }
      set useMipMaps(value) {
        this.generateMipMaps = value;
      }
      /** Gets the unique id of the internal texture */
      get uniqueId() {
        return this._uniqueId;
      }
      /** @internal */
      _setUniqueId(id) {
        this._uniqueId = id;
      }
      /**
       * Gets the Engine the texture belongs to.
       * @returns The babylon engine
       */
      getEngine() {
        return this._engine;
      }
      /**
       * Gets the data source type of the texture
       */
      get source() {
        return this._source;
      }
      /**
       * Creates a new InternalTexture
       * @param engine defines the engine to use
       * @param source defines the type of data that will be used
       * @param delayAllocation if the texture allocation should be delayed (default: false)
       */
      constructor(engine, source, delayAllocation = false) {
        super();
        this.isReady = false;
        this.isCube = false;
        this.is3D = false;
        this.is2DArray = false;
        this.isMultiview = false;
        this.url = "";
        this.generateMipMaps = false;
        this.samples = 0;
        this.type = -1;
        this.format = -1;
        this.onLoadedObservable = new Observable();
        this.onErrorObservable = new Observable();
        this.onRebuildCallback = null;
        this.width = 0;
        this.height = 0;
        this.depth = 0;
        this.baseWidth = 0;
        this.baseHeight = 0;
        this.baseDepth = 0;
        this.invertY = false;
        this._invertVScale = false;
        this._associatedChannel = -1;
        this._source = 0;
        this._buffer = null;
        this._bufferView = null;
        this._bufferViewArray = null;
        this._bufferViewArrayArray = null;
        this._size = 0;
        this._extension = "";
        this._files = null;
        this._workingCanvas = null;
        this._workingContext = null;
        this._cachedCoordinatesMode = null;
        this._isDisabled = false;
        this._compression = null;
        this._sphericalPolynomial = null;
        this._sphericalPolynomialPromise = null;
        this._sphericalPolynomialComputed = false;
        this._lodGenerationScale = 0;
        this._lodGenerationOffset = 0;
        this._useSRGBBuffer = false;
        this._creationFlags = 0;
        this._lodTextureHigh = null;
        this._lodTextureMid = null;
        this._lodTextureLow = null;
        this._isRGBD = false;
        this._linearSpecularLOD = false;
        this._irradianceTexture = null;
        this._hardwareTexture = null;
        this._maxLodLevel = null;
        this._references = 1;
        this._gammaSpace = null;
        this._premulAlpha = false;
        this._dynamicTextureSource = null;
        this._engine = engine;
        this._source = source;
        this._uniqueId = _InternalTexture._Counter++;
        if (!delayAllocation) {
          this._hardwareTexture = engine._createHardwareTexture();
        }
      }
      /**
       * Increments the number of references (ie. the number of Texture that point to it)
       */
      incrementReferences() {
        this._references++;
      }
      /**
       * Change the size of the texture (not the size of the content)
       * @param width defines the new width
       * @param height defines the new height
       * @param depth defines the new depth (1 by default)
       */
      updateSize(width, height, depth = 1) {
        this._engine.updateTextureDimensions(this, width, height, depth);
        this.width = width;
        this.height = height;
        this.depth = depth;
        this.baseWidth = width;
        this.baseHeight = height;
        this.baseDepth = depth;
        this._size = width * height * depth;
      }
      /** @internal */
      _rebuild() {
        var _a, _b;
        this.isReady = false;
        this._cachedCoordinatesMode = null;
        this._cachedWrapU = null;
        this._cachedWrapV = null;
        this._cachedWrapR = null;
        this._cachedAnisotropicFilteringLevel = null;
        if (this.onRebuildCallback) {
          const data = this.onRebuildCallback(this);
          const swapAndSetIsReady = (proxyInternalTexture) => {
            proxyInternalTexture._swapAndDie(this, false);
            this.isReady = data.isReady;
          };
          if (data.isAsync) {
            data.proxy.then(swapAndSetIsReady);
          } else {
            swapAndSetIsReady(data.proxy);
          }
          return;
        }
        let proxy;
        switch (this.source) {
          case 2:
            break;
          case 1:
            proxy = this._engine.createTexture(
              (_a = this._originalUrl) != null ? _a : this.url,
              !this.generateMipMaps,
              this.invertY,
              null,
              this.samplingMode,
              // Do not use Proxy here as it could be fully synchronous
              // and proxy would be undefined.
              (temp) => {
                temp._swapAndDie(this, false);
                this.isReady = true;
              },
              null,
              this._buffer,
              void 0,
              this.format,
              this._extension,
              void 0,
              void 0,
              void 0,
              this._useSRGBBuffer
            );
            return;
          case 3:
            proxy = this._engine.createRawTexture(this._bufferView, this.baseWidth, this.baseHeight, this.format, this.generateMipMaps, this.invertY, this.samplingMode, this._compression, this.type, this._creationFlags, this._useSRGBBuffer);
            proxy._swapAndDie(this, false);
            this.isReady = true;
            break;
          case 10:
            proxy = this._engine.createRawTexture3D(this._bufferView, this.baseWidth, this.baseHeight, this.baseDepth, this.format, this.generateMipMaps, this.invertY, this.samplingMode, this._compression, this.type);
            proxy._swapAndDie(this, false);
            this.isReady = true;
            break;
          case 11:
            proxy = this._engine.createRawTexture2DArray(this._bufferView, this.baseWidth, this.baseHeight, this.baseDepth, this.format, this.generateMipMaps, this.invertY, this.samplingMode, this._compression, this.type);
            proxy._swapAndDie(this, false);
            this.isReady = true;
            break;
          case 4:
            proxy = this._engine.createDynamicTexture(this.baseWidth, this.baseHeight, this.generateMipMaps, this.samplingMode);
            proxy._swapAndDie(this, false);
            if (this._dynamicTextureSource) {
              this._engine.updateDynamicTexture(this, this._dynamicTextureSource, this.invertY, this._premulAlpha, this.format, true);
            }
            break;
          case 7:
            proxy = this._engine.createCubeTexture(this.url, null, this._files, !this.generateMipMaps, () => {
              proxy._swapAndDie(this, false);
              this.isReady = true;
            }, null, this.format, this._extension, false, 0, 0, null, void 0, this._useSRGBBuffer, ArrayBuffer.isView(this._buffer) ? this._buffer : null);
            return;
          case 8:
            proxy = this._engine.createRawCubeTexture(this._bufferViewArray, this.width, (_b = this._originalFormat) != null ? _b : this.format, this.type, this.generateMipMaps, this.invertY, this.samplingMode, this._compression);
            proxy._swapAndDie(this, false);
            this.isReady = true;
            break;
          case 13:
            return;
          case 9:
            proxy = this._engine.createPrefilteredCubeTexture(this.url, null, this._lodGenerationScale, this._lodGenerationOffset, (proxy2) => {
              if (proxy2) {
                proxy2._swapAndDie(this, false);
              }
              this.isReady = true;
            }, null, this.format, this._extension);
            proxy._sphericalPolynomial = this._sphericalPolynomial;
            return;
          case 12:
          case 14: {
            break;
          }
        }
      }
      /**
       * @internal
       */
      _swapAndDie(target, swapAll = true) {
        var _a;
        (_a = this._hardwareTexture) == null ? void 0 : _a.setUsage(target._source, this.generateMipMaps, this.is2DArray, this.isCube, this.is3D, this.width, this.height, this.depth);
        target._hardwareTexture = this._hardwareTexture;
        if (swapAll) {
          target._isRGBD = this._isRGBD;
        }
        if (this._lodTextureHigh) {
          if (target._lodTextureHigh) {
            target._lodTextureHigh.dispose();
          }
          target._lodTextureHigh = this._lodTextureHigh;
        }
        if (this._lodTextureMid) {
          if (target._lodTextureMid) {
            target._lodTextureMid.dispose();
          }
          target._lodTextureMid = this._lodTextureMid;
        }
        if (this._lodTextureLow) {
          if (target._lodTextureLow) {
            target._lodTextureLow.dispose();
          }
          target._lodTextureLow = this._lodTextureLow;
        }
        if (this._irradianceTexture) {
          if (target._irradianceTexture) {
            target._irradianceTexture.dispose();
          }
          target._irradianceTexture = this._irradianceTexture;
        }
        const cache = this._engine.getLoadedTexturesCache();
        let index = cache.indexOf(this);
        if (index !== -1) {
          cache.splice(index, 1);
        }
        index = cache.indexOf(target);
        if (index === -1) {
          cache.push(target);
        }
      }
      /**
       * Dispose the current allocated resources
       */
      dispose() {
        this._references--;
        this.onLoadedObservable.clear();
        this.onErrorObservable.clear();
        if (this._references === 0) {
          this._engine._releaseTexture(this);
          this._hardwareTexture = null;
          this._dynamicTextureSource = null;
        }
      }
    };
    InternalTexture._Counter = 0;
  }
});

// node_modules/@babylonjs/core/Materials/Textures/Loaders/textureLoaderManager.js
function registerTextureLoader(extension, loaderFactory) {
  if (unregisterTextureLoader(extension)) {
    Logger.Warn(`Extension with the name '${name}' already exists`);
  }
  _registeredTextureLoaders.set(extension, loaderFactory);
}
function unregisterTextureLoader(extension) {
  return _registeredTextureLoaders.delete(extension);
}
function _GetCompatibleTextureLoader(extension, mimeType) {
  if (mimeType === "image/ktx" || mimeType === "image/ktx2") {
    extension = ".ktx";
  }
  if (!_registeredTextureLoaders.has(extension)) {
    if (extension.endsWith(".dds")) {
      registerTextureLoader(".dds", () => import("./ddsTextureLoader-E2QPZNGG.mjs").then((module) => new module._DDSTextureLoader()));
    }
    if (extension.endsWith(".basis")) {
      registerTextureLoader(".basis", () => import("./basisTextureLoader-TVZUE6EB.mjs").then((module) => new module._BasisTextureLoader()));
    }
    if (extension.endsWith(".env")) {
      registerTextureLoader(".env", () => import("./envTextureLoader-BSI2OHRI.mjs").then((module) => new module._ENVTextureLoader()));
    }
    if (extension.endsWith(".hdr")) {
      registerTextureLoader(".hdr", () => import("./hdrTextureLoader-E3DK3XL5.mjs").then((module) => new module._HDRTextureLoader()));
    }
    if (extension.endsWith(".ktx") || extension.endsWith(".ktx2")) {
      registerTextureLoader(".ktx", () => import("./ktxTextureLoader-GKPGKJJ5.mjs").then((module) => new module._KTXTextureLoader()));
      registerTextureLoader(".ktx2", () => import("./ktxTextureLoader-GKPGKJJ5.mjs").then((module) => new module._KTXTextureLoader()));
    }
    if (extension.endsWith(".tga")) {
      registerTextureLoader(".tga", () => import("./tgaTextureLoader-YBS6EFZL.mjs").then((module) => new module._TGATextureLoader()));
    }
    if (extension.endsWith(".exr")) {
      registerTextureLoader(".exr", () => import("./exrTextureLoader-DVYHISXX.mjs").then((module) => new module._ExrTextureLoader()));
    }
  }
  const registered = _registeredTextureLoaders.get(extension);
  return registered ? Promise.resolve(registered(mimeType)) : null;
}
var _registeredTextureLoaders;
var init_textureLoaderManager = __esm({
  "node_modules/@babylonjs/core/Materials/Textures/Loaders/textureLoaderManager.js"() {
    "use strict";
    init_logger();
    _registeredTextureLoaders = /* @__PURE__ */ new Map();
  }
});

// node_modules/@babylonjs/core/Engines/abstractEngine.js
function QueueNewFrame(func, requester) {
  if (!IsWindowObjectExist()) {
    if (typeof requestAnimationFrame === "function") {
      return requestAnimationFrame(func);
    }
  } else {
    const { requestAnimationFrame: requestAnimationFrame2 } = requester || window;
    if (typeof requestAnimationFrame2 === "function") {
      return requestAnimationFrame2(func);
    }
  }
  return setTimeout(func, 16);
}
var AbstractEngine;
var init_abstractEngine = __esm({
  "node_modules/@babylonjs/core/Engines/abstractEngine.js"() {
    "use strict";
    init_engineStore();
    init_logger();
    init_effect();
    init_performanceConfigurator();
    init_precisionDate();
    init_depthCullingState();
    init_stencilStateComposer();
    init_stencilState();
    init_alphaCullingState();
    init_devTools();
    init_internalTexture();
    init_domManagement();
    init_observable();
    init_abstractEngine_functions();
    init_textureLoaderManager();
    AbstractEngine = class _AbstractEngine {
      /**
       * Gets the current frame id
       */
      get frameId() {
        return this._frameId;
      }
      /**
       * Gets a boolean indicating if the engine runs in WebGPU or not.
       */
      get isWebGPU() {
        return this._isWebGPU;
      }
      /**
       * @internal
       */
      _getShaderProcessor(shaderLanguage) {
        return this._shaderProcessor;
      }
      /**
       * Gets the shader platform name used by the effects.
       */
      get shaderPlatformName() {
        return this._shaderPlatformName;
      }
      _clearEmptyResources() {
        this._emptyTexture = null;
        this._emptyCubeTexture = null;
        this._emptyTexture3D = null;
        this._emptyTexture2DArray = null;
      }
      /**
       * Gets or sets a boolean indicating if depth buffer should be reverse, going from far to near.
       * This can provide greater z depth for distant objects.
       */
      get useReverseDepthBuffer() {
        return this._useReverseDepthBuffer;
      }
      set useReverseDepthBuffer(useReverse) {
        if (useReverse === this._useReverseDepthBuffer) {
          return;
        }
        this._useReverseDepthBuffer = useReverse;
        if (useReverse) {
          this._depthCullingState.depthFunc = 518;
        } else {
          this._depthCullingState.depthFunc = 515;
        }
      }
      /**
       * Enable or disable color writing
       * @param enable defines the state to set
       */
      setColorWrite(enable) {
        if (enable !== this._colorWrite) {
          this._colorWriteChanged = true;
          this._colorWrite = enable;
        }
      }
      /**
       * Gets a boolean indicating if color writing is enabled
       * @returns the current color writing state
       */
      getColorWrite() {
        return this._colorWrite;
      }
      /**
       * Gets the depth culling state manager
       */
      get depthCullingState() {
        return this._depthCullingState;
      }
      /**
       * Gets the alpha state manager
       */
      get alphaState() {
        return this._alphaState;
      }
      /**
       * Gets the stencil state manager
       */
      get stencilState() {
        return this._stencilState;
      }
      /**
       * Gets the stencil state composer
       */
      get stencilStateComposer() {
        return this._stencilStateComposer;
      }
      /** @internal */
      _getGlobalDefines(defines) {
        if (defines) {
          if (this.isNDCHalfZRange) {
            defines["IS_NDC_HALF_ZRANGE"] = "";
          } else {
            delete defines["IS_NDC_HALF_ZRANGE"];
          }
          if (this.useReverseDepthBuffer) {
            defines["USE_REVERSE_DEPTHBUFFER"] = "";
          } else {
            delete defines["USE_REVERSE_DEPTHBUFFER"];
          }
          if (this.useExactSrgbConversions) {
            defines["USE_EXACT_SRGB_CONVERSIONS"] = "";
          } else {
            delete defines["USE_EXACT_SRGB_CONVERSIONS"];
          }
          return;
        } else {
          let s = "";
          if (this.isNDCHalfZRange) {
            s += "#define IS_NDC_HALF_ZRANGE";
          }
          if (this.useReverseDepthBuffer) {
            if (s) {
              s += "\n";
            }
            s += "#define USE_REVERSE_DEPTHBUFFER";
          }
          if (this.useExactSrgbConversions) {
            if (s) {
              s += "\n";
            }
            s += "#define USE_EXACT_SRGB_CONVERSIONS";
          }
          return s;
        }
      }
      _rebuildInternalTextures() {
        const currentState = this._internalTexturesCache.slice();
        for (const internalTexture of currentState) {
          internalTexture._rebuild();
        }
      }
      _rebuildRenderTargetWrappers() {
        const currentState = this._renderTargetWrapperCache.slice();
        for (const renderTargetWrapper of currentState) {
          renderTargetWrapper._rebuild();
        }
      }
      _rebuildEffects() {
        for (const key in this._compiledEffects) {
          const effect = this._compiledEffects[key];
          effect._pipelineContext = null;
          effect._prepareEffect();
        }
        Effect.ResetCache();
      }
      _rebuildGraphicsResources() {
        var _a;
        this.wipeCaches(true);
        this._rebuildEffects();
        (_a = this._rebuildComputeEffects) == null ? void 0 : _a.call(this);
        this._rebuildBuffers();
        this._rebuildInternalTextures();
        this._rebuildTextures();
        this._rebuildRenderTargetWrappers();
        this.wipeCaches(true);
      }
      _flagContextRestored() {
        Logger.Warn(this.name + " context successfully restored.");
        this.onContextRestoredObservable.notifyObservers(this);
        this._contextWasLost = false;
      }
      _restoreEngineAfterContextLost(initEngine) {
        setTimeout(() => __async(this, null, function* () {
          this._clearEmptyResources();
          const depthTest = this._depthCullingState.depthTest;
          const depthFunc = this._depthCullingState.depthFunc;
          const depthMask = this._depthCullingState.depthMask;
          const stencilTest = this._stencilState.stencilTest;
          yield initEngine();
          this._rebuildGraphicsResources();
          this._depthCullingState.depthTest = depthTest;
          this._depthCullingState.depthFunc = depthFunc;
          this._depthCullingState.depthMask = depthMask;
          this._stencilState.stencilTest = stencilTest;
          this._flagContextRestored();
        }), 0);
      }
      /** Gets a boolean indicating if the engine was disposed */
      get isDisposed() {
        return this._isDisposed;
      }
      /**
       * Enables or disables the snapshot rendering mode
       * Note that the WebGL engine does not support snapshot rendering so setting the value won't have any effect for this engine
       */
      get snapshotRendering() {
        return false;
      }
      set snapshotRendering(activate) {
      }
      /**
       * Gets or sets the snapshot rendering mode
       */
      get snapshotRenderingMode() {
        return 0;
      }
      set snapshotRenderingMode(mode) {
      }
      /**
       * Returns the string "AbstractEngine"
       * @returns "AbstractEngine"
       */
      getClassName() {
        return "AbstractEngine";
      }
      /**
       * Gets the default empty texture
       */
      get emptyTexture() {
        if (!this._emptyTexture) {
          this._emptyTexture = this.createRawTexture(new Uint8Array(4), 1, 1, 5, false, false, 1);
        }
        return this._emptyTexture;
      }
      /**
       * Gets the default empty 3D texture
       */
      get emptyTexture3D() {
        if (!this._emptyTexture3D) {
          this._emptyTexture3D = this.createRawTexture3D(new Uint8Array(4), 1, 1, 1, 5, false, false, 1);
        }
        return this._emptyTexture3D;
      }
      /**
       * Gets the default empty 2D array texture
       */
      get emptyTexture2DArray() {
        if (!this._emptyTexture2DArray) {
          this._emptyTexture2DArray = this.createRawTexture2DArray(new Uint8Array(4), 1, 1, 1, 5, false, false, 1);
        }
        return this._emptyTexture2DArray;
      }
      /**
       * Gets the default empty cube texture
       */
      get emptyCubeTexture() {
        if (!this._emptyCubeTexture) {
          const faceData = new Uint8Array(4);
          const cubeData = [faceData, faceData, faceData, faceData, faceData, faceData];
          this._emptyCubeTexture = this.createRawCubeTexture(cubeData, 1, 5, 0, false, false, 1);
        }
        return this._emptyCubeTexture;
      }
      /**
       * Gets the list of current active render loop functions
       * @returns a read only array with the current render loop functions
       */
      get activeRenderLoops() {
        return this._activeRenderLoops;
      }
      /**
       * stop executing a render loop function and remove it from the execution array
       * @param renderFunction defines the function to be removed. If not provided all functions will be removed.
       */
      stopRenderLoop(renderFunction) {
        if (!renderFunction) {
          this._activeRenderLoops.length = 0;
          this._cancelFrame();
          return;
        }
        const index = this._activeRenderLoops.indexOf(renderFunction);
        if (index >= 0) {
          this._activeRenderLoops.splice(index, 1);
          if (this._activeRenderLoops.length == 0) {
            this._cancelFrame();
          }
        }
      }
      _cancelFrame() {
        if (this._frameHandler !== 0) {
          const handlerToCancel = this._frameHandler;
          this._frameHandler = 0;
          if (!IsWindowObjectExist()) {
            if (typeof cancelAnimationFrame === "function") {
              return cancelAnimationFrame(handlerToCancel);
            }
          } else {
            const { cancelAnimationFrame: cancelAnimationFrame2 } = this.getHostWindow() || window;
            if (typeof cancelAnimationFrame2 === "function") {
              return cancelAnimationFrame2(handlerToCancel);
            }
          }
          return clearTimeout(handlerToCancel);
        }
      }
      /**
       * Begin a new frame
       */
      beginFrame() {
        this.onBeginFrameObservable.notifyObservers(this);
      }
      /**
       * End the current frame
       */
      endFrame() {
        this._frameId++;
        this.onEndFrameObservable.notifyObservers(this);
      }
      /** @internal */
      _renderLoop() {
        this._frameHandler = 0;
        if (!this._contextWasLost) {
          let shouldRender = true;
          if (this._isDisposed || !this.renderEvenInBackground && this._windowIsBackground) {
            shouldRender = false;
          }
          if (shouldRender) {
            this.beginFrame();
            if (!this._renderViews()) {
              this._renderFrame();
            }
            this.endFrame();
          }
        }
        if (this._activeRenderLoops.length > 0 && this._frameHandler === 0) {
          this._frameHandler = this._queueNewFrame(this._boundRenderFunction, this.getHostWindow());
        }
      }
      /** @internal */
      _renderFrame() {
        for (let index = 0; index < this._activeRenderLoops.length; index++) {
          const renderFunction = this._activeRenderLoops[index];
          renderFunction();
        }
      }
      /** @internal */
      _renderViews() {
        return false;
      }
      /**
       * Can be used to override the current requestAnimationFrame requester.
       * @internal
       */
      _queueNewFrame(bindedRenderFunction, requester) {
        return QueueNewFrame(bindedRenderFunction, requester);
      }
      /**
       * Register and execute a render loop. The engine can have more than one render function
       * @param renderFunction defines the function to continuously execute
       */
      runRenderLoop(renderFunction) {
        if (this._activeRenderLoops.indexOf(renderFunction) !== -1) {
          return;
        }
        this._activeRenderLoops.push(renderFunction);
        if (this._activeRenderLoops.length === 1 && this._frameHandler === 0) {
          this._frameHandler = this._queueNewFrame(this._boundRenderFunction, this.getHostWindow());
        }
      }
      /**
       * Gets a boolean indicating if depth testing is enabled
       * @returns the current state
       */
      getDepthBuffer() {
        return this._depthCullingState.depthTest;
      }
      /**
       * Enable or disable depth buffering
       * @param enable defines the state to set
       */
      setDepthBuffer(enable) {
        this._depthCullingState.depthTest = enable;
      }
      /**
       * Set the z offset Factor to apply to current rendering
       * @param value defines the offset to apply
       */
      setZOffset(value) {
        this._depthCullingState.zOffset = this.useReverseDepthBuffer ? -value : value;
      }
      /**
       * Gets the current value of the zOffset Factor
       * @returns the current zOffset Factor state
       */
      getZOffset() {
        const zOffset = this._depthCullingState.zOffset;
        return this.useReverseDepthBuffer ? -zOffset : zOffset;
      }
      /**
       * Set the z offset Units to apply to current rendering
       * @param value defines the offset to apply
       */
      setZOffsetUnits(value) {
        this._depthCullingState.zOffsetUnits = this.useReverseDepthBuffer ? -value : value;
      }
      /**
       * Gets the current value of the zOffset Units
       * @returns the current zOffset Units state
       */
      getZOffsetUnits() {
        const zOffsetUnits = this._depthCullingState.zOffsetUnits;
        return this.useReverseDepthBuffer ? -zOffsetUnits : zOffsetUnits;
      }
      /**
       * Gets host window
       * @returns the host window object
       */
      getHostWindow() {
        if (!IsWindowObjectExist()) {
          return null;
        }
        if (this._renderingCanvas && this._renderingCanvas.ownerDocument && this._renderingCanvas.ownerDocument.defaultView) {
          return this._renderingCanvas.ownerDocument.defaultView;
        }
        return window;
      }
      /**
       * (WebGPU only) True (default) to be in compatibility mode, meaning rendering all existing scenes without artifacts (same rendering than WebGL).
       * Setting the property to false will improve performances but may not work in some scenes if some precautions are not taken.
       * See https://doc.babylonjs.com/setup/support/webGPU/webGPUOptimization/webGPUNonCompatibilityMode for more details
       */
      get compatibilityMode() {
        return this._compatibilityMode;
      }
      set compatibilityMode(mode) {
        this._compatibilityMode = true;
      }
      _rebuildTextures() {
        for (const scene of this.scenes) {
          scene._rebuildTextures();
        }
        for (const scene of this._virtualScenes) {
          scene._rebuildTextures();
        }
      }
      /**
       * @internal
       */
      _releaseRenderTargetWrapper(rtWrapper) {
        const index = this._renderTargetWrapperCache.indexOf(rtWrapper);
        if (index !== -1) {
          this._renderTargetWrapperCache.splice(index, 1);
        }
      }
      /**
       * Gets the current viewport
       */
      get currentViewport() {
        return this._cachedViewport;
      }
      /**
       * Set the WebGL's viewport
       * @param viewport defines the viewport element to be used
       * @param requiredWidth defines the width required for rendering. If not provided the rendering canvas' width is used
       * @param requiredHeight defines the height required for rendering. If not provided the rendering canvas' height is used
       */
      setViewport(viewport, requiredWidth, requiredHeight) {
        const width = requiredWidth || this.getRenderWidth();
        const height = requiredHeight || this.getRenderHeight();
        const x = viewport.x || 0;
        const y = viewport.y || 0;
        this._cachedViewport = viewport;
        this._viewport(x * width, y * height, width * viewport.width, height * viewport.height);
      }
      /**
       * Create an image to use with canvas
       * @returns IImage interface
       */
      createCanvasImage() {
        return document.createElement("img");
      }
      /**
       * Returns a string describing the current engine
       */
      get description() {
        let description = this.name + this.version;
        if (this._caps.parallelShaderCompile) {
          description += " - Parallel shader compilation";
        }
        return description;
      }
      _createTextureBase(url, noMipmap, invertY, scene, samplingMode = 3, onLoad = null, onError = null, prepareTexture, prepareTextureProcess, buffer = null, fallback = null, format = null, forcedExtension = null, mimeType, loaderOptions, useSRGBBuffer) {
        url = url || "";
        const fromData = url.substr(0, 5) === "data:";
        const fromBlob = url.substr(0, 5) === "blob:";
        const isBase64 = fromData && url.indexOf(";base64,") !== -1;
        const texture = fallback ? fallback : new InternalTexture(
          this,
          1
          /* InternalTextureSource.Url */
        );
        if (texture !== fallback) {
          texture.label = url.substring(0, 60);
        }
        const originalUrl = url;
        if (this._transformTextureUrl && !isBase64 && !fallback && !buffer) {
          url = this._transformTextureUrl(url);
        }
        if (originalUrl !== url) {
          texture._originalUrl = originalUrl;
        }
        const lastDot = url.lastIndexOf(".");
        let extension = forcedExtension ? forcedExtension : lastDot > -1 ? url.substring(lastDot).toLowerCase() : "";
        const queryStringIndex = extension.indexOf("?");
        if (queryStringIndex > -1) {
          extension = extension.split("?")[0];
        }
        const loaderPromise = _GetCompatibleTextureLoader(extension, mimeType);
        if (scene) {
          scene.addPendingData(texture);
        }
        texture.url = url;
        texture.generateMipMaps = !noMipmap;
        texture.samplingMode = samplingMode;
        texture.invertY = invertY;
        texture._useSRGBBuffer = this._getUseSRGBBuffer(!!useSRGBBuffer, noMipmap);
        if (!this._doNotHandleContextLost) {
          texture._buffer = buffer;
        }
        let onLoadObserver = null;
        if (onLoad && !fallback) {
          onLoadObserver = texture.onLoadedObservable.add(onLoad);
        }
        if (!fallback) {
          this._internalTexturesCache.push(texture);
        }
        const onInternalError = (message, exception) => {
          if (scene) {
            scene.removePendingData(texture);
          }
          if (url === originalUrl) {
            if (onLoadObserver) {
              texture.onLoadedObservable.remove(onLoadObserver);
            }
            if (EngineStore.UseFallbackTexture && url !== EngineStore.FallbackTexture) {
              this._createTextureBase(EngineStore.FallbackTexture, noMipmap, texture.invertY, scene, samplingMode, null, onError, prepareTexture, prepareTextureProcess, buffer, texture);
            }
            message = (message || "Unknown error") + (EngineStore.UseFallbackTexture ? " - Fallback texture was used" : "");
            texture.onErrorObservable.notifyObservers({ message, exception });
            if (onError) {
              onError(message, exception);
            }
          } else {
            Logger.Warn(`Failed to load ${url}, falling back to ${originalUrl}`);
            this._createTextureBase(originalUrl, noMipmap, texture.invertY, scene, samplingMode, onLoad, onError, prepareTexture, prepareTextureProcess, buffer, texture, format, forcedExtension, mimeType, loaderOptions, useSRGBBuffer);
          }
        };
        if (loaderPromise) {
          const callback = (data) => __async(this, null, function* () {
            const loader = yield loaderPromise;
            loader.loadData(data, texture, (width, height, loadMipmap, isCompressed, done, loadFailed) => {
              if (loadFailed) {
                onInternalError("TextureLoader failed to load data");
              } else {
                prepareTexture(texture, extension, scene, { width, height }, texture.invertY, !loadMipmap, isCompressed, () => {
                  done();
                  return false;
                }, samplingMode);
              }
            }, loaderOptions);
          });
          if (!buffer) {
            this._loadFile(url, (data) => callback(new Uint8Array(data)), void 0, scene ? scene.offlineProvider : void 0, true, (request, exception) => {
              onInternalError("Unable to load " + (request ? request.responseURL : url, exception));
            });
          } else {
            if (buffer instanceof ArrayBuffer) {
              callback(new Uint8Array(buffer));
            } else if (ArrayBuffer.isView(buffer)) {
              callback(buffer);
            } else {
              if (onError) {
                onError("Unable to load: only ArrayBuffer or ArrayBufferView is supported", null);
              }
            }
          }
        } else {
          const onload = (img) => {
            if (fromBlob && !this._doNotHandleContextLost) {
              texture._buffer = img;
            }
            prepareTexture(texture, extension, scene, img, texture.invertY, noMipmap, false, prepareTextureProcess, samplingMode);
          };
          if (!fromData || isBase64) {
            if (buffer && (typeof buffer.decoding === "string" || buffer.close)) {
              onload(buffer);
            } else {
              _AbstractEngine._FileToolsLoadImage(url || "", onload, onInternalError, scene ? scene.offlineProvider : null, mimeType, texture.invertY && this._features.needsInvertingBitmap ? { imageOrientation: "flipY" } : void 0);
            }
          } else if (typeof buffer === "string" || buffer instanceof ArrayBuffer || ArrayBuffer.isView(buffer) || buffer instanceof Blob) {
            _AbstractEngine._FileToolsLoadImage(buffer, onload, onInternalError, scene ? scene.offlineProvider : null, mimeType, texture.invertY && this._features.needsInvertingBitmap ? { imageOrientation: "flipY" } : void 0);
          } else if (buffer) {
            onload(buffer);
          }
        }
        return texture;
      }
      _rebuildBuffers() {
        for (const uniformBuffer of this._uniformBuffers) {
          uniformBuffer._rebuildAfterContextLost();
        }
      }
      /** @internal */
      get _shouldUseHighPrecisionShader() {
        return !!(this._caps.highPrecisionShaderSupported && this._highPrecisionShadersAllowed);
      }
      /**
       * Gets host document
       * @returns the host document object
       */
      getHostDocument() {
        if (this._renderingCanvas && this._renderingCanvas.ownerDocument) {
          return this._renderingCanvas.ownerDocument;
        }
        return IsDocumentAvailable() ? document : null;
      }
      /**
       * Gets the list of loaded textures
       * @returns an array containing all loaded textures
       */
      getLoadedTexturesCache() {
        return this._internalTexturesCache;
      }
      /**
       * Clears the list of texture accessible through engine.
       * This can help preventing texture load conflict due to name collision.
       */
      clearInternalTexturesCache() {
        this._internalTexturesCache.length = 0;
      }
      /**
       * Gets the object containing all engine capabilities
       * @returns the EngineCapabilities object
       */
      getCaps() {
        return this._caps;
      }
      /**
       * Reset the texture cache to empty state
       */
      resetTextureCache() {
        for (const key in this._boundTexturesCache) {
          if (!Object.prototype.hasOwnProperty.call(this._boundTexturesCache, key)) {
            continue;
          }
          this._boundTexturesCache[key] = null;
        }
        this._currentTextureChannel = -1;
      }
      /**
       * Gets or sets the name of the engine
       */
      get name() {
        return this._name;
      }
      set name(value) {
        this._name = value;
      }
      /**
       * Returns the current npm package of the sdk
       */
      // Not mixed with Version for tooling purpose.
      static get NpmPackage() {
        return "babylonjs@7.25.1";
      }
      /**
       * Returns the current version of the framework
       */
      static get Version() {
        return "7.25.1";
      }
      /**
       * Gets the HTML canvas attached with the current webGL context
       * @returns a HTML canvas
       */
      getRenderingCanvas() {
        return this._renderingCanvas;
      }
      /**
       * Gets the audio context specified in engine initialization options
       * @returns an Audio Context
       */
      getAudioContext() {
        return this._audioContext;
      }
      /**
       * Gets the audio destination specified in engine initialization options
       * @returns an audio destination node
       */
      getAudioDestination() {
        return this._audioDestination;
      }
      /**
       * Defines the hardware scaling level.
       * By default the hardware scaling level is computed from the window device ratio.
       * if level = 1 then the engine will render at the exact resolution of the canvas. If level = 0.5 then the engine will render at twice the size of the canvas.
       * @param level defines the level to use
       */
      setHardwareScalingLevel(level) {
        this._hardwareScalingLevel = level;
        this.resize();
      }
      /**
       * Gets the current hardware scaling level.
       * By default the hardware scaling level is computed from the window device ratio.
       * if level = 1 then the engine will render at the exact resolution of the canvas. If level = 0.5 then the engine will render at twice the size of the canvas.
       * @returns a number indicating the current hardware scaling level
       */
      getHardwareScalingLevel() {
        return this._hardwareScalingLevel;
      }
      /**
       * Gets or sets a boolean indicating if resources should be retained to be able to handle context lost events
       * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/optimize_your_scene#handling-webgl-context-lost
       */
      get doNotHandleContextLost() {
        return this._doNotHandleContextLost;
      }
      set doNotHandleContextLost(value) {
        this._doNotHandleContextLost = value;
      }
      /**
       * Returns true if the stencil buffer has been enabled through the creation option of the context.
       */
      get isStencilEnable() {
        return this._isStencilEnable;
      }
      /**
       * Gets the options used for engine creation
       * @returns EngineOptions object
       */
      getCreationOptions() {
        return this._creationOptions;
      }
      /**
       * Creates a new engine
       * @param antialias defines whether anti-aliasing should be enabled. If undefined, it means that the underlying engine is free to enable it or not
       * @param options defines further options to be sent to the creation context
       * @param adaptToDeviceRatio defines whether to adapt to the device's viewport characteristics (default: false)
       */
      constructor(antialias, options, adaptToDeviceRatio) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
        this._colorWrite = true;
        this._colorWriteChanged = true;
        this._depthCullingState = new DepthCullingState();
        this._stencilStateComposer = new StencilStateComposer();
        this._stencilState = new StencilState();
        this._alphaState = new AlphaState();
        this._alphaMode = 1;
        this._alphaEquation = 0;
        this._activeRequests = [];
        this._badOS = false;
        this._badDesktopOS = false;
        this._compatibilityMode = true;
        this._internalTexturesCache = new Array();
        this._currentRenderTarget = null;
        this._boundTexturesCache = {};
        this._activeChannel = 0;
        this._currentTextureChannel = -1;
        this._viewportCached = { x: 0, y: 0, z: 0, w: 0 };
        this._isWebGPU = false;
        this.onCanvasBlurObservable = new Observable();
        this.onCanvasFocusObservable = new Observable();
        this.onNewSceneAddedObservable = new Observable();
        this.onResizeObservable = new Observable();
        this.onCanvasPointerOutObservable = new Observable();
        this.disablePerformanceMonitorInBackground = false;
        this.disableVertexArrayObjects = false;
        this._frameId = 0;
        this.hostInformation = {
          isMobile: false
        };
        this.isFullscreen = false;
        this.enableOfflineSupport = false;
        this.disableManifestCheck = false;
        this.disableContextMenu = true;
        this.currentRenderPassId = 0;
        this.isPointerLock = false;
        this.postProcesses = [];
        this.canvasTabIndex = 1;
        this._contextWasLost = false;
        this._useReverseDepthBuffer = false;
        this.isNDCHalfZRange = false;
        this.hasOriginBottomLeft = true;
        this._renderTargetWrapperCache = new Array();
        this._compiledEffects = {};
        this._isDisposed = false;
        this.scenes = [];
        this._virtualScenes = new Array();
        this.onBeforeTextureInitObservable = new Observable();
        this.renderEvenInBackground = true;
        this.preventCacheWipeBetweenFrames = false;
        this._frameHandler = 0;
        this._activeRenderLoops = new Array();
        this._windowIsBackground = false;
        this._boundRenderFunction = () => this._renderLoop();
        this.onBeforeShaderCompilationObservable = new Observable();
        this.onAfterShaderCompilationObservable = new Observable();
        this.onBeginFrameObservable = new Observable();
        this.onEndFrameObservable = new Observable();
        this._transformTextureUrl = null;
        this._uniformBuffers = new Array();
        this._storageBuffers = new Array();
        this._highPrecisionShadersAllowed = true;
        this.onContextLostObservable = new Observable();
        this.onContextRestoredObservable = new Observable();
        this._name = "";
        this.premultipliedAlpha = true;
        this.adaptToDeviceRatio = false;
        this._lastDevicePixelRatio = 1;
        this._doNotHandleContextLost = false;
        this.cullBackFaces = null;
        this._renderPassNames = ["main"];
        this._fps = 60;
        this._deltaTime = 0;
        this._deterministicLockstep = false;
        this._lockstepMaxSteps = 4;
        this._timeStep = 1 / 60;
        this.onDisposeObservable = new Observable();
        EngineStore.Instances.push(this);
        this.startTime = PrecisionDate.Now;
        this._stencilStateComposer.stencilGlobal = this._stencilState;
        PerformanceConfigurator.SetMatrixPrecision(!!options.useHighPrecisionMatrix);
        if (IsNavigatorAvailable() && navigator.userAgent) {
          this._badOS = /iPad/i.test(navigator.userAgent) || /iPhone/i.test(navigator.userAgent);
          this._badDesktopOS = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        }
        this.adaptToDeviceRatio = adaptToDeviceRatio != null ? adaptToDeviceRatio : false;
        options.antialias = antialias != null ? antialias : options.antialias;
        options.deterministicLockstep = (_a = options.deterministicLockstep) != null ? _a : false;
        options.lockstepMaxSteps = (_b = options.lockstepMaxSteps) != null ? _b : 4;
        options.timeStep = (_c = options.timeStep) != null ? _c : 1 / 60;
        options.audioEngine = (_d = options.audioEngine) != null ? _d : true;
        options.stencil = (_e = options.stencil) != null ? _e : true;
        this._audioContext = (_g = (_f = options.audioEngineOptions) == null ? void 0 : _f.audioContext) != null ? _g : null;
        this._audioDestination = (_i = (_h = options.audioEngineOptions) == null ? void 0 : _h.audioDestination) != null ? _i : null;
        this.premultipliedAlpha = (_j = options.premultipliedAlpha) != null ? _j : true;
        this._doNotHandleContextLost = !!options.doNotHandleContextLost;
        this._isStencilEnable = options.stencil ? true : false;
        this.useExactSrgbConversions = (_k = options.useExactSrgbConversions) != null ? _k : false;
        const devicePixelRatio = IsWindowObjectExist() ? window.devicePixelRatio || 1 : 1;
        const limitDeviceRatio = options.limitDeviceRatio || devicePixelRatio;
        adaptToDeviceRatio = adaptToDeviceRatio || options.adaptToDeviceRatio || false;
        this._hardwareScalingLevel = adaptToDeviceRatio ? 1 / Math.min(limitDeviceRatio, devicePixelRatio) : 1;
        this._lastDevicePixelRatio = devicePixelRatio;
        this._creationOptions = options;
      }
      /**
       * Resize the view according to the canvas' size
       * @param forceSetSize true to force setting the sizes of the underlying canvas
       */
      resize(forceSetSize = false) {
        let width;
        let height;
        if (this.adaptToDeviceRatio) {
          const devicePixelRatio = IsWindowObjectExist() ? window.devicePixelRatio || 1 : 1;
          const changeRatio = this._lastDevicePixelRatio / devicePixelRatio;
          this._lastDevicePixelRatio = devicePixelRatio;
          this._hardwareScalingLevel *= changeRatio;
        }
        if (IsWindowObjectExist() && IsDocumentAvailable()) {
          if (this._renderingCanvas) {
            const boundingRect = this._renderingCanvas.getBoundingClientRect ? this._renderingCanvas.getBoundingClientRect() : {
              // fallback to last solution in case the function doesn't exist
              width: this._renderingCanvas.width * this._hardwareScalingLevel,
              height: this._renderingCanvas.height * this._hardwareScalingLevel
            };
            width = this._renderingCanvas.clientWidth || boundingRect.width || this._renderingCanvas.width || 100;
            height = this._renderingCanvas.clientHeight || boundingRect.height || this._renderingCanvas.height || 100;
          } else {
            width = window.innerWidth;
            height = window.innerHeight;
          }
        } else {
          width = this._renderingCanvas ? this._renderingCanvas.width : 100;
          height = this._renderingCanvas ? this._renderingCanvas.height : 100;
        }
        this.setSize(width / this._hardwareScalingLevel, height / this._hardwareScalingLevel, forceSetSize);
      }
      /**
       * Force a specific size of the canvas
       * @param width defines the new canvas' width
       * @param height defines the new canvas' height
       * @param forceSetSize true to force setting the sizes of the underlying canvas
       * @returns true if the size was changed
       */
      setSize(width, height, forceSetSize = false) {
        if (!this._renderingCanvas) {
          return false;
        }
        width = width | 0;
        height = height | 0;
        if (!forceSetSize && this._renderingCanvas.width === width && this._renderingCanvas.height === height) {
          return false;
        }
        this._renderingCanvas.width = width;
        this._renderingCanvas.height = height;
        if (this.scenes) {
          for (let index = 0; index < this.scenes.length; index++) {
            const scene = this.scenes[index];
            for (let camIndex = 0; camIndex < scene.cameras.length; camIndex++) {
              const cam = scene.cameras[camIndex];
              cam._currentRenderId = 0;
            }
          }
          if (this.onResizeObservable.hasObservers()) {
            this.onResizeObservable.notifyObservers(this);
          }
        }
        return true;
      }
      // eslint-disable-next-line jsdoc/require-returns-check
      /**
       * Creates a raw texture
       * @param data defines the data to store in the texture
       * @param width defines the width of the texture
       * @param height defines the height of the texture
       * @param format defines the format of the data
       * @param generateMipMaps defines if the engine should generate the mip levels
       * @param invertY defines if data must be stored with Y axis inverted
       * @param samplingMode defines the required sampling mode (Texture.NEAREST_SAMPLINGMODE by default)
       * @param compression defines the compression used (null by default)
       * @param type defines the type fo the data (Engine.TEXTURETYPE_UNSIGNED_INT by default)
       * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
       * @param useSRGBBuffer defines if the texture must be loaded in a sRGB GPU buffer (if supported by the GPU).
       * @returns the raw texture inside an InternalTexture
       */
      createRawTexture(data, width, height, format, generateMipMaps, invertY, samplingMode, compression, type, creationFlags, useSRGBBuffer) {
        throw _WarnImport("engine.rawTexture");
      }
      // eslint-disable-next-line jsdoc/require-returns-check
      /**
       * Creates a new raw cube texture
       * @param data defines the array of data to use to create each face
       * @param size defines the size of the textures
       * @param format defines the format of the data
       * @param type defines the type of the data (like Engine.TEXTURETYPE_UNSIGNED_INT)
       * @param generateMipMaps  defines if the engine should generate the mip levels
       * @param invertY defines if data must be stored with Y axis inverted
       * @param samplingMode defines the required sampling mode (like Texture.NEAREST_SAMPLINGMODE)
       * @param compression defines the compression used (null by default)
       * @returns the cube texture as an InternalTexture
       */
      createRawCubeTexture(data, size, format, type, generateMipMaps, invertY, samplingMode, compression) {
        throw _WarnImport("engine.rawTexture");
      }
      // eslint-disable-next-line jsdoc/require-returns-check
      /**
       * Creates a new raw 3D texture
       * @param data defines the data used to create the texture
       * @param width defines the width of the texture
       * @param height defines the height of the texture
       * @param depth defines the depth of the texture
       * @param format defines the format of the texture
       * @param generateMipMaps defines if the engine must generate mip levels
       * @param invertY defines if data must be stored with Y axis inverted
       * @param samplingMode defines the required sampling mode (like Texture.NEAREST_SAMPLINGMODE)
       * @param compression defines the compressed used (can be null)
       * @param textureType defines the compressed used (can be null)
       * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
       * @returns a new raw 3D texture (stored in an InternalTexture)
       */
      createRawTexture3D(data, width, height, depth, format, generateMipMaps, invertY, samplingMode, compression, textureType, creationFlags) {
        throw _WarnImport("engine.rawTexture");
      }
      // eslint-disable-next-line jsdoc/require-returns-check
      /**
       * Creates a new raw 2D array texture
       * @param data defines the data used to create the texture
       * @param width defines the width of the texture
       * @param height defines the height of the texture
       * @param depth defines the number of layers of the texture
       * @param format defines the format of the texture
       * @param generateMipMaps defines if the engine must generate mip levels
       * @param invertY defines if data must be stored with Y axis inverted
       * @param samplingMode defines the required sampling mode (like Texture.NEAREST_SAMPLINGMODE)
       * @param compression defines the compressed used (can be null)
       * @param textureType defines the compressed used (can be null)
       * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
       * @returns a new raw 2D array texture (stored in an InternalTexture)
       */
      createRawTexture2DArray(data, width, height, depth, format, generateMipMaps, invertY, samplingMode, compression, textureType, creationFlags) {
        throw _WarnImport("engine.rawTexture");
      }
      /**
       * Shared initialization across engines types.
       * @param canvas The canvas associated with this instance of the engine.
       */
      _sharedInit(canvas) {
        this._renderingCanvas = canvas;
      }
      _setupMobileChecks() {
        if (!(navigator && navigator.userAgent)) {
          return;
        }
        this._checkForMobile = () => {
          const currentUA = navigator.userAgent;
          this.hostInformation.isMobile = currentUA.indexOf("Mobile") !== -1 || // Needed for iOS 13+ detection on iPad (inspired by solution from https://stackoverflow.com/questions/9038625/detect-if-device-is-ios)
          currentUA.indexOf("Mac") !== -1 && IsDocumentAvailable() && "ontouchend" in document;
        };
        this._checkForMobile();
        if (IsWindowObjectExist()) {
          window.addEventListener("resize", this._checkForMobile);
        }
      }
      /**
       * creates and returns a new video element
       * @param constraints video constraints
       * @returns video element
       */
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      createVideoElement(constraints) {
        return document.createElement("video");
      }
      /**
       * @internal
       */
      _reportDrawCall(numDrawCalls = 1) {
        var _a;
        (_a = this._drawCalls) == null ? void 0 : _a.addCount(numDrawCalls, false);
      }
      /**
       * Gets the current framerate
       * @returns a number representing the framerate
       */
      getFps() {
        return this._fps;
      }
      /**
       * Gets the time spent between current and previous frame
       * @returns a number representing the delta time in ms
       */
      getDeltaTime() {
        return this._deltaTime;
      }
      /**
       * Gets a boolean indicating that the engine is running in deterministic lock step mode
       * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#deterministic-lockstep
       * @returns true if engine is in deterministic lock step mode
       */
      isDeterministicLockStep() {
        return this._deterministicLockstep;
      }
      /**
       * Gets the max steps when engine is running in deterministic lock step
       * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#deterministic-lockstep
       * @returns the max steps
       */
      getLockstepMaxSteps() {
        return this._lockstepMaxSteps;
      }
      /**
       * Returns the time in ms between steps when using deterministic lock step.
       * @returns time step in (ms)
       */
      getTimeStep() {
        return this._timeStep * 1e3;
      }
      /**
       * Engine abstraction for loading and creating an image bitmap from a given source string.
       * @param imageSource source to load the image from.
       * @param options An object that sets options for the image's extraction.
       */
      _createImageBitmapFromSource(imageSource, options) {
        throw new Error("createImageBitmapFromSource is not implemented");
      }
      /**
       * Engine abstraction for createImageBitmap
       * @param image source for image
       * @param options An object that sets options for the image's extraction.
       * @returns ImageBitmap
       */
      createImageBitmap(image, options) {
        return createImageBitmap(image, options);
      }
      /**
       * Resize an image and returns the image data as an uint8array
       * @param image image to resize
       * @param bufferWidth destination buffer width
       * @param bufferHeight destination buffer height
       */
      resizeImageBitmap(image, bufferWidth, bufferHeight) {
        throw new Error("resizeImageBitmap is not implemented");
      }
      /**
       * Get Font size information
       * @param font font name
       */
      getFontOffset(font) {
        throw new Error("getFontOffset is not implemented");
      }
      static _CreateCanvas(width, height) {
        if (typeof document === "undefined") {
          return new OffscreenCanvas(width, height);
        }
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        return canvas;
      }
      /**
       * Create a canvas. This method is overridden by other engines
       * @param width width
       * @param height height
       * @returns ICanvas interface
       */
      createCanvas(width, height) {
        return _AbstractEngine._CreateCanvas(width, height);
      }
      /**
       * Loads an image as an HTMLImageElement.
       * @param input url string, ArrayBuffer, or Blob to load
       * @param onLoad callback called when the image successfully loads
       * @param onError callback called when the image fails to load
       * @param offlineProvider offline provider for caching
       * @param mimeType optional mime type
       * @param imageBitmapOptions optional the options to use when creating an ImageBitmap
       * @returns the HTMLImageElement of the loaded image
       * @internal
       */
      static _FileToolsLoadImage(input, onLoad, onError, offlineProvider, mimeType, imageBitmapOptions) {
        throw _WarnImport("FileTools");
      }
      /**
       * @internal
       */
      _loadFile(url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError) {
        const request = _loadFile(url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError);
        this._activeRequests.push(request);
        request.onCompleteObservable.add(() => {
          const index = this._activeRequests.indexOf(request);
          if (index !== -1) {
            this._activeRequests.splice(index, 1);
          }
        });
        return request;
      }
      /**
       * Loads a file from a url
       * @param url url to load
       * @param onSuccess callback called when the file successfully loads
       * @param onProgress callback called while file is loading (if the server supports this mode)
       * @param offlineProvider defines the offline provider for caching
       * @param useArrayBuffer defines a boolean indicating that date must be returned as ArrayBuffer
       * @param onError callback called when the file fails to load
       * @returns a file request object
       * @internal
       */
      static _FileToolsLoadFile(url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError) {
        if (EngineFunctionContext.loadFile) {
          return EngineFunctionContext.loadFile(url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError);
        }
        throw _WarnImport("FileTools");
      }
      /**
       * Dispose and release all associated resources
       */
      dispose() {
        var _a;
        this.releaseEffects();
        this._isDisposed = true;
        this.stopRenderLoop();
        if (this._emptyTexture) {
          this._releaseTexture(this._emptyTexture);
          this._emptyTexture = null;
        }
        if (this._emptyCubeTexture) {
          this._releaseTexture(this._emptyCubeTexture);
          this._emptyCubeTexture = null;
        }
        this._renderingCanvas = null;
        if (this.onBeforeTextureInitObservable) {
          this.onBeforeTextureInitObservable.clear();
        }
        while (this.postProcesses.length) {
          this.postProcesses[0].dispose();
        }
        while (this.scenes.length) {
          this.scenes[0].dispose();
        }
        while (this._virtualScenes.length) {
          this._virtualScenes[0].dispose();
        }
        (_a = this.releaseComputeEffects) == null ? void 0 : _a.call(this);
        Effect.ResetCache();
        for (const request of this._activeRequests) {
          request.abort();
        }
        this._boundRenderFunction = null;
        this.onDisposeObservable.notifyObservers(this);
        this.onDisposeObservable.clear();
        this.onResizeObservable.clear();
        this.onCanvasBlurObservable.clear();
        this.onCanvasFocusObservable.clear();
        this.onCanvasPointerOutObservable.clear();
        this.onNewSceneAddedObservable.clear();
        if (IsWindowObjectExist()) {
          window.removeEventListener("resize", this._checkForMobile);
        }
        const index = EngineStore.Instances.indexOf(this);
        if (index >= 0) {
          EngineStore.Instances.splice(index, 1);
        }
        if (!EngineStore.Instances.length) {
          EngineStore.OnEnginesDisposedObservable.notifyObservers(this);
          EngineStore.OnEnginesDisposedObservable.clear();
        }
        this.onBeginFrameObservable.clear();
        this.onEndFrameObservable.clear();
      }
      /**
       * Method called to create the default loading screen.
       * This can be overridden in your own app.
       * @param canvas The rendering canvas element
       */
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      static DefaultLoadingScreenFactory(canvas) {
        throw _WarnImport("LoadingScreen");
      }
      /**
       * Will flag all materials in all scenes in all engines as dirty to trigger new shader compilation
       * @param flag defines which part of the materials must be marked as dirty
       * @param predicate defines a predicate used to filter which materials should be affected
       */
      static MarkAllMaterialsAsDirty(flag, predicate) {
        for (let engineIndex = 0; engineIndex < EngineStore.Instances.length; engineIndex++) {
          const engine = EngineStore.Instances[engineIndex];
          for (let sceneIndex = 0; sceneIndex < engine.scenes.length; sceneIndex++) {
            engine.scenes[sceneIndex].markAllMaterialsAsDirty(flag, predicate);
          }
        }
      }
    };
    AbstractEngine._RenderPassIdCounter = 0;
    AbstractEngine._RescalePostProcessFactory = null;
    AbstractEngine.CollisionsEpsilon = 1e-3;
    AbstractEngine.QueueNewFrame = QueueNewFrame;
  }
});

// node_modules/@babylonjs/core/Misc/fileTools.js
function DecodeBase64UrlToBinary(uri) {
  return DecodeBase64ToBinary(uri.split(",")[1]);
}
var Base64DataUrlRegEx, LoadFileError, RequestFileError, ReadFileError, CleanUrl, FileToolsOptions, SetCorsBehavior, LoadImageConfiguration, LoadImage, ReadFile, LoadFile, RequestFile, IsFileURL, IsBase64DataUrl, TestBase64DataUrl, DecodeBase64UrlToString, initSideEffects, FileTools, _injectLTSFileTools;
var init_fileTools = __esm({
  "node_modules/@babylonjs/core/Misc/fileTools.js"() {
    "use strict";
    init_webRequest();
    init_domManagement();
    init_observable();
    init_filesInputStore();
    init_retryStrategy();
    init_error();
    init_stringTools();
    init_shaderProcessor();
    init_engineStore();
    init_logger();
    init_timingTools();
    init_abstractEngine_functions();
    init_abstractEngine();
    Base64DataUrlRegEx = new RegExp(/^data:([^,]+\/[^,]+)?;base64,/i);
    LoadFileError = class _LoadFileError extends RuntimeError {
      /**
       * Creates a new LoadFileError
       * @param message defines the message of the error
       * @param object defines the optional web request
       */
      constructor(message, object) {
        super(message, ErrorCodes.LoadFileError);
        this.name = "LoadFileError";
        BaseError._setPrototypeOf(this, _LoadFileError.prototype);
        if (object instanceof WebRequest) {
          this.request = object;
        } else {
          this.file = object;
        }
      }
    };
    RequestFileError = class _RequestFileError extends RuntimeError {
      /**
       * Creates a new LoadFileError
       * @param message defines the message of the error
       * @param request defines the optional web request
       */
      constructor(message, request) {
        super(message, ErrorCodes.RequestFileError);
        this.request = request;
        this.name = "RequestFileError";
        BaseError._setPrototypeOf(this, _RequestFileError.prototype);
      }
    };
    ReadFileError = class _ReadFileError extends RuntimeError {
      /**
       * Creates a new ReadFileError
       * @param message defines the message of the error
       * @param file defines the optional file
       */
      constructor(message, file) {
        super(message, ErrorCodes.ReadFileError);
        this.file = file;
        this.name = "ReadFileError";
        BaseError._setPrototypeOf(this, _ReadFileError.prototype);
      }
    };
    CleanUrl = (url) => {
      url = url.replace(/#/gm, "%23");
      return url;
    };
    FileToolsOptions = {
      /**
       * Gets or sets the retry strategy to apply when an error happens while loading an asset.
       * When defining this function, return the wait time before trying again or return -1 to
       * stop retrying and error out.
       */
      DefaultRetryStrategy: RetryStrategy.ExponentialBackoff(),
      /**
       * Gets or sets the base URL to use to load assets
       */
      BaseUrl: "",
      /**
       * Default behaviour for cors in the application.
       * It can be a string if the expected behavior is identical in the entire app.
       * Or a callback to be able to set it per url or on a group of them (in case of Video source for instance)
       */
      CorsBehavior: "anonymous",
      /**
       * Gets or sets a function used to pre-process url before using them to load assets
       * @param url
       * @returns the processed url
       */
      PreprocessUrl: (url) => url,
      /**
       * Gets or sets the base URL to use to load scripts
       * Used for both JS and WASM
       */
      ScriptBaseUrl: "",
      /**
       * Gets or sets a function used to pre-process script url before using them to load.
       * Used for both JS and WASM
       * @param url defines the url to process
       * @returns the processed url
       */
      ScriptPreprocessUrl: (url) => url,
      /**
       * Gets or sets a function used to clean the url before using it to load assets
       * @param url defines the url to clean
       * @returns the cleaned url
       */
      CleanUrl
    };
    SetCorsBehavior = (url, element) => {
      if (url && url.indexOf("data:") === 0) {
        return;
      }
      if (FileToolsOptions.CorsBehavior) {
        if (typeof FileToolsOptions.CorsBehavior === "string" || FileToolsOptions.CorsBehavior instanceof String) {
          element.crossOrigin = FileToolsOptions.CorsBehavior;
        } else {
          const result = FileToolsOptions.CorsBehavior(url);
          if (result) {
            element.crossOrigin = result;
          }
        }
      }
    };
    LoadImageConfiguration = {
      getRequiredSize: null
    };
    LoadImage = (input, onLoad, onError, offlineProvider, mimeType = "", imageBitmapOptions) => {
      const engine = EngineStore.LastCreatedEngine;
      if (typeof HTMLImageElement === "undefined" && !(engine == null ? void 0 : engine._features.forceBitmapOverHTMLImageElement)) {
        onError("LoadImage is only supported in web or BabylonNative environments.");
        return null;
      }
      let url;
      let usingObjectURL = false;
      if (input instanceof ArrayBuffer || ArrayBuffer.isView(input)) {
        if (typeof Blob !== "undefined" && typeof URL !== "undefined") {
          url = URL.createObjectURL(new Blob([input], { type: mimeType }));
          usingObjectURL = true;
        } else {
          url = `data:${mimeType};base64,` + EncodeArrayBufferToBase64(input);
        }
      } else if (input instanceof Blob) {
        url = URL.createObjectURL(input);
        usingObjectURL = true;
      } else {
        url = FileToolsOptions.CleanUrl(input);
        url = FileToolsOptions.PreprocessUrl(url);
      }
      const onErrorHandler = (exception) => {
        if (onError) {
          const inputText = url || input.toString();
          onError(`Error while trying to load image: ${inputText.indexOf("http") === 0 || inputText.length <= 128 ? inputText : inputText.slice(0, 128) + "..."}`, exception);
        }
      };
      if (engine == null ? void 0 : engine._features.forceBitmapOverHTMLImageElement) {
        LoadFile(url, (data) => {
          engine.createImageBitmap(new Blob([data], { type: mimeType }), __spreadValues({ premultiplyAlpha: "none" }, imageBitmapOptions)).then((imgBmp) => {
            onLoad(imgBmp);
            if (usingObjectURL) {
              URL.revokeObjectURL(url);
            }
          }).catch((reason) => {
            if (onError) {
              onError("Error while trying to load image: " + input, reason);
            }
          });
        }, void 0, offlineProvider || void 0, true, (request, exception) => {
          onErrorHandler(exception);
        });
        return null;
      }
      const img = new Image();
      if (LoadImageConfiguration.getRequiredSize) {
        const size = LoadImageConfiguration.getRequiredSize(input);
        if (size.width) {
          img.width = size.width;
        }
        if (size.height) {
          img.height = size.height;
        }
      }
      SetCorsBehavior(url, img);
      const handlersList = [];
      const loadHandlersList = () => {
        handlersList.forEach((handler) => {
          handler.target.addEventListener(handler.name, handler.handler);
        });
      };
      const unloadHandlersList = () => {
        handlersList.forEach((handler) => {
          handler.target.removeEventListener(handler.name, handler.handler);
        });
        handlersList.length = 0;
      };
      const loadHandler = () => {
        unloadHandlersList();
        onLoad(img);
        if (usingObjectURL && img.src) {
          URL.revokeObjectURL(img.src);
        }
      };
      const errorHandler = (err) => {
        unloadHandlersList();
        onErrorHandler(err);
        if (usingObjectURL && img.src) {
          URL.revokeObjectURL(img.src);
        }
      };
      const cspHandler = (err) => {
        if (err.blockedURI !== img.src || err.disposition === "report") {
          return;
        }
        unloadHandlersList();
        const cspException = new Error(`CSP violation of policy ${err.effectiveDirective} ${err.blockedURI}. Current policy is ${err.originalPolicy}`);
        EngineStore.UseFallbackTexture = false;
        onErrorHandler(cspException);
        if (usingObjectURL && img.src) {
          URL.revokeObjectURL(img.src);
        }
        img.src = "";
      };
      handlersList.push({ target: img, name: "load", handler: loadHandler });
      handlersList.push({ target: img, name: "error", handler: errorHandler });
      handlersList.push({ target: document, name: "securitypolicyviolation", handler: cspHandler });
      loadHandlersList();
      const fromBlob = url.substring(0, 5) === "blob:";
      const fromData = url.substring(0, 5) === "data:";
      const noOfflineSupport = () => {
        if (fromBlob || fromData || !WebRequest.IsCustomRequestAvailable) {
          img.src = url;
        } else {
          LoadFile(url, (data, _, contentType) => {
            const type = !mimeType && contentType ? contentType : mimeType;
            const blob = new Blob([data], { type });
            const url2 = URL.createObjectURL(blob);
            usingObjectURL = true;
            img.src = url2;
          }, void 0, offlineProvider || void 0, true, (_request, exception) => {
            onErrorHandler(exception);
          });
        }
      };
      const loadFromOfflineSupport = () => {
        if (offlineProvider) {
          offlineProvider.loadImage(url, img);
        }
      };
      if (!fromBlob && !fromData && offlineProvider && offlineProvider.enableTexturesOffline) {
        offlineProvider.open(loadFromOfflineSupport, noOfflineSupport);
      } else {
        if (url.indexOf("file:") !== -1) {
          const textureName = decodeURIComponent(url.substring(5).toLowerCase());
          if (FilesInputStore.FilesToLoad[textureName] && typeof URL !== "undefined") {
            try {
              let blobURL;
              try {
                blobURL = URL.createObjectURL(FilesInputStore.FilesToLoad[textureName]);
              } catch (ex) {
                blobURL = URL.createObjectURL(FilesInputStore.FilesToLoad[textureName]);
              }
              img.src = blobURL;
              usingObjectURL = true;
            } catch (e) {
              img.src = "";
            }
            return img;
          }
        }
        noOfflineSupport();
      }
      return img;
    };
    ReadFile = (file, onSuccess, onProgress, useArrayBuffer, onError) => {
      const reader = new FileReader();
      const fileRequest = {
        onCompleteObservable: new Observable(),
        abort: () => reader.abort()
      };
      reader.onloadend = () => fileRequest.onCompleteObservable.notifyObservers(fileRequest);
      if (onError) {
        reader.onerror = () => {
          onError(new ReadFileError(`Unable to read ${file.name}`, file));
        };
      }
      reader.onload = (e) => {
        onSuccess(e.target["result"]);
      };
      if (onProgress) {
        reader.onprogress = onProgress;
      }
      if (!useArrayBuffer) {
        reader.readAsText(file);
      } else {
        reader.readAsArrayBuffer(file);
      }
      return fileRequest;
    };
    LoadFile = (fileOrUrl, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError, onOpened) => {
      if (fileOrUrl.name) {
        return ReadFile(fileOrUrl, onSuccess, onProgress, useArrayBuffer, onError ? (error) => {
          onError(void 0, error);
        } : void 0);
      }
      const url = fileOrUrl;
      if (url.indexOf("file:") !== -1) {
        let fileName = decodeURIComponent(url.substring(5).toLowerCase());
        if (fileName.indexOf("./") === 0) {
          fileName = fileName.substring(2);
        }
        const file = FilesInputStore.FilesToLoad[fileName];
        if (file) {
          return ReadFile(file, onSuccess, onProgress, useArrayBuffer, onError ? (error) => onError(void 0, new LoadFileError(error.message, error.file)) : void 0);
        }
      }
      const { match, type } = TestBase64DataUrl(url);
      if (match) {
        const fileRequest = {
          onCompleteObservable: new Observable(),
          abort: () => () => {
          }
        };
        try {
          const data = useArrayBuffer ? DecodeBase64UrlToBinary(url) : DecodeBase64UrlToString(url);
          onSuccess(data, void 0, type);
        } catch (error) {
          if (onError) {
            onError(void 0, error);
          } else {
            Logger.Error(error.message || "Failed to parse the Data URL");
          }
        }
        TimingTools.SetImmediate(() => {
          fileRequest.onCompleteObservable.notifyObservers(fileRequest);
        });
        return fileRequest;
      }
      return RequestFile(url, (data, request) => {
        onSuccess(data, request == null ? void 0 : request.responseURL, request == null ? void 0 : request.getResponseHeader("content-type"));
      }, onProgress, offlineProvider, useArrayBuffer, onError ? (error) => {
        onError(error.request, new LoadFileError(error.message, error.request));
      } : void 0, onOpened);
    };
    RequestFile = (url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError, onOpened) => {
      url = FileToolsOptions.CleanUrl(url);
      url = FileToolsOptions.PreprocessUrl(url);
      const loadUrl = FileToolsOptions.BaseUrl + url;
      let aborted = false;
      const fileRequest = {
        onCompleteObservable: new Observable(),
        abort: () => aborted = true
      };
      const requestFile = () => {
        let request = new WebRequest();
        let retryHandle = null;
        let onReadyStateChange;
        const unbindEvents = () => {
          if (!request) {
            return;
          }
          if (onProgress) {
            request.removeEventListener("progress", onProgress);
          }
          if (onReadyStateChange) {
            request.removeEventListener("readystatechange", onReadyStateChange);
          }
          request.removeEventListener("loadend", onLoadEnd);
        };
        let onLoadEnd = () => {
          unbindEvents();
          fileRequest.onCompleteObservable.notifyObservers(fileRequest);
          fileRequest.onCompleteObservable.clear();
          onProgress = void 0;
          onReadyStateChange = null;
          onLoadEnd = null;
          onError = void 0;
          onOpened = void 0;
          onSuccess = void 0;
        };
        fileRequest.abort = () => {
          aborted = true;
          if (onLoadEnd) {
            onLoadEnd();
          }
          if (request && request.readyState !== (XMLHttpRequest.DONE || 4)) {
            request.abort();
          }
          if (retryHandle !== null) {
            clearTimeout(retryHandle);
            retryHandle = null;
          }
          request = null;
        };
        const handleError = (error) => {
          const message = error.message || "Unknown error";
          if (onError && request) {
            onError(new RequestFileError(message, request));
          } else {
            Logger.Error(message);
          }
        };
        const retryLoop = (retryIndex) => {
          if (!request) {
            return;
          }
          request.open("GET", loadUrl);
          if (onOpened) {
            try {
              onOpened(request);
            } catch (e) {
              handleError(e);
              return;
            }
          }
          if (useArrayBuffer) {
            request.responseType = "arraybuffer";
          }
          if (onProgress) {
            request.addEventListener("progress", onProgress);
          }
          if (onLoadEnd) {
            request.addEventListener("loadend", onLoadEnd);
          }
          onReadyStateChange = () => {
            if (aborted || !request) {
              return;
            }
            if (request.readyState === (XMLHttpRequest.DONE || 4)) {
              if (onReadyStateChange) {
                request.removeEventListener("readystatechange", onReadyStateChange);
              }
              if (request.status >= 200 && request.status < 300 || request.status === 0 && (!IsWindowObjectExist() || IsFileURL())) {
                try {
                  if (onSuccess) {
                    onSuccess(useArrayBuffer ? request.response : request.responseText, request);
                  }
                } catch (e) {
                  handleError(e);
                }
                return;
              }
              const retryStrategy = FileToolsOptions.DefaultRetryStrategy;
              if (retryStrategy) {
                const waitTime = retryStrategy(loadUrl, request, retryIndex);
                if (waitTime !== -1) {
                  unbindEvents();
                  request = new WebRequest();
                  retryHandle = setTimeout(() => retryLoop(retryIndex + 1), waitTime);
                  return;
                }
              }
              const error = new RequestFileError("Error status: " + request.status + " " + request.statusText + " - Unable to load " + loadUrl, request);
              if (onError) {
                onError(error);
              }
            }
          };
          request.addEventListener("readystatechange", onReadyStateChange);
          request.send();
        };
        retryLoop(0);
      };
      if (offlineProvider && offlineProvider.enableSceneOffline) {
        const noOfflineSupport = (request) => {
          if (request && request.status > 400) {
            if (onError) {
              onError(request);
            }
          } else {
            requestFile();
          }
        };
        const loadFromOfflineSupport = () => {
          if (offlineProvider) {
            offlineProvider.loadFile(FileToolsOptions.BaseUrl + url, (data) => {
              if (!aborted && onSuccess) {
                onSuccess(data);
              }
              fileRequest.onCompleteObservable.notifyObservers(fileRequest);
            }, onProgress ? (event) => {
              if (!aborted && onProgress) {
                onProgress(event);
              }
            } : void 0, noOfflineSupport, useArrayBuffer);
          }
        };
        offlineProvider.open(loadFromOfflineSupport, noOfflineSupport);
      } else {
        requestFile();
      }
      return fileRequest;
    };
    IsFileURL = () => {
      return typeof location !== "undefined" && location.protocol === "file:";
    };
    IsBase64DataUrl = (uri) => {
      return Base64DataUrlRegEx.test(uri);
    };
    TestBase64DataUrl = (uri) => {
      const results = Base64DataUrlRegEx.exec(uri);
      if (results === null || results.length === 0) {
        return { match: false, type: "" };
      } else {
        const type = results[0].replace("data:", "").replace("base64,", "");
        return { match: true, type };
      }
    };
    DecodeBase64UrlToString = (uri) => {
      return DecodeBase64ToString(uri.split(",")[1]);
    };
    initSideEffects = () => {
      AbstractEngine._FileToolsLoadImage = LoadImage;
      EngineFunctionContext.loadFile = LoadFile;
      _functionContainer.loadFile = LoadFile;
    };
    initSideEffects();
    _injectLTSFileTools = (DecodeBase64UrlToBinary2, DecodeBase64UrlToString2, FileToolsOptions2, IsBase64DataUrl2, IsFileURL2, LoadFile2, LoadImage2, ReadFile2, RequestFile2, SetCorsBehavior2) => {
      FileTools = {
        DecodeBase64UrlToBinary: DecodeBase64UrlToBinary2,
        DecodeBase64UrlToString: DecodeBase64UrlToString2,
        DefaultRetryStrategy: FileToolsOptions2.DefaultRetryStrategy,
        BaseUrl: FileToolsOptions2.BaseUrl,
        CorsBehavior: FileToolsOptions2.CorsBehavior,
        PreprocessUrl: FileToolsOptions2.PreprocessUrl,
        IsBase64DataUrl: IsBase64DataUrl2,
        IsFileURL: IsFileURL2,
        LoadFile: LoadFile2,
        LoadImage: LoadImage2,
        ReadFile: ReadFile2,
        RequestFile: RequestFile2,
        SetCorsBehavior: SetCorsBehavior2
      };
      Object.defineProperty(FileTools, "DefaultRetryStrategy", {
        get: function() {
          return FileToolsOptions2.DefaultRetryStrategy;
        },
        set: function(value) {
          FileToolsOptions2.DefaultRetryStrategy = value;
        }
      });
      Object.defineProperty(FileTools, "BaseUrl", {
        get: function() {
          return FileToolsOptions2.BaseUrl;
        },
        set: function(value) {
          FileToolsOptions2.BaseUrl = value;
        }
      });
      Object.defineProperty(FileTools, "PreprocessUrl", {
        get: function() {
          return FileToolsOptions2.PreprocessUrl;
        },
        set: function(value) {
          FileToolsOptions2.PreprocessUrl = value;
        }
      });
      Object.defineProperty(FileTools, "CorsBehavior", {
        get: function() {
          return FileToolsOptions2.CorsBehavior;
        },
        set: function(value) {
          FileToolsOptions2.CorsBehavior = value;
        }
      });
    };
    _injectLTSFileTools(DecodeBase64UrlToBinary, DecodeBase64UrlToString, FileToolsOptions, IsBase64DataUrl, IsFileURL, LoadFile, LoadImage, ReadFile, RequestFile, SetCorsBehavior);
  }
});

// node_modules/@babylonjs/core/Misc/instantiationTools.js
var InstantiationTools;
var init_instantiationTools = __esm({
  "node_modules/@babylonjs/core/Misc/instantiationTools.js"() {
    "use strict";
    init_logger();
    init_typeStore();
    InstantiationTools = class {
      /**
       * Tries to instantiate a new object from a given class name
       * @param className defines the class name to instantiate
       * @returns the new object or null if the system was not able to do the instantiation
       */
      static Instantiate(className2) {
        if (this.RegisteredExternalClasses && this.RegisteredExternalClasses[className2]) {
          return this.RegisteredExternalClasses[className2];
        }
        const internalClass = GetClass(className2);
        if (internalClass) {
          return internalClass;
        }
        Logger.Warn(className2 + " not found, you may have missed an import.");
        const arr = className2.split(".");
        let fn = window || this;
        for (let i = 0, len = arr.length; i < len; i++) {
          fn = fn[arr[i]];
        }
        if (typeof fn !== "function") {
          return null;
        }
        return fn;
      }
    };
    InstantiationTools.RegisteredExternalClasses = {};
  }
});

// node_modules/@babylonjs/core/Misc/guid.js
function RandomGUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0, v = c === "x" ? r : r & 3 | 8;
    return v.toString(16);
  });
}
var GUID;
var init_guid = __esm({
  "node_modules/@babylonjs/core/Misc/guid.js"() {
    "use strict";
    GUID = {
      /**
       * Implementation from http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#answer-2117523
       * Be aware Math.random() could cause collisions, but:
       * "All but 6 of the 128 bits of the ID are randomly generated, which means that for any two ids, there's a 1 in 2^^122 (or 5.3x10^^36) chance they'll collide"
       * @returns a pseudo random id
       */
      // eslint-disable-next-line @typescript-eslint/naming-convention
      RandomId: RandomGUID
    };
  }
});

// node_modules/@babylonjs/core/Misc/tools.functions.js
function IsExponentOfTwo(value) {
  let count = 1;
  do {
    count *= 2;
  } while (count < value);
  return count === value;
}
function Mix(a, b, alpha) {
  return a * (1 - alpha) + b * alpha;
}
function NearestPOT(x) {
  const c = CeilingPOT(x);
  const f = FloorPOT(x);
  return c - x > x - f ? f : c;
}
function CeilingPOT(x) {
  x--;
  x |= x >> 1;
  x |= x >> 2;
  x |= x >> 4;
  x |= x >> 8;
  x |= x >> 16;
  x++;
  return x;
}
function FloorPOT(x) {
  x = x | x >> 1;
  x = x | x >> 2;
  x = x | x >> 4;
  x = x | x >> 8;
  x = x | x >> 16;
  return x - (x >> 1);
}
function GetExponentOfTwo(value, max, mode = 2) {
  let pot;
  switch (mode) {
    case 1:
      pot = FloorPOT(value);
      break;
    case 2:
      pot = NearestPOT(value);
      break;
    case 3:
    default:
      pot = CeilingPOT(value);
      break;
  }
  return Math.min(pot, max);
}
var init_tools_functions = __esm({
  "node_modules/@babylonjs/core/Misc/tools.functions.js"() {
    "use strict";
  }
});

// node_modules/@babylonjs/core/Misc/tools.js
function className(name2, module) {
  return (target) => {
    target["__bjsclassName__"] = name2;
    target["__bjsmoduleName__"] = module != null ? module : null;
  };
}
var Tools, AsyncLoop;
var init_tools = __esm({
  "node_modules/@babylonjs/core/Misc/tools.js"() {
    "use strict";
    init_observable();
    init_domManagement();
    init_logger();
    init_deepCopier();
    init_precisionDate();
    init_devTools();
    init_webRequest();
    init_engineStore();
    init_fileTools();
    init_timingTools();
    init_instantiationTools();
    init_guid();
    init_tools_functions();
    Tools = class _Tools {
      /**
       * Gets or sets the base URL to use to load assets
       */
      static get BaseUrl() {
        return FileToolsOptions.BaseUrl;
      }
      static set BaseUrl(value) {
        FileToolsOptions.BaseUrl = value;
      }
      /**
       * Gets or sets the clean URL function to use to load assets
       */
      static get CleanUrl() {
        return FileToolsOptions.CleanUrl;
      }
      static set CleanUrl(value) {
        FileToolsOptions.CleanUrl = value;
      }
      /**
       * This function checks whether a URL is absolute or not.
       * It will also detect data and blob URLs
       * @param url the url to check
       * @returns is the url absolute or relative
       */
      static IsAbsoluteUrl(url) {
        if (url.indexOf("//") === 0) {
          return true;
        }
        if (url.indexOf("://") === -1) {
          return false;
        }
        if (url.indexOf(".") === -1) {
          return false;
        }
        if (url.indexOf("/") === -1) {
          return false;
        }
        if (url.indexOf(":") > url.indexOf("/")) {
          return false;
        }
        if (url.indexOf("://") < url.indexOf(".")) {
          return true;
        }
        if (url.indexOf("data:") === 0 || url.indexOf("blob:") === 0) {
          return true;
        }
        return false;
      }
      /**
       * Sets the base URL to use to load scripts
       */
      static set ScriptBaseUrl(value) {
        FileToolsOptions.ScriptBaseUrl = value;
      }
      static get ScriptBaseUrl() {
        return FileToolsOptions.ScriptBaseUrl;
      }
      /**
       * Sets a preprocessing function to run on a source URL before importing it
       * Note that this function will execute AFTER the base URL is appended to the URL
       */
      static set ScriptPreprocessUrl(func) {
        FileToolsOptions.ScriptPreprocessUrl = func;
      }
      static get ScriptPreprocessUrl() {
        return FileToolsOptions.ScriptPreprocessUrl;
      }
      /**
       * Gets or sets the retry strategy to apply when an error happens while loading an asset
       */
      static get DefaultRetryStrategy() {
        return FileToolsOptions.DefaultRetryStrategy;
      }
      static set DefaultRetryStrategy(strategy) {
        FileToolsOptions.DefaultRetryStrategy = strategy;
      }
      /**
       * Default behavior for cors in the application.
       * It can be a string if the expected behavior is identical in the entire app.
       * Or a callback to be able to set it per url or on a group of them (in case of Video source for instance)
       */
      static get CorsBehavior() {
        return FileToolsOptions.CorsBehavior;
      }
      static set CorsBehavior(value) {
        FileToolsOptions.CorsBehavior = value;
      }
      /**
       * Gets or sets a global variable indicating if fallback texture must be used when a texture cannot be loaded
       * @ignorenaming
       */
      static get UseFallbackTexture() {
        return EngineStore.UseFallbackTexture;
      }
      static set UseFallbackTexture(value) {
        EngineStore.UseFallbackTexture = value;
      }
      /**
       * Use this object to register external classes like custom textures or material
       * to allow the loaders to instantiate them
       */
      static get RegisteredExternalClasses() {
        return InstantiationTools.RegisteredExternalClasses;
      }
      static set RegisteredExternalClasses(classes) {
        InstantiationTools.RegisteredExternalClasses = classes;
      }
      /**
       * Texture content used if a texture cannot loaded
       * @ignorenaming
       */
      // eslint-disable-next-line @typescript-eslint/naming-convention
      static get fallbackTexture() {
        return EngineStore.FallbackTexture;
      }
      // eslint-disable-next-line @typescript-eslint/naming-convention
      static set fallbackTexture(value) {
        EngineStore.FallbackTexture = value;
      }
      /**
       * Read the content of a byte array at a specified coordinates (taking in account wrapping)
       * @param u defines the coordinate on X axis
       * @param v defines the coordinate on Y axis
       * @param width defines the width of the source data
       * @param height defines the height of the source data
       * @param pixels defines the source byte array
       * @param color defines the output color
       */
      static FetchToRef(u, v, width, height, pixels, color) {
        const wrappedU = Math.abs(u) * width % width | 0;
        const wrappedV = Math.abs(v) * height % height | 0;
        const position = (wrappedU + wrappedV * width) * 4;
        color.r = pixels[position] / 255;
        color.g = pixels[position + 1] / 255;
        color.b = pixels[position + 2] / 255;
        color.a = pixels[position + 3] / 255;
      }
      /**
       * Interpolates between a and b via alpha
       * @param a The lower value (returned when alpha = 0)
       * @param b The upper value (returned when alpha = 1)
       * @param alpha The interpolation-factor
       * @returns The mixed value
       */
      static Mix(a, b, alpha) {
        return 0;
      }
      /**
       * Tries to instantiate a new object from a given class name
       * @param className defines the class name to instantiate
       * @returns the new object or null if the system was not able to do the instantiation
       */
      static Instantiate(className2) {
        return InstantiationTools.Instantiate(className2);
      }
      /**
       * Polyfill for setImmediate
       * @param action defines the action to execute after the current execution block
       */
      static SetImmediate(action) {
        TimingTools.SetImmediate(action);
      }
      /**
       * Function indicating if a number is an exponent of 2
       * @param value defines the value to test
       * @returns true if the value is an exponent of 2
       */
      static IsExponentOfTwo(value) {
        return true;
      }
      /**
       * Returns the nearest 32-bit single precision float representation of a Number
       * @param value A Number.  If the parameter is of a different type, it will get converted
       * to a number or to NaN if it cannot be converted
       * @returns number
       */
      static FloatRound(value) {
        return Math.fround(value);
      }
      /**
       * Extracts the filename from a path
       * @param path defines the path to use
       * @returns the filename
       */
      static GetFilename(path) {
        const index = path.lastIndexOf("/");
        if (index < 0) {
          return path;
        }
        return path.substring(index + 1);
      }
      /**
       * Extracts the "folder" part of a path (everything before the filename).
       * @param uri The URI to extract the info from
       * @param returnUnchangedIfNoSlash Do not touch the URI if no slashes are present
       * @returns The "folder" part of the path
       */
      static GetFolderPath(uri, returnUnchangedIfNoSlash = false) {
        const index = uri.lastIndexOf("/");
        if (index < 0) {
          if (returnUnchangedIfNoSlash) {
            return uri;
          }
          return "";
        }
        return uri.substring(0, index + 1);
      }
      /**
       * Convert an angle in radians to degrees
       * @param angle defines the angle to convert
       * @returns the angle in degrees
       */
      static ToDegrees(angle) {
        return angle * 180 / Math.PI;
      }
      /**
       * Convert an angle in degrees to radians
       * @param angle defines the angle to convert
       * @returns the angle in radians
       */
      static ToRadians(angle) {
        return angle * Math.PI / 180;
      }
      /**
       * Smooth angle changes (kind of low-pass filter), in particular for device orientation "shaking"
       * Use trigonometric functions to avoid discontinuity (0/360, -180/180)
       * @param previousAngle defines last angle value, in degrees
       * @param newAngle defines new angle value, in degrees
       * @param smoothFactor defines smoothing sensitivity; min 0: no smoothing, max 1: new data ignored
       * @returns the angle in degrees
       */
      static SmoothAngleChange(previousAngle, newAngle, smoothFactor = 0.9) {
        const previousAngleRad = this.ToRadians(previousAngle);
        const newAngleRad = this.ToRadians(newAngle);
        return this.ToDegrees(Math.atan2((1 - smoothFactor) * Math.sin(newAngleRad) + smoothFactor * Math.sin(previousAngleRad), (1 - smoothFactor) * Math.cos(newAngleRad) + smoothFactor * Math.cos(previousAngleRad)));
      }
      /**
       * Returns an array if obj is not an array
       * @param obj defines the object to evaluate as an array
       * @param allowsNullUndefined defines a boolean indicating if obj is allowed to be null or undefined
       * @returns either obj directly if obj is an array or a new array containing obj
       */
      static MakeArray(obj, allowsNullUndefined) {
        if (allowsNullUndefined !== true && (obj === void 0 || obj == null)) {
          return null;
        }
        return Array.isArray(obj) ? obj : [obj];
      }
      /**
       * Gets the pointer prefix to use
       * @param engine defines the engine we are finding the prefix for
       * @returns "pointer" if touch is enabled. Else returns "mouse"
       */
      static GetPointerPrefix(engine) {
        let eventPrefix = "pointer";
        if (IsWindowObjectExist() && !window.PointerEvent) {
          eventPrefix = "mouse";
        }
        if (engine._badDesktopOS && !engine._badOS && // And not ipad pros who claim to be macs...
        !(document && "ontouchend" in document)) {
          eventPrefix = "mouse";
        }
        return eventPrefix;
      }
      /**
       * Sets the cors behavior on a dom element. This will add the required Tools.CorsBehavior to the element.
       * @param url define the url we are trying
       * @param element define the dom element where to configure the cors policy
       * @param element.crossOrigin
       */
      static SetCorsBehavior(url, element) {
        SetCorsBehavior(url, element);
      }
      /**
       * Sets the referrerPolicy behavior on a dom element.
       * @param referrerPolicy define the referrer policy to use
       * @param element define the dom element where to configure the referrer policy
       * @param element.referrerPolicy
       */
      static SetReferrerPolicyBehavior(referrerPolicy, element) {
        element.referrerPolicy = referrerPolicy;
      }
      // External files
      /**
       * Gets or sets a function used to pre-process url before using them to load assets
       */
      static get PreprocessUrl() {
        return FileToolsOptions.PreprocessUrl;
      }
      static set PreprocessUrl(processor) {
        FileToolsOptions.PreprocessUrl = processor;
      }
      /**
       * Loads an image as an HTMLImageElement.
       * @param input url string, ArrayBuffer, or Blob to load
       * @param onLoad callback called when the image successfully loads
       * @param onError callback called when the image fails to load
       * @param offlineProvider offline provider for caching
       * @param mimeType optional mime type
       * @param imageBitmapOptions optional the options to use when creating an ImageBitmap
       * @returns the HTMLImageElement of the loaded image
       */
      static LoadImage(input, onLoad, onError, offlineProvider, mimeType, imageBitmapOptions) {
        return LoadImage(input, onLoad, onError, offlineProvider, mimeType, imageBitmapOptions);
      }
      /**
       * Loads a file from a url
       * @param url url string, ArrayBuffer, or Blob to load
       * @param onSuccess callback called when the file successfully loads
       * @param onProgress callback called while file is loading (if the server supports this mode)
       * @param offlineProvider defines the offline provider for caching
       * @param useArrayBuffer defines a boolean indicating that date must be returned as ArrayBuffer
       * @param onError callback called when the file fails to load
       * @returns a file request object
       */
      static LoadFile(url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError) {
        return LoadFile(url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError);
      }
      /**
       * Loads a file from a url
       * @param url the file url to load
       * @param useArrayBuffer defines a boolean indicating that date must be returned as ArrayBuffer
       * @returns a promise containing an ArrayBuffer corresponding to the loaded file
       */
      static LoadFileAsync(url, useArrayBuffer = true) {
        return new Promise((resolve, reject) => {
          LoadFile(url, (data) => {
            resolve(data);
          }, void 0, void 0, useArrayBuffer, (request, exception) => {
            reject(exception);
          });
        });
      }
      /**
       * Get a script URL including preprocessing
       * @param scriptUrl the script Url to process
       * @param forceAbsoluteUrl force the script to be an absolute url (adding the current base url if necessary)
       * @returns a modified URL to use
       */
      static GetBabylonScriptURL(scriptUrl, forceAbsoluteUrl) {
        if (!scriptUrl) {
          return "";
        }
        if (_Tools.ScriptBaseUrl && scriptUrl.startsWith(_Tools._DefaultCdnUrl)) {
          const baseUrl = _Tools.ScriptBaseUrl[_Tools.ScriptBaseUrl.length - 1] === "/" ? _Tools.ScriptBaseUrl.substring(0, _Tools.ScriptBaseUrl.length - 1) : _Tools.ScriptBaseUrl;
          scriptUrl = scriptUrl.replace(_Tools._DefaultCdnUrl, baseUrl);
        }
        scriptUrl = _Tools.ScriptPreprocessUrl(scriptUrl);
        if (forceAbsoluteUrl) {
          scriptUrl = _Tools.GetAbsoluteUrl(scriptUrl);
        }
        return scriptUrl;
      }
      /**
       * This function is used internally by babylon components to load a script (identified by an url). When the url returns, the
       * content of this file is added into a new script element, attached to the DOM (body element)
       * @param scriptUrl defines the url of the script to load
       * @param onSuccess defines the callback called when the script is loaded
       * @param onError defines the callback to call if an error occurs
       * @param scriptId defines the id of the script element
       */
      static LoadBabylonScript(scriptUrl, onSuccess, onError, scriptId) {
        scriptUrl = _Tools.GetBabylonScriptURL(scriptUrl);
        _Tools.LoadScript(scriptUrl, onSuccess, onError);
      }
      /**
       * Load an asynchronous script (identified by an url). When the url returns, the
       * content of this file is added into a new script element, attached to the DOM (body element)
       * @param scriptUrl defines the url of the script to laod
       * @returns a promise request object
       */
      static LoadBabylonScriptAsync(scriptUrl) {
        scriptUrl = _Tools.GetBabylonScriptURL(scriptUrl);
        return _Tools.LoadScriptAsync(scriptUrl);
      }
      /**
       * This function is used internally by babylon components to load a script (identified by an url). When the url returns, the
       * content of this file is added into a new script element, attached to the DOM (body element)
       * @param scriptUrl defines the url of the script to load
       * @param onSuccess defines the callback called when the script is loaded
       * @param onError defines the callback to call if an error occurs
       * @param scriptId defines the id of the script element
       */
      static LoadScript(scriptUrl, onSuccess, onError, scriptId) {
        if (typeof importScripts === "function") {
          try {
            importScripts(scriptUrl);
            onSuccess();
          } catch (e) {
            onError == null ? void 0 : onError(`Unable to load script '${scriptUrl}' in worker`, e);
          }
          return;
        } else if (!IsWindowObjectExist()) {
          onError == null ? void 0 : onError(`Cannot load script '${scriptUrl}' outside of a window or a worker`);
          return;
        }
        const head = document.getElementsByTagName("head")[0];
        const script = document.createElement("script");
        script.setAttribute("type", "text/javascript");
        script.setAttribute("src", scriptUrl);
        if (scriptId) {
          script.id = scriptId;
        }
        script.onload = () => {
          if (onSuccess) {
            onSuccess();
          }
        };
        script.onerror = (e) => {
          if (onError) {
            onError(`Unable to load script '${scriptUrl}'`, e);
          }
        };
        head.appendChild(script);
      }
      /**
       * Load an asynchronous script (identified by an url). When the url returns, the
       * content of this file is added into a new script element, attached to the DOM (body element)
       * @param scriptUrl defines the url of the script to load
       * @param scriptId defines the id of the script element
       * @returns a promise request object
       */
      static LoadScriptAsync(scriptUrl, scriptId) {
        return new Promise((resolve, reject) => {
          this.LoadScript(scriptUrl, () => {
            resolve();
          }, (message, exception) => {
            reject(exception || new Error(message));
          }, scriptId);
        });
      }
      /**
       * Loads a file from a blob
       * @param fileToLoad defines the blob to use
       * @param callback defines the callback to call when data is loaded
       * @param progressCallback defines the callback to call during loading process
       * @returns a file request object
       */
      static ReadFileAsDataURL(fileToLoad, callback, progressCallback) {
        const reader = new FileReader();
        const request = {
          onCompleteObservable: new Observable(),
          abort: () => reader.abort()
        };
        reader.onloadend = () => {
          request.onCompleteObservable.notifyObservers(request);
        };
        reader.onload = (e) => {
          callback(e.target["result"]);
        };
        reader.onprogress = progressCallback;
        reader.readAsDataURL(fileToLoad);
        return request;
      }
      /**
       * Reads a file from a File object
       * @param file defines the file to load
       * @param onSuccess defines the callback to call when data is loaded
       * @param onProgress defines the callback to call during loading process
       * @param useArrayBuffer defines a boolean indicating that data must be returned as an ArrayBuffer
       * @param onError defines the callback to call when an error occurs
       * @returns a file request object
       */
      static ReadFile(file, onSuccess, onProgress, useArrayBuffer, onError) {
        return ReadFile(file, onSuccess, onProgress, useArrayBuffer, onError);
      }
      /**
       * Creates a data url from a given string content
       * @param content defines the content to convert
       * @returns the new data url link
       */
      static FileAsURL(content) {
        const fileBlob = new Blob([content]);
        const url = window.URL;
        const link = url.createObjectURL(fileBlob);
        return link;
      }
      /**
       * Format the given number to a specific decimal format
       * @param value defines the number to format
       * @param decimals defines the number of decimals to use
       * @returns the formatted string
       */
      static Format(value, decimals = 2) {
        return value.toFixed(decimals);
      }
      /**
       * Tries to copy an object by duplicating every property
       * @param source defines the source object
       * @param destination defines the target object
       * @param doNotCopyList defines a list of properties to avoid
       * @param mustCopyList defines a list of properties to copy (even if they start with _)
       */
      static DeepCopy(source, destination, doNotCopyList, mustCopyList) {
        DeepCopier.DeepCopy(source, destination, doNotCopyList, mustCopyList);
      }
      /**
       * Gets a boolean indicating if the given object has no own property
       * @param obj defines the object to test
       * @returns true if object has no own property
       */
      static IsEmpty(obj) {
        for (const i in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, i)) {
            return false;
          }
        }
        return true;
      }
      /**
       * Function used to register events at window level
       * @param windowElement defines the Window object to use
       * @param events defines the events to register
       */
      static RegisterTopRootEvents(windowElement, events) {
        for (let index = 0; index < events.length; index++) {
          const event = events[index];
          windowElement.addEventListener(event.name, event.handler, false);
          try {
            if (window.parent) {
              window.parent.addEventListener(event.name, event.handler, false);
            }
          } catch (e) {
          }
        }
      }
      /**
       * Function used to unregister events from window level
       * @param windowElement defines the Window object to use
       * @param events defines the events to unregister
       */
      static UnregisterTopRootEvents(windowElement, events) {
        for (let index = 0; index < events.length; index++) {
          const event = events[index];
          windowElement.removeEventListener(event.name, event.handler);
          try {
            if (windowElement.parent) {
              windowElement.parent.removeEventListener(event.name, event.handler);
            }
          } catch (e) {
          }
        }
      }
      /**
       * Dumps the current bound framebuffer
       * @param width defines the rendering width
       * @param height defines the rendering height
       * @param engine defines the hosting engine
       * @param successCallback defines the callback triggered once the data are available
       * @param mimeType defines the mime type of the result
       * @param fileName defines the filename to download. If present, the result will automatically be downloaded
       * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
       * @returns a void promise
       */
      static DumpFramebuffer(width, height, engine, successCallback, mimeType = "image/png", fileName, quality) {
        return __async(this, null, function* () {
          throw _WarnImport("DumpTools");
        });
      }
      /**
       * Dumps an array buffer
       * @param width defines the rendering width
       * @param height defines the rendering height
       * @param data the data array
       * @param successCallback defines the callback triggered once the data are available
       * @param mimeType defines the mime type of the result
       * @param fileName defines the filename to download. If present, the result will automatically be downloaded
       * @param invertY true to invert the picture in the Y dimension
       * @param toArrayBuffer true to convert the data to an ArrayBuffer (encoded as `mimeType`) instead of a base64 string
       * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
       */
      static DumpData(width, height, data, successCallback, mimeType = "image/png", fileName, invertY = false, toArrayBuffer = false, quality) {
        throw _WarnImport("DumpTools");
      }
      // eslint-disable-next-line jsdoc/require-returns-check
      /**
       * Dumps an array buffer
       * @param width defines the rendering width
       * @param height defines the rendering height
       * @param data the data array
       * @param mimeType defines the mime type of the result
       * @param fileName defines the filename to download. If present, the result will automatically be downloaded
       * @param invertY true to invert the picture in the Y dimension
       * @param toArrayBuffer true to convert the data to an ArrayBuffer (encoded as `mimeType`) instead of a base64 string
       * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
       * @returns a promise that resolve to the final data
       */
      static DumpDataAsync(width, height, data, mimeType = "image/png", fileName, invertY = false, toArrayBuffer = false, quality) {
        throw _WarnImport("DumpTools");
      }
      static _IsOffScreenCanvas(canvas) {
        return canvas.convertToBlob !== void 0;
      }
      /**
       * Converts the canvas data to blob.
       * This acts as a polyfill for browsers not supporting the to blob function.
       * @param canvas Defines the canvas to extract the data from (can be an offscreen canvas)
       * @param successCallback Defines the callback triggered once the data are available
       * @param mimeType Defines the mime type of the result
       * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
       */
      static ToBlob(canvas, successCallback, mimeType = "image/png", quality) {
        if (!_Tools._IsOffScreenCanvas(canvas) && !canvas.toBlob) {
          canvas.toBlob = function(callback, type, quality2) {
            setTimeout(() => {
              const binStr = atob(this.toDataURL(type, quality2).split(",")[1]), len = binStr.length, arr = new Uint8Array(len);
              for (let i = 0; i < len; i++) {
                arr[i] = binStr.charCodeAt(i);
              }
              callback(new Blob([arr]));
            });
          };
        }
        if (_Tools._IsOffScreenCanvas(canvas)) {
          canvas.convertToBlob({
            type: mimeType,
            quality
          }).then((blob) => successCallback(blob));
        } else {
          canvas.toBlob(function(blob) {
            successCallback(blob);
          }, mimeType, quality);
        }
      }
      /**
       * Download a Blob object
       * @param blob the Blob object
       * @param fileName the file name to download
       */
      static DownloadBlob(blob, fileName) {
        if ("download" in document.createElement("a")) {
          if (!fileName) {
            const date = /* @__PURE__ */ new Date();
            const stringDate = (date.getFullYear() + "-" + (date.getMonth() + 1)).slice(2) + "-" + date.getDate() + "_" + date.getHours() + "-" + ("0" + date.getMinutes()).slice(-2);
            fileName = "screenshot_" + stringDate + ".png";
          }
          _Tools.Download(blob, fileName);
        } else {
          if (blob && typeof URL !== "undefined") {
            const url = URL.createObjectURL(blob);
            const newWindow = window.open("");
            if (!newWindow) {
              return;
            }
            const img = newWindow.document.createElement("img");
            img.onload = function() {
              URL.revokeObjectURL(url);
            };
            img.src = url;
            newWindow.document.body.appendChild(img);
          }
        }
      }
      /**
       * Encodes the canvas data to base 64, or automatically downloads the result if `fileName` is defined.
       * @param canvas The canvas to get the data from, which can be an offscreen canvas.
       * @param successCallback The callback which is triggered once the data is available. If `fileName` is defined, the callback will be invoked after the download occurs, and the `data` argument will be an empty string.
       * @param mimeType The mime type of the result.
       * @param fileName The name of the file to download. If defined, the result will automatically be downloaded. If not defined, and `successCallback` is also not defined, the result will automatically be downloaded with an auto-generated file name.
       * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
       */
      static EncodeScreenshotCanvasData(canvas, successCallback, mimeType = "image/png", fileName, quality) {
        if (typeof fileName === "string" || !successCallback) {
          this.ToBlob(canvas, function(blob) {
            if (blob) {
              _Tools.DownloadBlob(blob, fileName);
            }
            if (successCallback) {
              successCallback("");
            }
          }, mimeType, quality);
        } else if (successCallback) {
          if (_Tools._IsOffScreenCanvas(canvas)) {
            canvas.convertToBlob({
              type: mimeType,
              quality
            }).then((blob) => {
              const reader = new FileReader();
              reader.readAsDataURL(blob);
              reader.onloadend = () => {
                const base64data = reader.result;
                successCallback(base64data);
              };
            });
            return;
          }
          const base64Image = canvas.toDataURL(mimeType, quality);
          successCallback(base64Image);
        }
      }
      /**
       * Downloads a blob in the browser
       * @param blob defines the blob to download
       * @param fileName defines the name of the downloaded file
       */
      static Download(blob, fileName) {
        if (typeof URL === "undefined") {
          return;
        }
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.style.display = "none";
        a.href = url;
        a.download = fileName;
        a.addEventListener("click", () => {
          if (a.parentElement) {
            a.parentElement.removeChild(a);
          }
        });
        a.click();
        window.URL.revokeObjectURL(url);
      }
      /**
       * Will return the right value of the noPreventDefault variable
       * Needed to keep backwards compatibility to the old API.
       *
       * @param args arguments passed to the attachControl function
       * @returns the correct value for noPreventDefault
       */
      static BackCompatCameraNoPreventDefault(args) {
        if (typeof args[0] === "boolean") {
          return args[0];
        } else if (typeof args[1] === "boolean") {
          return args[1];
        }
        return false;
      }
      /**
       * Captures a screenshot of the current rendering
       * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/renderToPNG
       * @param engine defines the rendering engine
       * @param camera defines the source camera
       * @param size This parameter can be set to a single number or to an object with the
       * following (optional) properties: precision, width, height. If a single number is passed,
       * it will be used for both width and height. If an object is passed, the screenshot size
       * will be derived from the parameters. The precision property is a multiplier allowing
       * rendering at a higher or lower resolution
       * @param successCallback defines the callback receives a single parameter which contains the
       * screenshot as a string of base64-encoded characters. This string can be assigned to the
       * src parameter of an <img> to display it
       * @param mimeType defines the MIME type of the screenshot image (default: image/png).
       * Check your browser for supported MIME types
       * @param forceDownload force the system to download the image even if a successCallback is provided
       * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
       */
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      static CreateScreenshot(engine, camera, size, successCallback, mimeType = "image/png", forceDownload = false, quality) {
        throw _WarnImport("ScreenshotTools");
      }
      // eslint-disable-next-line jsdoc/require-returns-check
      /**
       * Captures a screenshot of the current rendering
       * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/renderToPNG
       * @param engine defines the rendering engine
       * @param camera defines the source camera
       * @param size This parameter can be set to a single number or to an object with the
       * following (optional) properties: precision, width, height. If a single number is passed,
       * it will be used for both width and height. If an object is passed, the screenshot size
       * will be derived from the parameters. The precision property is a multiplier allowing
       * rendering at a higher or lower resolution
       * @param mimeType defines the MIME type of the screenshot image (default: image/png).
       * Check your browser for supported MIME types
       * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
       * @returns screenshot as a string of base64-encoded characters. This string can be assigned
       * to the src parameter of an <img> to display it
       */
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      static CreateScreenshotAsync(engine, camera, size, mimeType = "image/png", quality) {
        throw _WarnImport("ScreenshotTools");
      }
      /**
       * Generates an image screenshot from the specified camera.
       * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/renderToPNG
       * @param engine The engine to use for rendering
       * @param camera The camera to use for rendering
       * @param size This parameter can be set to a single number or to an object with the
       * following (optional) properties: precision, width, height. If a single number is passed,
       * it will be used for both width and height. If an object is passed, the screenshot size
       * will be derived from the parameters. The precision property is a multiplier allowing
       * rendering at a higher or lower resolution
       * @param successCallback The callback receives a single parameter which contains the
       * screenshot as a string of base64-encoded characters. This string can be assigned to the
       * src parameter of an <img> to display it
       * @param mimeType The MIME type of the screenshot image (default: image/png).
       * Check your browser for supported MIME types
       * @param samples Texture samples (default: 1)
       * @param antialiasing Whether antialiasing should be turned on or not (default: false)
       * @param fileName A name for for the downloaded file.
       * @param renderSprites Whether the sprites should be rendered or not (default: false)
       * @param enableStencilBuffer Whether the stencil buffer should be enabled or not (default: false)
       * @param useLayerMask if the camera's layer mask should be used to filter what should be rendered (default: true)
       * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
       * @param customizeTexture An optional callback that can be used to modify the render target texture before taking the screenshot. This can be used, for instance, to enable camera post-processes before taking the screenshot.
       */
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      static CreateScreenshotUsingRenderTarget(engine, camera, size, successCallback, mimeType = "image/png", samples = 1, antialiasing = false, fileName, renderSprites = false, enableStencilBuffer = false, useLayerMask = true, quality, customizeTexture) {
        throw _WarnImport("ScreenshotTools");
      }
      // eslint-disable-next-line jsdoc/require-returns-check
      /**
       * Generates an image screenshot from the specified camera.
       * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/renderToPNG
       * @param engine The engine to use for rendering
       * @param camera The camera to use for rendering
       * @param size This parameter can be set to a single number or to an object with the
       * following (optional) properties: precision, width, height. If a single number is passed,
       * it will be used for both width and height. If an object is passed, the screenshot size
       * will be derived from the parameters. The precision property is a multiplier allowing
       * rendering at a higher or lower resolution
       * @param mimeType The MIME type of the screenshot image (default: image/png).
       * Check your browser for supported MIME types
       * @param samples Texture samples (default: 1)
       * @param antialiasing Whether antialiasing should be turned on or not (default: false)
       * @param fileName A name for for the downloaded file.
       * @param renderSprites Whether the sprites should be rendered or not (default: false)
       * @param enableStencilBuffer Whether the stencil buffer should be enabled or not (default: false)
       * @param useLayerMask if the camera's layer mask should be used to filter what should be rendered (default: true)
       * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
       * @param customizeTexture An optional callback that can be used to modify the render target texture before taking the screenshot. This can be used, for instance, to enable camera post-processes before taking the screenshot.
       * @returns screenshot as a string of base64-encoded characters. This string can be assigned
       * to the src parameter of an <img> to display it
       */
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      static CreateScreenshotUsingRenderTargetAsync(engine, camera, size, mimeType = "image/png", samples = 1, antialiasing = false, fileName, renderSprites = false, enableStencilBuffer = false, useLayerMask = true, quality, customizeTexture) {
        throw _WarnImport("ScreenshotTools");
      }
      /**
       * Implementation from http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#answer-2117523
       * Be aware Math.random() could cause collisions, but:
       * "All but 6 of the 128 bits of the ID are randomly generated, which means that for any two ids, there's a 1 in 2^^122 (or 5.3x10^^36) chance they'll collide"
       * @returns a pseudo random id
       */
      static RandomId() {
        return RandomGUID();
      }
      /**
       * Test if the given uri is a base64 string
       * @deprecated Please use FileTools.IsBase64DataUrl instead.
       * @param uri The uri to test
       * @returns True if the uri is a base64 string or false otherwise
       */
      static IsBase64(uri) {
        return IsBase64DataUrl(uri);
      }
      /**
       * Decode the given base64 uri.
       * @deprecated Please use FileTools.DecodeBase64UrlToBinary instead.
       * @param uri The uri to decode
       * @returns The decoded base64 data.
       */
      static DecodeBase64(uri) {
        return DecodeBase64UrlToBinary(uri);
      }
      /**
       * Gets a value indicating the number of loading errors
       * @ignorenaming
       */
      // eslint-disable-next-line @typescript-eslint/naming-convention
      static get errorsCount() {
        return Logger.errorsCount;
      }
      /**
       * Log a message to the console
       * @param message defines the message to log
       */
      static Log(message) {
        Logger.Log(message);
      }
      /**
       * Write a warning message to the console
       * @param message defines the message to log
       */
      static Warn(message) {
        Logger.Warn(message);
      }
      /**
       * Write an error message to the console
       * @param message defines the message to log
       */
      static Error(message) {
        Logger.Error(message);
      }
      /**
       * Gets current log cache (list of logs)
       */
      static get LogCache() {
        return Logger.LogCache;
      }
      /**
       * Clears the log cache
       */
      static ClearLogCache() {
        Logger.ClearLogCache();
      }
      /**
       * Sets the current log level (MessageLogLevel / WarningLogLevel / ErrorLogLevel)
       */
      static set LogLevels(level) {
        Logger.LogLevels = level;
      }
      /**
       * Sets the current performance log level
       */
      static set PerformanceLogLevel(level) {
        if ((level & _Tools.PerformanceUserMarkLogLevel) === _Tools.PerformanceUserMarkLogLevel) {
          _Tools.StartPerformanceCounter = _Tools._StartUserMark;
          _Tools.EndPerformanceCounter = _Tools._EndUserMark;
          return;
        }
        if ((level & _Tools.PerformanceConsoleLogLevel) === _Tools.PerformanceConsoleLogLevel) {
          _Tools.StartPerformanceCounter = _Tools._StartPerformanceConsole;
          _Tools.EndPerformanceCounter = _Tools._EndPerformanceConsole;
          return;
        }
        _Tools.StartPerformanceCounter = _Tools._StartPerformanceCounterDisabled;
        _Tools.EndPerformanceCounter = _Tools._EndPerformanceCounterDisabled;
      }
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      static _StartPerformanceCounterDisabled(counterName, condition) {
      }
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      static _EndPerformanceCounterDisabled(counterName, condition) {
      }
      static _StartUserMark(counterName, condition = true) {
        if (!_Tools._Performance) {
          if (!IsWindowObjectExist()) {
            return;
          }
          _Tools._Performance = window.performance;
        }
        if (!condition || !_Tools._Performance.mark) {
          return;
        }
        _Tools._Performance.mark(counterName + "-Begin");
      }
      static _EndUserMark(counterName, condition = true) {
        if (!condition || !_Tools._Performance.mark) {
          return;
        }
        _Tools._Performance.mark(counterName + "-End");
        _Tools._Performance.measure(counterName, counterName + "-Begin", counterName + "-End");
      }
      static _StartPerformanceConsole(counterName, condition = true) {
        if (!condition) {
          return;
        }
        _Tools._StartUserMark(counterName, condition);
        if (console.time) {
          console.time(counterName);
        }
      }
      static _EndPerformanceConsole(counterName, condition = true) {
        if (!condition) {
          return;
        }
        _Tools._EndUserMark(counterName, condition);
        console.timeEnd(counterName);
      }
      /**
       * Gets either window.performance.now() if supported or Date.now() else
       */
      static get Now() {
        return PrecisionDate.Now;
      }
      /**
       * This method will return the name of the class used to create the instance of the given object.
       * It will works only on Javascript basic data types (number, string, ...) and instance of class declared with the @className decorator.
       * @param object the object to get the class name from
       * @param isType defines if the object is actually a type
       * @returns the name of the class, will be "object" for a custom data type not using the @className decorator
       */
      static GetClassName(object, isType = false) {
        let name2 = null;
        if (!isType && object.getClassName) {
          name2 = object.getClassName();
        } else {
          if (object instanceof Object) {
            const classObj = isType ? object : Object.getPrototypeOf(object);
            name2 = classObj.constructor["__bjsclassName__"];
          }
          if (!name2) {
            name2 = typeof object;
          }
        }
        return name2;
      }
      /**
       * Gets the first element of an array satisfying a given predicate
       * @param array defines the array to browse
       * @param predicate defines the predicate to use
       * @returns null if not found or the element
       */
      static First(array, predicate) {
        for (const el of array) {
          if (predicate(el)) {
            return el;
          }
        }
        return null;
      }
      /**
       * This method will return the name of the full name of the class, including its owning module (if any).
       * It will works only on Javascript basic data types (number, string, ...) and instance of class declared with the @className decorator or implementing a method getClassName():string (in which case the module won't be specified).
       * @param object the object to get the class name from
       * @param isType defines if the object is actually a type
       * @returns a string that can have two forms: "moduleName.className" if module was specified when the class' Name was registered or "className" if there was not module specified.
       * @ignorenaming
       */
      // eslint-disable-next-line @typescript-eslint/naming-convention
      static getFullClassName(object, isType = false) {
        let className2 = null;
        let moduleName = null;
        if (!isType && object.getClassName) {
          className2 = object.getClassName();
        } else {
          if (object instanceof Object) {
            const classObj = isType ? object : Object.getPrototypeOf(object);
            className2 = classObj.constructor["__bjsclassName__"];
            moduleName = classObj.constructor["__bjsmoduleName__"];
          }
          if (!className2) {
            className2 = typeof object;
          }
        }
        if (!className2) {
          return null;
        }
        return (moduleName != null ? moduleName + "." : "") + className2;
      }
      /**
       * Returns a promise that resolves after the given amount of time.
       * @param delay Number of milliseconds to delay
       * @returns Promise that resolves after the given amount of time
       */
      static DelayAsync(delay) {
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve();
          }, delay);
        });
      }
      /**
       * Utility function to detect if the current user agent is Safari
       * @returns whether or not the current user agent is safari
       */
      static IsSafari() {
        if (!IsNavigatorAvailable()) {
          return false;
        }
        return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      }
    };
    Tools.UseCustomRequestHeaders = false;
    Tools.CustomRequestHeaders = WebRequest.CustomRequestHeaders;
    Tools.GetDOMTextContent = GetDOMTextContent;
    Tools._DefaultCdnUrl = "https://cdn.babylonjs.com";
    Tools.GetAbsoluteUrl = typeof document === "object" ? (url) => {
      const a = document.createElement("a");
      a.href = url;
      return a.href;
    } : typeof URL === "function" && typeof location === "object" ? (url) => new URL(url, location.origin).href : () => {
      throw new Error("Unable to get absolute URL. Override BABYLON.Tools.GetAbsoluteUrl to a custom implementation for the current context.");
    };
    Tools.NoneLogLevel = Logger.NoneLogLevel;
    Tools.MessageLogLevel = Logger.MessageLogLevel;
    Tools.WarningLogLevel = Logger.WarningLogLevel;
    Tools.ErrorLogLevel = Logger.ErrorLogLevel;
    Tools.AllLogLevel = Logger.AllLogLevel;
    Tools.IsWindowObjectExist = IsWindowObjectExist;
    Tools.PerformanceNoneLogLevel = 0;
    Tools.PerformanceUserMarkLogLevel = 1;
    Tools.PerformanceConsoleLogLevel = 2;
    Tools.StartPerformanceCounter = Tools._StartPerformanceCounterDisabled;
    Tools.EndPerformanceCounter = Tools._EndPerformanceCounterDisabled;
    AsyncLoop = class _AsyncLoop {
      /**
       * Constructor.
       * @param iterations the number of iterations.
       * @param func the function to run each iteration
       * @param successCallback the callback that will be called upon successful execution
       * @param offset starting offset.
       */
      constructor(iterations, func, successCallback, offset = 0) {
        this.iterations = iterations;
        this.index = offset - 1;
        this._done = false;
        this._fn = func;
        this._successCallback = successCallback;
      }
      /**
       * Execute the next iteration. Must be called after the last iteration was finished.
       */
      executeNext() {
        if (!this._done) {
          if (this.index + 1 < this.iterations) {
            ++this.index;
            this._fn(this);
          } else {
            this.breakLoop();
          }
        }
      }
      /**
       * Break the loop and run the success callback.
       */
      breakLoop() {
        this._done = true;
        this._successCallback();
      }
      /**
       * Create and run an async loop.
       * @param iterations the number of iterations.
       * @param fn the function to run each iteration
       * @param successCallback the callback that will be called upon successful execution
       * @param offset starting offset.
       * @returns the created async loop object
       */
      static Run(iterations, fn, successCallback, offset = 0) {
        const loop = new _AsyncLoop(iterations, fn, successCallback, offset);
        loop.executeNext();
        return loop;
      }
      /**
       * A for-loop that will run a given number of iterations synchronous and the rest async.
       * @param iterations total number of iterations
       * @param syncedIterations number of synchronous iterations in each async iteration.
       * @param fn the function to call each iteration.
       * @param callback a success call back that will be called when iterating stops.
       * @param breakFunction a break condition (optional)
       * @param timeout timeout settings for the setTimeout function. default - 0.
       * @returns the created async loop object
       */
      static SyncAsyncForLoop(iterations, syncedIterations, fn, callback, breakFunction, timeout = 0) {
        return _AsyncLoop.Run(Math.ceil(iterations / syncedIterations), (loop) => {
          if (breakFunction && breakFunction()) {
            loop.breakLoop();
          } else {
            setTimeout(() => {
              for (let i = 0; i < syncedIterations; ++i) {
                const iteration = loop.index * syncedIterations + i;
                if (iteration >= iterations) {
                  break;
                }
                fn(iteration);
                if (breakFunction && breakFunction()) {
                  loop.breakLoop();
                  break;
                }
              }
              loop.executeNext();
            }, timeout);
          }
        }, callback);
      }
    };
    Tools.Mix = Mix;
    Tools.IsExponentOfTwo = IsExponentOfTwo;
    EngineStore.FallbackTexture = "data:image/jpg;base64,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";
  }
});

export {
  TextureSampler,
  init_textureSampler,
  InternalTextureSource,
  InternalTexture,
  init_internalTexture,
  WebGLPipelineContext,
  init_webGLPipelineContext,
  _WarnImport,
  init_devTools,
  IsWindowObjectExist,
  IsNavigatorAvailable,
  IsDocumentAvailable,
  GetDOMTextContent,
  DomManagement,
  init_domManagement,
  _ConcatenateShader,
  _getGlobalDefines,
  init_abstractEngine_functions,
  getStateObject,
  deleteStateObject,
  createRawShaderProgram,
  createShaderProgram,
  createPipelineContext,
  _createShaderProgram,
  _finalizePipelineContext,
  _preparePipelineContext,
  _setProgram,
  _executeWhenRenderingStateIsCompiled,
  init_thinEngine_functions,
  IsExponentOfTwo,
  Mix,
  NearestPOT,
  FloorPOT,
  GetExponentOfTwo,
  init_tools_functions,
  Initialize,
  Process,
  PreProcess,
  Finalize,
  _ProcessIncludes,
  init_shaderProcessor,
  resetCachedPipeline,
  init_effect_functions,
  Effect,
  init_effect,
  PrecisionDate,
  init_precisionDate,
  DepthCullingState,
  init_depthCullingState,
  StencilStateComposer,
  init_stencilStateComposer,
  StencilState,
  init_stencilState,
  AlphaState,
  init_alphaCullingState,
  RandomGUID,
  GUID,
  init_guid,
  WebRequest,
  init_webRequest,
  FilesInputStore,
  init_filesInputStore,
  RetryStrategy,
  init_retryStrategy,
  BaseError,
  ErrorCodes,
  RuntimeError,
  init_error,
  EndsWith,
  StartsWith,
  Decode,
  EncodeArrayBufferToBase64,
  DecodeBase64ToString,
  DecodeBase64ToBinary,
  PadNumber,
  StringTools,
  init_stringTools,
  TimingTools,
  init_timingTools,
  LoadFileError,
  RequestFileError,
  ReadFileError,
  FileToolsOptions,
  SetCorsBehavior,
  LoadImageConfiguration,
  LoadImage,
  ReadFile,
  LoadFile,
  RequestFile,
  IsFileURL,
  IsBase64DataUrl,
  TestBase64DataUrl,
  DecodeBase64UrlToBinary,
  DecodeBase64UrlToString,
  FileTools,
  _injectLTSFileTools,
  init_fileTools,
  InstantiationTools,
  init_instantiationTools,
  DeepCopier,
  init_deepCopier,
  Tools,
  className,
  AsyncLoop,
  init_tools,
  registerTextureLoader,
  unregisterTextureLoader,
  _GetCompatibleTextureLoader,
  init_textureLoaderManager,
  QueueNewFrame,
  AbstractEngine,
  init_abstractEngine
};
